// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

export type Activation = {
    uid: string;
    token: string;
};

export type ActivationRequest = {
    uid: string;
    token: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ActivityUuidRequest = {
    activity_id: string;
};

export type AnonymizeMeeting = {
    message: string;
};

export type ApplyTypicalDay = {
    days: Array<Date>;
    erase?: boolean;
};

export type ApplyTypicalDayRequest = {
    days: Array<Date>;
    erase?: boolean;
};

/**
 * * `0` - Non-défini
 * * `270` - Farfadets
 * * `210` - Louveteaux-Jeannettes
 * * `220` - Scouts-Guides
 * * `230` - Pionniers-Caravelles
 * * `240` - Compagnons
 * * `290` - Audace
 * * `180` - Impeesa
 * * `310` - Équipe de Groupe
 * * `300` - Responsable de Groupe
 * * `600` - Équipe Territoriale
 * * `505` - Responsable Territorial
 * * `500` - Délégué Territorial
 * * `900` - Équipe Nationale
 * * `980` - Salarié
 * * `1000` - Autre branche
 */
export const BrancheEnum = {
    0: '0',
    270: '270',
    210: '210',
    220: '220',
    230: '230',
    240: '240',
    290: '290',
    180: '180',
    310: '310',
    300: '300',
    600: '600',
    505: '505',
    500: '500',
    900: '900',
    980: '980',
    1000: '1000'
} as const;

/**
 * * `0` - Non-défini
 * * `270` - Farfadets
 * * `210` - Louveteaux-Jeannettes
 * * `220` - Scouts-Guides
 * * `230` - Pionniers-Caravelles
 * * `240` - Compagnons
 * * `290` - Audace
 * * `180` - Impeesa
 * * `310` - Équipe de Groupe
 * * `300` - Responsable de Groupe
 * * `600` - Équipe Territoriale
 * * `505` - Responsable Territorial
 * * `500` - Délégué Territorial
 * * `900` - Équipe Nationale
 * * `980` - Salarié
 * * `1000` - Autre branche
 */
export type BrancheEnum = typeof BrancheEnum[keyof typeof BrancheEnum];

/**
 * This Serializer allow us to get access to the current user
 */
export type CreateNotNestedResource = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type CreateNotNestedResourceRequest = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type CreatePublicNotNestedResource = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type CreatePublicNotNestedResourceRequest = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DailyTask = {
    readonly id: string;
    description?: string;
    /**
     * Nom du service
     */
    label: string;
    readonly meeting: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DailyTaskRequest = {
    description?: string;
    /**
     * Nom du service
     */
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DailyTaskTeam = {
    readonly id: string;
    label: string;
    color?: string;
    /**
     * The meeting associated to the team
     */
    readonly meeting: string;
    participants: Array<NotNestedPublicMeetingParticipantWithAvatar>;
};

export type DigiformSendEmailReset = {
    email: string;
};

export type DigiformSendEmailResetRequest = {
    email: string;
};

/**
 * * `619` - AFPS
 * * `73` - BAFA
 * * `140` - BAFD
 * * `618` - BP JEPS
 * * `615` - Diplome Marin
 * * `1000` - Équivalence BAFD
 * * `632` - DE Educateur Spécialisé
 * * `626` - DE JEPS
 * * `603` - PSC1 Prevention et Secours Civiques de niveau 1
 * * `608` - Surveillant de Baignade
 * * `1001` - Autre Diplome ou Brevet
 */
export const DiplomaTypeEnum = {
    619: '619',
    73: '73',
    140: '140',
    618: '618',
    615: '615',
    1000: '1000',
    632: '632',
    626: '626',
    603: '603',
    608: '608',
    1001: '1001'
} as const;

/**
 * * `619` - AFPS
 * * `73` - BAFA
 * * `140` - BAFD
 * * `618` - BP JEPS
 * * `615` - Diplome Marin
 * * `1000` - Équivalence BAFD
 * * `632` - DE Educateur Spécialisé
 * * `626` - DE JEPS
 * * `603` - PSC1 Prevention et Secours Civiques de niveau 1
 * * `608` - Surveillant de Baignade
 * * `1001` - Autre Diplome ou Brevet
 */
export type DiplomaTypeEnum = typeof DiplomaTypeEnum[keyof typeof DiplomaTypeEnum];

export type Djoser = {
    /**
     * url to keycloak
     */
    autorization_url: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DocTemplate = {
    id?: string;
    label: string;
    description?: string | null;
    parent_template?: string | null;
    readonly involved_roles: Array<NotNestedMeetingRole>;
    category?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DocTemplateRequest = {
    id?: string;
    label: string;
    description?: string | null;
    parent_template?: string | null;
    category?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DuplicationMeetingForm = {
    title?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DuplicationMeetingFormRequest = {
    title?: string;
};

/**
 * * `none` - none
 * * `self_enrollment` - self_enrollment
 * * `managed_enrollment` - managed_enrollment
 */
export const EnrollmentModalityEnum = {
    NONE: 'none',
    SELF_ENROLLMENT: 'self_enrollment',
    MANAGED_ENROLLMENT: 'managed_enrollment'
} as const;

/**
 * * `none` - none
 * * `self_enrollment` - self_enrollment
 * * `managed_enrollment` - managed_enrollment
 */
export type EnrollmentModalityEnum = typeof EnrollmentModalityEnum[keyof typeof EnrollmentModalityEnum];

/**
 * * `ENROLLED` - enrolled
 * * `CANCELLED` - cancelled
 * * `WAITING_LIST` - waiting_list
 */
export const EnrollmentStatusEnum = {
    ENROLLED: 'ENROLLED',
    CANCELLED: 'CANCELLED',
    WAITING_LIST: 'WAITING_LIST'
} as const;

/**
 * * `ENROLLED` - enrolled
 * * `CANCELLED` - cancelled
 * * `WAITING_LIST` - waiting_list
 */
export type EnrollmentStatusEnum = typeof EnrollmentStatusEnum[keyof typeof EnrollmentStatusEnum];

/**
 * This Serializer allow us to get access to the current user
 */
export type Event = {
    readonly id: string;
    activity: PublicActivity;
    start_date: Date;
    end_date: Date;
    /**
     * Must not be null, a Track must be linked to a meeting
     */
    readonly meeting_id: string;
    room: NotNestedPublicRoom | null;
    team_in_charge: NotNestedTeam | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    readonly modular_parent: string | null;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    readonly supervisors: Array<NotNestedPublicMeetingParticipant>;
    visibility?: EventVisibilityEnum;
    readonly enrolled_participants: Array<NotNestedPublicMeetingParticipant>;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * * `MANY` - many
 * * `ONE` - one
 */
export const EventRelationTypeEnum = { MANY: 'MANY', ONE: 'ONE' } as const;

/**
 * * `MANY` - many
 * * `ONE` - one
 */
export type EventRelationTypeEnum = typeof EventRelationTypeEnum[keyof typeof EventRelationTypeEnum];

/**
 * * `JOURNEE_TYPE` - abstract
 * * `CONCRET` - concret
 * * `MODULAIRE` - modulaire
 */
export const EventTypeEnum = {
    JOURNEE_TYPE: 'JOURNEE_TYPE',
    CONCRET: 'CONCRET',
    MODULAIRE: 'MODULAIRE'
} as const;

/**
 * * `JOURNEE_TYPE` - abstract
 * * `CONCRET` - concret
 * * `MODULAIRE` - modulaire
 */
export type EventTypeEnum = typeof EventTypeEnum[keyof typeof EventTypeEnum];

/**
 * * `ALL` - all
 * * `TEAM` - team
 * * `SUPERVISORS` - supervisors
 */
export const EventVisibilityEnum = {
    ALL: 'ALL',
    TEAM: 'TEAM',
    SUPERVISORS: 'SUPERVISORS'
} as const;

/**
 * * `ALL` - all
 * * `TEAM` - team
 * * `SUPERVISORS` - supervisors
 */
export type EventVisibilityEnum = typeof EventVisibilityEnum[keyof typeof EventVisibilityEnum];

/**
 * This Serializer allow us to get access to the current user
 */
export type EventWithActivity = {
    readonly id: string;
    activity: PublicActivity;
    start_date: Date;
    end_date: Date;
    /**
     * Must not be null, a Track must be linked to a meeting
     */
    readonly meeting_id: string;
    room: NotNestedPublicRoom | null;
    team_in_charge: NotNestedTeam | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    readonly modular_parent: string | null;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    readonly supervisors: Array<NotNestedPublicMeetingParticipant>;
    visibility?: EventVisibilityEnum;
    readonly enrolled_participants: Array<NotNestedPublicMeetingParticipant>;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    readonly review_form_id: string | null;
    readonly review_form_meeting_id: string | null;
    readonly review_form_is_published: boolean;
};

/**
 * * `1` - man
 * * `2` - woman
 * * `3` - other
 */
export const GenderEnum = {
    1: '1',
    2: '2',
    3: '3'
} as const;

/**
 * * `1` - man
 * * `2` - woman
 * * `3` - other
 */
export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];

/**
 * * `m` - Masculin
 * * `f` - Féminin
 * * `n` - Les deux formes
 */
export const GrammaticalFormEnum = {
    M: 'm',
    F: 'f',
    N: 'n'
} as const;

/**
 * * `m` - Masculin
 * * `f` - Féminin
 * * `n` - Les deux formes
 */
export type GrammaticalFormEnum = typeof GrammaticalFormEnum[keyof typeof GrammaticalFormEnum];

/**
 * * `0` - Stagiaire
 * * `1` - Formateur
 * * `2` - Directeur
 * * `3` - Accompagnant
 * * `4` - Intervenant
 */
export const IntranetIdEnum = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4
} as const;

/**
 * * `0` - Stagiaire
 * * `1` - Formateur
 * * `2` - Directeur
 * * `3` - Accompagnant
 * * `4` - Intervenant
 */
export type IntranetIdEnum = typeof IntranetIdEnum[keyof typeof IntranetIdEnum];

/**
 * This Serializer allow us to get access to the current user
 */
export type Media = {
    readonly created_date: Date;
    readonly meeting: string | null;
    readonly updated_date: Date;
    readonly is_available: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type Meeting = {
    readonly id: string;
    readonly label: string;
    readonly created_at: Date;
    readonly end_date: Date;
    meeting_type: MeetingType;
    readonly meeting_type_id: string | null;
    place: NotNestedPlace;
    readonly place_id: string | null;
    readonly start_date: Date;
    structure_organisatrice: StructureType;
    readonly structure_organisatrice_id: string | null;
    readonly updated_at: Date;
    modules: Array<MeetingModule>;
    readonly daytime_min: string;
    readonly daytime_max: string;
    readonly ndays: number;
    source: SourceEnum;
    code_analytic?: string;
    readonly intranet_id: string;
    readonly supervisors: Array<NotNestedPublicMeetingParticipant>;
    num_agreement_js?: string;
    /**
     * Description du stage
     */
    description?: string;
    status: StatusEnum;
    readonly tracks: Array<Track>;
    tagada_password?: string | null;
    tagada_status: TagadaStatusEnum;
    readonly tagada_participants_last_sync: Date | null;
    readonly tagada_avis_last_sync: Date | null;
    readonly tagada_total_candidates: number;
    readonly tagada_synced_candidates: number;
    opinion_status?: OpinionStatusEnum;
    readonly has_opinions: boolean;
    readonly intranet_last_sync: Date;
    /**
     * Si activé, une photo est demandée lors de l'émargement
     */
    checkin_photo_enabled?: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingComment = {
    readonly id: string;
    event?: string | null;
    readonly participant_id: string;
    text?: string | null;
    type?: TypeEnum;
    readonly created_at: Date;
    /**
     * Date must be filled for a comment
     */
    date: Date;
    /**
     * Author of the comment when done with Digiform
     */
    author: NotNestedPublicMeetingParticipant;
    readonly author_id: string | null;
    /**
     * List of nested tags associated
     */
    readonly tags: Array<MeetingCommentTag>;
    /**
     * List of ids of the tags associated
     */
    tags_id?: Array<string>;
    /**
     * Assign the comment as a special comment. allowed_values : (start_interview, middle_interview, end_interview, sgdf_opinion, js_opinion)
     */
    assign_as?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingCommentRequest = {
    event?: string | null;
    text?: string | null;
    type?: TypeEnum;
    /**
     * Date must be filled for a comment
     */
    date: Date;
    /**
     * List of ids of the tags associated
     */
    tags_id?: Array<string>;
    /**
     * Assign the comment as a special comment. allowed_values : (start_interview, middle_interview, end_interview, sgdf_opinion, js_opinion)
     */
    assign_as?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingCommentTag = {
    readonly id: string;
    /**
     * a CommentTag is custom to a particular meeting
     */
    readonly meeting_id: string | null;
    color?: string;
    label: string;
    favorite?: boolean;
    icon?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingCommentTagRequest = {
    color?: string;
    label: string;
    favorite?: boolean;
    icon?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingForm = {
    readonly id: string;
    title: string;
    readonly form_fields: Array<MeetingFormField>;
    response_type: ResponseTypeEnum;
    readonly created_at: Date;
    readonly updated_at: Date;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    readonly submissions_count: number;
    author?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingFormField = {
    readonly id: string;
    title: string;
    name: string;
    type: string;
    choices?: string;
    help_info?: string;
    default_value?: string;
    is_required?: boolean;
    order: number;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingFormFieldRequest = {
    title: string;
    name: string;
    type: string;
    choices?: string;
    help_info?: string;
    default_value?: string;
    is_required?: boolean;
    order: number;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingFormSubmission = {
    readonly id: string;
    readonly submitted_at: Date;
    submission_data: unknown;
    readonly url: string;
    participant: NotNestedPublicMeetingParticipantWithAvatar;
    team?: NotNestedDailyTaskTeam | null;
};

/**
 * Serializer for exporting form submissions to CSV/Excel.
 * Flattens submission data into columns.
 * Supports optional fields via context: include_email, include_branche
 */
export type MeetingFormSubmissionExport = {
    /**
     * Numéro adhérent
     */
    readonly num_adherent: string | null;
    /**
     * Prénom
     */
    readonly participant_first_name: string | null;
    /**
     * Nom
     */
    readonly participant_last_name: string | null;
    /**
     * Email
     */
    readonly participant_email: string | null;
    readonly branche: string | null;
    /**
     * Équipe
     */
    readonly team_name: string | null;
    /**
     * Date de soumission
     */
    readonly submitted_at: Date;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingFormSubmissionRequest = {
    submission_data: unknown;
    participant: NotNestedPublicMeetingParticipantWithAvatarRequest;
    team?: NotNestedDailyTaskTeamRequest | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingGestionnaire = {
    readonly id: string;
    readonly label: string;
    readonly created_at: Date;
    readonly end_date: Date;
    meeting_type: MeetingType;
    readonly meeting_type_id: string | null;
    place: NotNestedPlace;
    readonly place_id: string | null;
    readonly start_date: Date;
    structure_organisatrice: StructureType;
    readonly structure_organisatrice_id: string | null;
    readonly updated_at: Date;
    modules: Array<MeetingModule>;
    daytime_min?: string;
    daytime_max?: string;
    readonly ndays: number;
    source: SourceEnum;
    code_analytic?: string;
    readonly intranet_id: string;
    readonly supervisors: Array<NotNestedPublicMeetingParticipant>;
    num_agreement_js?: string;
    /**
     * Description du stage
     */
    description?: string;
    status: StatusEnum;
    readonly tracks: Array<Track>;
    tagada_password?: string | null;
    tagada_status: TagadaStatusEnum;
    readonly tagada_participants_last_sync: Date | null;
    readonly tagada_avis_last_sync: Date | null;
    readonly tagada_total_candidates: number;
    readonly tagada_synced_candidates: number;
    opinion_status?: OpinionStatusEnum;
    readonly has_opinions: boolean;
    readonly intranet_last_sync: Date;
    /**
     * Si activé, une photo est demandée lors de l'émargement
     */
    checkin_photo_enabled?: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingGestionnaireRequest = {
    daytime_min?: string;
    daytime_max?: string;
    code_analytic?: string;
    num_agreement_js?: string;
    /**
     * Description du stage
     */
    description?: string;
    tagada_password?: string | null;
    opinion_status?: OpinionStatusEnum;
    /**
     * Si activé, une photo est demandée lors de l'émargement
     */
    checkin_photo_enabled?: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingModule = {
    readonly id: string;
    readonly codename: string;
    readonly label: string | null;
    /**
     * Si activé, le module n'est proposé qu'aux administrateurs (superusers) dans la configuration du stage.
     */
    readonly hidden: boolean;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type MeetingParticipant = {
    readonly id: string;
    readonly user_id: string;
    first_name: string;
    last_name: string;
    usage_first_name: string;
    usage_last_name: string;
    readonly created: Date;
    readonly updated: Date;
    readonly meeting: string;
    user: NotNestedUser;
    role: NotNestedMeetingRole;
    daily_task_team: NotNestedDailyTaskTeam;
    readonly teams: Array<NotNestedTeam>;
    readonly fonction: string;
    structure_principale: ReadonlyStructure | null;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     *
     * * `0` - Non-défini
     * * `270` - Farfadets
     * * `210` - Louveteaux-Jeannettes
     * * `220` - Scouts-Guides
     * * `230` - Pionniers-Caravelles
     * * `240` - Compagnons
     * * `290` - Audace
     * * `180` - Impeesa
     * * `310` - Équipe de Groupe
     * * `300` - Responsable de Groupe
     * * `600` - Équipe Territoriale
     * * `505` - Responsable Territorial
     * * `500` - Délégué Territorial
     * * `900` - Équipe Nationale
     * * `980` - Salarié
     * * `1000` - Autre branche
     */
    branche?: BrancheEnum;
    track: Track;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    food_regime?: string;
    session_status?: SessionStatusEnum;
    complement_information?: string;
    readonly canceled: boolean;
    hidden?: boolean;
    readonly observation_count: number;
    birthdate?: Date | null;
    hebergement?: string;
    track_id: string | null;
    is_bafa_bafd_candidate?: boolean;
    tagada_candidate_status?: TagadaCandidateStatusEnum;
    tagada_avis_status?: TagadaAvisStatusEnum;
    tagada_avis_last_sync?: Date | null;
    readonly tagada_sync_object: string;
    age_at_meeting_start?: number;
    readonly intranet_last_sync: Date;
    /**
     * Compte rendu de début de stage
     */
    start_interview?: string | null;
    /**
     * Compte rendu d'entretien de mi-stage
     */
    middle_interview?: string | null;
    /**
     * Compte rendu d'entretien de fin de stage
     */
    end_interview?: string | null;
    /**
     * Avis interne SGdF de fin de stage
     */
    sgdf_opinion?: string | null;
    /**
     * Avis JS de fin de stage
     */
    js_opinion?: string | null;
    readonly avis_prevalidation: string | null;
    readonly avis_validation: string | null;
    readonly avis_validation_gestionnaire: string | null;
    readonly signature_url: string;
    readonly signature_available: boolean;
    readonly avatar_url: string;
    readonly avatar_available: boolean;
    readonly user_avatar_url: string;
    readonly user_avatar_available: boolean;
    user_last_sync: Date | null;
    rg_user: NotNestedUser | null;
    dt_user: NotNestedUser | null;
    gender: string;
    grammatical_form: string;
    birth_name: string;
    which_administrative_lastname: string;
    which_administrative_firstname: string;
    phone: string;
    email: string;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type MeetingParticipantRequest = {
    first_name: string;
    last_name: string;
    usage_first_name: string;
    usage_last_name: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     *
     * * `0` - Non-défini
     * * `270` - Farfadets
     * * `210` - Louveteaux-Jeannettes
     * * `220` - Scouts-Guides
     * * `230` - Pionniers-Caravelles
     * * `240` - Compagnons
     * * `290` - Audace
     * * `180` - Impeesa
     * * `310` - Équipe de Groupe
     * * `300` - Responsable de Groupe
     * * `600` - Équipe Territoriale
     * * `505` - Responsable Territorial
     * * `500` - Délégué Territorial
     * * `900` - Équipe Nationale
     * * `980` - Salarié
     * * `1000` - Autre branche
     */
    branche?: BrancheEnum;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    food_regime?: string;
    session_status?: SessionStatusEnum;
    complement_information?: string;
    hidden?: boolean;
    birthdate?: Date | null;
    hebergement?: string;
    track_id: string | null;
    is_bafa_bafd_candidate?: boolean;
    tagada_candidate_status?: TagadaCandidateStatusEnum;
    tagada_avis_status?: TagadaAvisStatusEnum;
    tagada_avis_last_sync?: Date | null;
    age_at_meeting_start?: number;
    /**
     * Compte rendu de début de stage
     */
    start_interview?: string | null;
    /**
     * Compte rendu d'entretien de mi-stage
     */
    middle_interview?: string | null;
    /**
     * Compte rendu d'entretien de fin de stage
     */
    end_interview?: string | null;
    /**
     * Avis interne SGdF de fin de stage
     */
    sgdf_opinion?: string | null;
    /**
     * Avis JS de fin de stage
     */
    js_opinion?: string | null;
    user_last_sync: Date | null;
    rg_user: NotNestedUserRequest | null;
    dt_user: NotNestedUserRequest | null;
    gender: string;
    grammatical_form: string;
    birth_name: string;
    which_administrative_lastname: string;
    which_administrative_firstname: string;
    phone: string;
    email: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingPublic = {
    readonly id: string;
    readonly label: string;
    readonly created_at: Date;
    readonly end_date: Date;
    meeting_type: MeetingType;
    readonly meeting_type_id: string | null;
    place: NotNestedPlace;
    readonly place_id: string | null;
    readonly start_date: Date;
    structure_organisatrice: StructureType;
    readonly structure_organisatrice_id: string | null;
    readonly updated_at: Date;
    modules: Array<MeetingModule>;
    readonly daytime_min: string;
    readonly daytime_max: string;
    readonly ndays: number;
    source: SourceEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingPublicForm = {
    readonly id: string;
    readonly is_answered: boolean;
    readonly is_open: boolean;
    title: string;
    response_type: ResponseTypeEnum;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    author?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingPublicFormWithFields = {
    readonly id: string;
    title: string;
    readonly form_fields: Array<MeetingFormField>;
    response_type: ResponseTypeEnum;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    readonly form_responses: Array<MeetingFormSubmission>;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    author?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingRequest = {
    code_analytic?: string;
    num_agreement_js?: string;
    /**
     * Description du stage
     */
    description?: string;
    tagada_password?: string | null;
    opinion_status?: OpinionStatusEnum;
    /**
     * Si activé, une photo est demandée lors de l'émargement
     */
    checkin_photo_enabled?: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingType = {
    readonly id: string;
    readonly label: string;
    /**
     * The modules which are associated by default on the MeetingType
     */
    readonly modules_default: Array<string>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ModularEvent = {
    readonly id: string;
    readonly label: string;
    start_date: Date;
    end_date: Date;
    /**
     * Must not be null, a Track must be linked to a meeting
     */
    readonly meeting_id: string;
    event_type?: EventTypeEnum;
    readonly modular_children: Array<EventWithActivity>;
};

export type ModuleNotFoundError = {
    status: string;
    message: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NestedByStructureParticipant = {
    readonly id: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    readonly user_id: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly username: string;
    readonly meeting_id: string;
    readonly meeting_label: string;
    readonly meeting_type_id: string;
    readonly meeting_type_label: string;
    readonly structure_principale_id: string;
    readonly structure_principale_label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NestedMeetingCommentDetail = {
    text?: string | null;
    readonly updated_at: Date;
    readonly author_name: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NestedMeetingCommentDetailRequest = {
    text?: string | null;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type NoCommentMeetingParticipant = {
    readonly id: string;
    readonly user_id: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly usage_first_name: string;
    readonly usage_last_name: string;
    readonly created: Date;
    readonly updated: Date;
    readonly meeting: string;
    user: NotNestedUser;
    role: NotNestedMeetingRole;
    daily_task_team: NotNestedDailyTaskTeam;
    readonly teams: Array<NotNestedTeam>;
    readonly fonction: string;
    structure_principale: ReadonlyStructure | null;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     *
     * * `0` - Non-défini
     * * `270` - Farfadets
     * * `210` - Louveteaux-Jeannettes
     * * `220` - Scouts-Guides
     * * `230` - Pionniers-Caravelles
     * * `240` - Compagnons
     * * `290` - Audace
     * * `180` - Impeesa
     * * `310` - Équipe de Groupe
     * * `300` - Responsable de Groupe
     * * `600` - Équipe Territoriale
     * * `505` - Responsable Territorial
     * * `500` - Délégué Territorial
     * * `900` - Équipe Nationale
     * * `980` - Salarié
     * * `1000` - Autre branche
     */
    branche?: BrancheEnum;
    track: Track;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    food_regime?: string;
    session_status?: SessionStatusEnum;
    complement_information?: string;
    readonly canceled: boolean;
    hidden?: boolean;
    readonly observation_count: number;
    readonly birthdate: Date | null;
    hebergement?: string;
    track_id: string | null;
    is_bafa_bafd_candidate?: boolean;
    tagada_candidate_status: TagadaCandidateStatusEnum;
    tagada_avis_status: TagadaAvisStatusEnum;
    readonly tagada_avis_last_sync: Date | null;
    readonly tagada_sync_object: string;
    readonly age_at_meeting_start: number;
    readonly intranet_last_sync: Date;
    readonly signature_url: string;
    readonly signature_available: boolean;
    readonly avatar_url: string;
    readonly avatar_available: boolean;
    readonly user_avatar_url: string;
    readonly user_avatar_available: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedDailyTaskTeam = {
    readonly id: string;
    label: string;
    color?: string;
    /**
     * The meeting associated to the team
     */
    readonly meeting: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedDailyTaskTeamRequest = {
    label: string;
    color?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedDiploma = {
    readonly id: number;
    readonly diploma_url: string;
    /**
     * Type de diplôme
     *
     * * `619` - AFPS
     * * `73` - BAFA
     * * `140` - BAFD
     * * `618` - BP JEPS
     * * `615` - Diplome Marin
     * * `1000` - Équivalence BAFD
     * * `632` - DE Educateur Spécialisé
     * * `626` - DE JEPS
     * * `603` - PSC1 Prevention et Secours Civiques de niveau 1
     * * `608` - Surveillant de Baignade
     * * `1001` - Autre Diplome ou Brevet
     */
    diploma_type: DiplomaTypeEnum;
    /**
     * Date d'obtention du diplome
     */
    issue_date: Date;
    readonly diploma_available: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedDiplomaRequest = {
    /**
     * Type de diplôme
     *
     * * `619` - AFPS
     * * `73` - BAFA
     * * `140` - BAFD
     * * `618` - BP JEPS
     * * `615` - Diplome Marin
     * * `1000` - Équivalence BAFD
     * * `632` - DE Educateur Spécialisé
     * * `626` - DE JEPS
     * * `603` - PSC1 Prevention et Secours Civiques de niveau 1
     * * `608` - Surveillant de Baignade
     * * `1001` - Autre Diplome ou Brevet
     */
    diploma_type: DiplomaTypeEnum;
    /**
     * Date d'obtention du diplome
     */
    issue_date: Date;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedEvent = {
    readonly id: string;
    activity: string;
    start_date: Date;
    end_date: Date;
    /**
     * Must not be null, a Track must be linked to a meeting
     */
    readonly meeting_id: string;
    /**
     * Room where is located the event ; can be empty if no room has been defined yet during the meeting
     */
    room?: string | null;
    /**
     * Participant team in charge of this event, can be empty if no team in charge
     */
    team_in_charge?: string | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    readonly modular_parent: string | null;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    /**
     * Supervisors in charge to prepare the Event, can be empty if no supervisor defined (all supervisors or no-one)
     */
    supervisors?: Array<string>;
    visibility?: EventVisibilityEnum;
    readonly enrolled_participants: Array<NotNestedPublicMeetingParticipant>;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedEventRequest = {
    activity: string;
    start_date: Date;
    end_date: Date;
    /**
     * Room where is located the event ; can be empty if no room has been defined yet during the meeting
     */
    room?: string | null;
    /**
     * Participant team in charge of this event, can be empty if no team in charge
     */
    team_in_charge?: string | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    /**
     * Supervisors in charge to prepare the Event, can be empty if no supervisor defined (all supervisors or no-one)
     */
    supervisors?: Array<string>;
    visibility?: EventVisibilityEnum;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedEventWithNestedActivity = {
    readonly id: string;
    activity: NotNestedPublicActivity;
    start_date: Date;
    end_date: Date;
    /**
     * Must not be null, a Track must be linked to a meeting
     */
    readonly meeting_id: string;
    /**
     * Room where is located the event ; can be empty if no room has been defined yet during the meeting
     */
    room?: string | null;
    /**
     * Participant team in charge of this event, can be empty if no team in charge
     */
    team_in_charge?: string | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    readonly modular_parent: string | null;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    /**
     * Supervisors in charge to prepare the Event, can be empty if no supervisor defined (all supervisors or no-one)
     */
    supervisors?: Array<string>;
    visibility?: EventVisibilityEnum;
    readonly enrolled_participants: Array<NotNestedPublicMeetingParticipant>;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedEventWithNestedActivityRequest = {
    activity: NotNestedPublicActivityRequest;
    start_date: Date;
    end_date: Date;
    /**
     * Room where is located the event ; can be empty if no room has been defined yet during the meeting
     */
    room?: string | null;
    /**
     * Participant team in charge of this event, can be empty if no team in charge
     */
    team_in_charge?: string | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    /**
     * Supervisors in charge to prepare the Event, can be empty if no supervisor defined (all supervisors or no-one)
     */
    supervisors?: Array<string>;
    visibility?: EventVisibilityEnum;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedMeetingForm = {
    readonly id: string;
    readonly form_fields: Array<string>;
    response_type: ResponseTypeEnum;
    readonly created_at: Date;
    readonly updated_at: Date;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    author?: string | null;
    title: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedMeetingFormRequest = {
    response_type: ResponseTypeEnum;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    author?: string | null;
    title: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedMeetingFormSubmission = {
    readonly id: string;
    readonly submitted_at: Date;
    submission_data: unknown;
    readonly url: string;
    participant?: string | null;
    team?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedMeetingFormSubmissionRequest = {
    submission_data: unknown;
    participant?: string | null;
    team?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedMeetingRole = {
    readonly id: string;
    intranet_id: IntranetIdEnum;
    readonly role: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPlace = {
    readonly id: string;
    readonly label: string;
    readonly address: string;
    readonly zipcode: string;
    readonly city: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicActivity = {
    readonly id: string;
    /**
     * Must not be null, an Activity must be linked to a meeting
     */
    readonly meeting_id: string;
    /**
     * Event Category, must be filled to create an event
     */
    category?: string | null;
    /**
     * Une Activity peut être associé à zéro, un ou plusieurs Track (parcours)
     */
    tracks?: Array<string>;
    label: string;
    description?: string | null;
    /**
     * Nombre maximum de participants autorisés lors de cette Activity
     */
    max_participants?: number;
    event_relation_type?: EventRelationTypeEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicActivityCategory = {
    readonly id: string;
    color?: string;
    text_color?: string | null;
    label: string;
    /**
     * When a meeting is set, the category is custom to a particular meeting
     */
    readonly meeting: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicActivityCategoryRequest = {
    color?: string;
    text_color?: string | null;
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicActivityRequest = {
    /**
     * Event Category, must be filled to create an event
     */
    category?: string | null;
    /**
     * Une Activity peut être associé à zéro, un ou plusieurs Track (parcours)
     */
    tracks?: Array<string>;
    label: string;
    description?: string | null;
    /**
     * Nombre maximum de participants autorisés lors de cette Activity
     */
    max_participants?: number;
    event_relation_type?: EventRelationTypeEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicActivityTopic = {
    readonly id: string;
    color?: string;
    text_color?: string | null;
    label: string;
    /**
     * When a meeting is set, the category is custom to a particular meeting
     */
    readonly meeting: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicActivityTopicRequest = {
    color?: string;
    text_color?: string | null;
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicEventParticipantEnrollment = {
    readonly id: string;
    readonly participant_id: string;
    readonly enroller_id: string | null;
    readonly event_id: string;
    readonly created_at: Date;
    readonly updated_at: Date;
    enrollment_status: EnrollmentStatusEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicMeetingParticipant = {
    readonly id: string;
    readonly user_id: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly usage_first_name: string;
    readonly usage_last_name: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicMeetingParticipantWithAvatar = {
    readonly id: string;
    readonly user_id: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly usage_first_name: string;
    readonly usage_last_name: string;
    readonly avatar_url: string;
    readonly avatar_available: boolean;
    readonly user_avatar_url: string;
    readonly user_avatar_available: boolean;
    teams: Array<string>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicMeetingParticipantWithAvatarRequest = {
    teams: Array<string>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicRoom = {
    readonly id: string;
    /**
     * Nombre de personnes autorisées dans la salle
     */
    capacity: number;
    description?: string;
    label: string;
    readonly meeting: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicTeamCategory = {
    readonly id: string;
    label: string;
    /**
     * The category is custom to a particular meeting
     */
    readonly meeting: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicTeamCategoryRequest = {
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedResource = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
    readonly media_url: string;
    readonly media_available: boolean;
    readonly rendered_url: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedResourceRequest = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedRoomWithEvent = {
    readonly id: string;
    /**
     * Nombre de personnes autorisées dans la salle
     */
    capacity: number;
    description?: string;
    label: string;
    readonly meeting: string;
    readonly events: Array<string>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedRoomWithEventRequest = {
    /**
     * Nombre de personnes autorisées dans la salle
     */
    capacity: number;
    description?: string;
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedTeam = {
    readonly id: string;
    label: string;
    color?: string;
    /**
     * The meeting associated to the team
     */
    readonly meeting: string;
    category_id: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedTeamRequest = {
    label: string;
    color?: string;
    category_id: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedUser = {
    readonly id: string;
    /**
     * Nom d’utilisateur
     *
     * Requis. 150 caractères maximum. Uniquement des lettres, nombres et les caractères « @ », « . », « + », « - » et « _ ».
     */
    readonly username: string;
    gender: GenderEnum;
    /**
     * Accord des intitulés (rôle, fonction) ; vide = déduit du genre
     *
     * * `m` - Masculin
     * * `f` - Féminin
     * * `n` - Les deux formes
     */
    grammatical_form: GrammaticalFormEnum;
    /**
     * Prénom
     */
    readonly first_name: string;
    /**
     * Nom
     */
    readonly last_name: string;
    readonly birth_name: string | null;
    readonly usage_first_name: string | null;
    readonly usage_last_name: string | null;
    readonly phone: string;
    readonly birthdate: Date | null;
    /**
     * Adresse électronique
     */
    readonly email: string;
    fonction: string | null;
    fonction_code: string | null;
    structure: string | null;
    readonly diplomas: Array<NotNestedDiploma>;
    readonly last_sync: Date | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedUserRequest = {
    fonction: string | null;
    fonction_code: string | null;
    structure: string | null;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type OpinionParticipant = {
    readonly id: string;
    readonly meeting_id: string;
    role: NotNestedMeetingRole;
    readonly admin_first_name: string;
    readonly admin_last_name: string;
    js_opinion?: NestedMeetingCommentDetail | null;
    sgdf_opinion?: NestedMeetingCommentDetail | null;
    session_status?: SessionStatusEnum;
    thread_summary: OpinionReviewThreadSummary | null;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type OpinionParticipantRequest = {
    js_opinion?: NestedMeetingCommentDetailRequest | null;
    sgdf_opinion?: NestedMeetingCommentDetailRequest | null;
    session_status?: SessionStatusEnum;
};

/**
 * Lightweight — embedded in opinion participant list (count + status only).
 *
 * Read-only summary returned by the DRF v1 ``opinion_list``/``opinion``
 * endpoints. The full thread CRUD lives on the ninja v2 router
 * ``core.api.routers.opinion_review``.
 */
export type OpinionReviewThreadSummary = {
    readonly id: string;
    is_resolved?: boolean;
    readonly message_count: number;
};

/**
 * Lightweight — embedded in opinion participant list (count + status only).
 *
 * Read-only summary returned by the DRF v1 ``opinion_list``/``opinion``
 * endpoints. The full thread CRUD lives on the ninja v2 router
 * ``core.api.routers.opinion_review``.
 */
export type OpinionReviewThreadSummaryRequest = {
    is_resolved?: boolean;
};

/**
 * * `not_started` - Non démarré
 * * `in_progress` - Rédaction En cours
 * * `validated_director` - Validé par la direction
 * * `validated_orga` - Validé national
 * * `submitted` - Finalisé - Soumis J&S
 * * `manually_submitted` - Finalisé - soumis manuellement
 */
export const OpinionStatusEnum = {
    NOT_STARTED: 'not_started',
    IN_PROGRESS: 'in_progress',
    VALIDATED_DIRECTOR: 'validated_director',
    VALIDATED_ORGA: 'validated_orga',
    SUBMITTED: 'submitted',
    MANUALLY_SUBMITTED: 'manually_submitted'
} as const;

/**
 * * `not_started` - Non démarré
 * * `in_progress` - Rédaction En cours
 * * `validated_director` - Validé par la direction
 * * `validated_orga` - Validé national
 * * `submitted` - Finalisé - Soumis J&S
 * * `manually_submitted` - Finalisé - soumis manuellement
 */
export type OpinionStatusEnum = typeof OpinionStatusEnum[keyof typeof OpinionStatusEnum];

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type OwnMeetingParticipant = {
    readonly id: string;
    readonly user_id: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly usage_first_name: string;
    readonly usage_last_name: string;
    readonly meeting: string;
    role: NotNestedMeetingRole;
    readonly teams: Array<NotNestedTeam>;
    daily_task_team: NotNestedDailyTaskTeam;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    readonly food_regime: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    readonly num_bafa_bafd: string;
    readonly hebergement: string;
    readonly birth_name: string;
    which_administrative_lastname: string;
    which_administrative_firstname: string;
    phone: string;
    birthdate?: Date;
    email: string;
    gender: string;
    grammatical_form: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     *
     * * `0` - Non-défini
     * * `270` - Farfadets
     * * `210` - Louveteaux-Jeannettes
     * * `220` - Scouts-Guides
     * * `230` - Pionniers-Caravelles
     * * `240` - Compagnons
     * * `290` - Audace
     * * `180` - Impeesa
     * * `310` - Équipe de Groupe
     * * `300` - Responsable de Groupe
     * * `600` - Équipe Territoriale
     * * `505` - Responsable Territorial
     * * `500` - Délégué Territorial
     * * `900` - Équipe Nationale
     * * `980` - Salarié
     * * `1000` - Autre branche
     */
    branche: BrancheEnum;
    track: Track;
    /**
     * Parcours de formation sélectionné. Is imported from intranet the 1st time but not synchronized after
     */
    readonly track_id: string | null;
    readonly avatar_url: string;
    readonly avatar_available: boolean;
    readonly user_avatar_url: string;
    readonly user_avatar_available: boolean;
    readonly signature_url: string;
    readonly signature_available: boolean;
    readonly last_sync: Date | null;
    readonly ical_token: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type OwnMeetingUpdateParticipant = {
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    food_regime?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    hebergement?: string;
    grammatical_form?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type OwnMeetingUpdateParticipantRequest = {
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    food_regime?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    hebergement?: string;
    grammatical_form?: string;
};

export type PaginatedDailyTaskList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DailyTask>;
};

export type PaginatedDailyTaskTeamList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DailyTaskTeam>;
};

export type PaginatedDocTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DocTemplate>;
};

export type PaginatedEventList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Event>;
};

export type PaginatedMeetingCommentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingComment>;
};

export type PaginatedMeetingList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Meeting>;
};

export type PaginatedMeetingModuleList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingModule>;
};

export type PaginatedMeetingParticipantList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingParticipant>;
};

export type PaginatedMeetingPublicList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingPublic>;
};

export type PaginatedMeetingTypeList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingType>;
};

export type PaginatedModularEventList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ModularEvent>;
};

export type PaginatedNoCommentMeetingParticipantList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NoCommentMeetingParticipant>;
};

export type PaginatedNotNestedMeetingRoleList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NotNestedMeetingRole>;
};

export type PaginatedNotNestedPlaceList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NotNestedPlace>;
};

export type PaginatedNotNestedPublicActivityCategoryList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NotNestedPublicActivityCategory>;
};

export type PaginatedNotNestedPublicActivityTopicList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NotNestedPublicActivityTopic>;
};

export type PaginatedNotNestedPublicEventParticipantEnrollmentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NotNestedPublicEventParticipantEnrollment>;
};

export type PaginatedNotNestedRoomWithEventList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NotNestedRoomWithEvent>;
};

export type PaginatedOpinionParticipantList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<OpinionParticipant>;
};

export type PaginatedParticipantStructureList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ParticipantStructure>;
};

export type PaginatedPublicActivityList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<PublicActivity>;
};

export type PaginatedPublicEventList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<PublicEvent>;
};

export type PaginatedPublicModularEventList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<PublicModularEvent>;
};

export type PaginatedReadonlyStructureList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ReadonlyStructure>;
};

export type PaginatedTeamDailyTaskList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TeamDailyTask>;
};

export type PaginatedTeamList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Team>;
};

export type PaginatedTrackList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Track>;
};

export type PaginatedUserList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<User>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PandasTeamDailyTaskByTask = {
    daily_task: string;
    date: Date;
    team_in_charge: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PandasTeamDailyTaskByTeam = {
    daily_task: string;
    date: Date;
    team_in_charge: string;
};

export type ParticipantEnrollementList = {
    /**
     * Type de stage
     */
    meeting_type: string;
    /**
     * Utilisateur
     */
    username: string;
    /**
     * Courriel
     */
    email: string;
    /**
     * Téléphone
     */
    phone: string;
    /**
     * Nom
     */
    lastname: string;
    /**
     * Prénom
     */
    firstname: string;
    fonction: string | null;
    /**
     * Rôle
     */
    role: string;
    /**
     * Structure
     */
    structure_principale: string | null;
    groupe: string;
    territoire: string;
    choix_parcours: string;
};

/**
 * Serializer pour ajouter ou annuler l'inscription d'un participant à un événement spécifique.
 */
export type ParticipantEnrollmentRequest = {
    participant_id: string;
};

export type ParticipantList = {
    /**
     * Type de stage
     */
    meeting_type: string;
    /**
     * Nom
     */
    lastname: string;
    /**
     * Prénom
     */
    firstname: string;
    /**
     * Date de naissance
     */
    birthdate: Date;
    fonction: string | null;
    /**
     * Structure
     */
    structure_principale: string | null;
    groupe: string;
    territoire: string;
    choix_parcours: string;
    /**
     * Numéro de dossier Candidat BAFA-BAFD
     */
    num_bafa_bafd: string;
    /**
     * Régime alimentaire
     */
    food_regime: string;
};

export type ParticipantListDirection = {
    /**
     * Type de stage
     */
    meeting_type: string;
    start_date: Date;
    end_date: Date;
    /**
     * Date de début
     */
    date_de_debut: Date;
    date_de_fin: Date;
    place: string | null;
    num_agreement_js: string;
    /**
     * Nom direction
     */
    director: string;
    /**
     * Nom
     */
    lastname: string;
    /**
     * Prénom
     */
    firstname: string;
    /**
     * Courriel
     */
    email: string;
    /**
     * Téléphone
     */
    phone: string;
    /**
     * Date de naissance
     */
    birthdate: Date;
    fonction: string | null;
    /**
     * Structure
     */
    structure_principale: string | null;
    groupe: string;
    territoire: string;
    /**
     * Parcours (Uniquement Appro)
     */
    parcours: string;
    choix_parcours: string;
    /**
     * Numéro de dossier Candidat BAFA-BAFD
     */
    num_bafa_bafd: string;
    /**
     * Régime alimentaire
     */
    food_regime: string;
    avis_prevalidation: string | null;
    avis_validation: string | null;
    avis_validation_gestionnaire: string | null;
    /**
     * Avis BAFA-BAFD
     */
    js_opinion: string | null;
    /**
     * Avis SGdF
     */
    sgdf_opinion: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ParticipantStructure = {
    readonly id: string;
    label: string;
    structure_code: string;
    structure_type: string;
    structure_echelon: string;
    participants: Array<NestedByStructureParticipant>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ParticipantsDailyTaskTeam = {
    participants: Array<string>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ParticipantsDailyTaskTeamRequest = {
    participants: Array<string>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ParticipantsTeam = {
    participants: Array<string>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ParticipantsTeamRequest = {
    participants: Array<string>;
};

export type PasswordResetConfirmRetypeRequest = {
    uid: string;
    token: string;
    new_password: string;
    re_new_password: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedDailyTaskRequest = {
    description?: string;
    /**
     * Nom du service
     */
    label?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedDailyTaskTeamRequest = {
    label?: string;
    color?: string;
    participants?: Array<NotNestedPublicMeetingParticipantWithAvatarRequest>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedDocTemplateRequest = {
    id?: string;
    label?: string;
    description?: string | null;
    parent_template?: string | null;
    category?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedMeetingCommentRequest = {
    event?: string | null;
    text?: string | null;
    type?: TypeEnum;
    /**
     * Date must be filled for a comment
     */
    date?: Date;
    /**
     * List of ids of the tags associated
     */
    tags_id?: Array<string>;
    /**
     * Assign the comment as a special comment. allowed_values : (start_interview, middle_interview, end_interview, sgdf_opinion, js_opinion)
     */
    assign_as?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedMeetingCommentTagRequest = {
    color?: string;
    label?: string;
    favorite?: boolean;
    icon?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedMeetingFormFieldRequest = {
    title?: string;
    name?: string;
    type?: string;
    choices?: string;
    help_info?: string;
    default_value?: string;
    is_required?: boolean;
    order?: number;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedMeetingFormRequest = {
    title?: string;
    response_type?: ResponseTypeEnum;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    author?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedMeetingFormSubmissionRequest = {
    submission_data?: unknown;
    participant?: NotNestedPublicMeetingParticipantWithAvatarRequest;
    team?: NotNestedDailyTaskTeamRequest | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedMeetingGestionnaireRequest = {
    daytime_min?: string;
    daytime_max?: string;
    code_analytic?: string;
    num_agreement_js?: string;
    /**
     * Description du stage
     */
    description?: string;
    tagada_password?: string | null;
    opinion_status?: OpinionStatusEnum;
    /**
     * Si activé, une photo est demandée lors de l'émargement
     */
    checkin_photo_enabled?: boolean;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type PatchedMeetingParticipantRequest = {
    first_name?: string;
    last_name?: string;
    usage_first_name?: string;
    usage_last_name?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     *
     * * `0` - Non-défini
     * * `270` - Farfadets
     * * `210` - Louveteaux-Jeannettes
     * * `220` - Scouts-Guides
     * * `230` - Pionniers-Caravelles
     * * `240` - Compagnons
     * * `290` - Audace
     * * `180` - Impeesa
     * * `310` - Équipe de Groupe
     * * `300` - Responsable de Groupe
     * * `600` - Équipe Territoriale
     * * `505` - Responsable Territorial
     * * `500` - Délégué Territorial
     * * `900` - Équipe Nationale
     * * `980` - Salarié
     * * `1000` - Autre branche
     */
    branche?: BrancheEnum;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    food_regime?: string;
    session_status?: SessionStatusEnum;
    complement_information?: string;
    hidden?: boolean;
    birthdate?: Date | null;
    hebergement?: string;
    track_id?: string | null;
    is_bafa_bafd_candidate?: boolean;
    tagada_candidate_status?: TagadaCandidateStatusEnum;
    tagada_avis_status?: TagadaAvisStatusEnum;
    tagada_avis_last_sync?: Date | null;
    age_at_meeting_start?: number;
    /**
     * Compte rendu de début de stage
     */
    start_interview?: string | null;
    /**
     * Compte rendu d'entretien de mi-stage
     */
    middle_interview?: string | null;
    /**
     * Compte rendu d'entretien de fin de stage
     */
    end_interview?: string | null;
    /**
     * Avis interne SGdF de fin de stage
     */
    sgdf_opinion?: string | null;
    /**
     * Avis JS de fin de stage
     */
    js_opinion?: string | null;
    user_last_sync?: Date | null;
    rg_user?: NotNestedUserRequest | null;
    dt_user?: NotNestedUserRequest | null;
    gender?: string;
    grammatical_form?: string;
    birth_name?: string;
    which_administrative_lastname?: string;
    which_administrative_firstname?: string;
    phone?: string;
    email?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedMeetingRequest = {
    code_analytic?: string;
    num_agreement_js?: string;
    /**
     * Description du stage
     */
    description?: string;
    tagada_password?: string | null;
    opinion_status?: OpinionStatusEnum;
    /**
     * Si activé, une photo est demandée lors de l'émargement
     */
    checkin_photo_enabled?: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedDiplomaRequest = {
    /**
     * Type de diplôme
     *
     * * `619` - AFPS
     * * `73` - BAFA
     * * `140` - BAFD
     * * `618` - BP JEPS
     * * `615` - Diplome Marin
     * * `1000` - Équivalence BAFD
     * * `632` - DE Educateur Spécialisé
     * * `626` - DE JEPS
     * * `603` - PSC1 Prevention et Secours Civiques de niveau 1
     * * `608` - Surveillant de Baignade
     * * `1001` - Autre Diplome ou Brevet
     */
    diploma_type?: DiplomaTypeEnum;
    /**
     * Date d'obtention du diplome
     */
    issue_date?: Date;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedEventRequest = {
    activity?: string;
    start_date?: Date;
    end_date?: Date;
    /**
     * Room where is located the event ; can be empty if no room has been defined yet during the meeting
     */
    room?: string | null;
    /**
     * Participant team in charge of this event, can be empty if no team in charge
     */
    team_in_charge?: string | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    /**
     * Supervisors in charge to prepare the Event, can be empty if no supervisor defined (all supervisors or no-one)
     */
    supervisors?: Array<string>;
    visibility?: EventVisibilityEnum;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedEventWithNestedActivityRequest = {
    activity?: NotNestedPublicActivityRequest;
    start_date?: Date;
    end_date?: Date;
    /**
     * Room where is located the event ; can be empty if no room has been defined yet during the meeting
     */
    room?: string | null;
    /**
     * Participant team in charge of this event, can be empty if no team in charge
     */
    team_in_charge?: string | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    /**
     * Supervisors in charge to prepare the Event, can be empty if no supervisor defined (all supervisors or no-one)
     */
    supervisors?: Array<string>;
    visibility?: EventVisibilityEnum;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedPublicActivityCategoryRequest = {
    color?: string;
    text_color?: string | null;
    label?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedPublicActivityRequest = {
    /**
     * Event Category, must be filled to create an event
     */
    category?: string | null;
    /**
     * Une Activity peut être associé à zéro, un ou plusieurs Track (parcours)
     */
    tracks?: Array<string>;
    label?: string;
    description?: string | null;
    /**
     * Nombre maximum de participants autorisés lors de cette Activity
     */
    max_participants?: number;
    event_relation_type?: EventRelationTypeEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedPublicActivityTopicRequest = {
    color?: string;
    text_color?: string | null;
    label?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedPublicTeamCategoryRequest = {
    label?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedResourceRequest = {
    id?: string;
    label?: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type?: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order?: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedRoomWithEventRequest = {
    /**
     * Nombre de personnes autorisées dans la salle
     */
    capacity?: number;
    description?: string;
    label?: string;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type PatchedOpinionParticipantRequest = {
    js_opinion?: NestedMeetingCommentDetailRequest | null;
    sgdf_opinion?: NestedMeetingCommentDetailRequest | null;
    session_status?: SessionStatusEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedOwnMeetingUpdateParticipantRequest = {
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    food_regime?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    hebergement?: string;
    grammatical_form?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedPublicNotNestedResourceRequest = {
    id?: string;
    label?: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type?: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order?: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedTeamDailyTaskRequest = {
    daily_task?: string;
    date?: Date;
    team_in_charge?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedTeamRequest = {
    label?: string;
    color?: string;
    category_id?: string | null;
    participants?: Array<NotNestedPublicMeetingParticipantWithAvatarRequest>;
    category?: NotNestedPublicTeamCategoryRequest;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedTrackRequest = {
    /**
     * Nom du Track (parcours)
     */
    label?: string;
};

export type ProviderAuth = {
    readonly access: string;
    readonly refresh: string;
    readonly user: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicActivity = {
    readonly id: string;
    /**
     * Must not be null, an Activity must be linked to a meeting
     */
    readonly meeting_id: string;
    category: NotNestedPublicActivityCategory | null;
    readonly tracks: Array<Track>;
    label: string;
    description?: string | null;
    /**
     * Nombre maximum de participants autorisés lors de cette Activity
     */
    max_participants?: number;
    event_relation_type?: EventRelationTypeEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicEvent = {
    readonly id: string;
    activity: PublicActivity;
    start_date: Date;
    end_date: Date;
    /**
     * Must not be null, a Track must be linked to a meeting
     */
    readonly meeting_id: string;
    room: NotNestedPublicRoom | null;
    team_in_charge: NotNestedTeam | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    readonly modular_parent: string | null;
    readonly review_form_id: string | null;
    readonly review_form_meeting_id: string | null;
    readonly review_form_is_published: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicModularEvent = {
    readonly id: string;
    readonly label: string;
    start_date: Date;
    end_date: Date;
    /**
     * Must not be null, a Track must be linked to a meeting
     */
    readonly meeting_id: string;
    event_type?: EventTypeEnum;
    readonly modular_children: Array<PublicEvent>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicNotNestedResource = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
    readonly media_url: string;
    readonly media_available: boolean;
    readonly rendered_url: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicNotNestedResourceRequest = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

export type PublicResourceTreeList = {
    readonly tree: Array<ResourceNode>;
    readonly list: Array<PublicNotNestedResource>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublishMeetingForm = {
    publication_date?: Date;
    opening_date?: Date;
    closing_date?: Date | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublishMeetingFormRequest = {
    publication_date?: Date;
    opening_date?: Date;
    closing_date?: Date | null;
};

export type Pv = {
    /**
     * Type de stage
     */
    meeting_type: string;
    /**
     * Nom du stage
     */
    meeting_name: string;
    /**
     * Nom du stage sans accent
     */
    meeting_name_ascii: string;
    /**
     * Role sur le stage
     */
    role: string;
    /**
     * Date de début
     */
    date_de_debut: Date;
    date_de_fin: Date;
    /**
     * Statut Adhésion
     */
    participant_adhesion_statut: string;
    /**
     * Lieu
     */
    place: string | null;
    /**
     * Numéro déclaration Stage BAFA/BAFD
     */
    num_agreement_js: string;
    /**
     * Nom direction
     */
    director: string;
    /**
     * Nom
     */
    lastname: string;
    /**
     * Prénom
     */
    firstname: string;
    /**
     * Nom sans accent
     */
    lastname_ascii: string;
    /**
     * Prénom sans accent
     */
    firstname_ascii: string;
    /**
     * Date de naissance
     */
    birthdate: Date;
    /**
     * Courriel
     */
    email: string;
    fonction: string | null;
    /**
     * Structure
     */
    structure_principale: string | null;
    groupe: string;
    territoire: string;
    /**
     * Parcours (Uniquement Appro)
     */
    parcours: string;
    choix_parcours: string;
    /**
     * Candidat BAFA-BAFD
     */
    is_bafa_bafd_candidate: boolean;
    /**
     * Numéro de dossier Candidat BAFA-BAFD
     */
    num_bafa_bafd: string;
    /**
     * Session satisfaisante
     */
    session_favorable: string;
    /**
     * Session non satisfaisante
     */
    session_defavorable: string;
    /**
     * Avis BAFA-BAFD
     */
    js_opinion: string | null;
    /**
     * Avis SGdF
     */
    sgdf_opinion: string | null;
    nom_dt: string | null;
    /**
     * Prénom DT
     */
    prenom_dt: string | null;
    /**
     * Numéro Adhérent DT
     */
    num_adh_dt: string | null;
    mail_dt: string | null;
    nom_rg: string | null;
    /**
     * Prénom RG
     */
    prenom_rg: string | null;
    /**
     * Numéro Adhérent RG
     */
    num_adh_rg: string | null;
    mail_rg: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ReadOnlyNotNestedUser = {
    readonly id: string;
    /**
     * Nom d’utilisateur
     *
     * Requis. 150 caractères maximum. Uniquement des lettres, nombres et les caractères « @ », « . », « + », « - » et « _ ».
     */
    readonly username: string;
    gender: GenderEnum;
    /**
     * Accord des intitulés (rôle, fonction) ; vide = déduit du genre
     *
     * * `m` - Masculin
     * * `f` - Féminin
     * * `n` - Les deux formes
     */
    grammatical_form: GrammaticalFormEnum;
    /**
     * Prénom
     */
    readonly first_name: string;
    /**
     * Nom
     */
    readonly last_name: string;
    readonly birth_name: string | null;
    readonly usage_first_name: string | null;
    readonly usage_last_name: string | null;
    readonly phone: string;
    readonly birthdate: Date | null;
    /**
     * Adresse électronique
     */
    readonly email: string;
    fonction: string | null;
    fonction_code: string | null;
    structure: string | null;
    readonly diplomas: Array<NotNestedDiploma>;
    readonly last_sync: Date | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ReadOnlyNotNestedUserRequest = {
    fonction: string | null;
    fonction_code: string | null;
    structure: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ReadonlyMeeting = {
    readonly id: string;
    readonly label: string;
    readonly created_at: Date;
    readonly end_date: Date;
    meeting_type: MeetingType;
    readonly meeting_type_id: string | null;
    place: NotNestedPlace;
    readonly place_id: string | null;
    readonly start_date: Date;
    structure_organisatrice: StructureType;
    readonly structure_organisatrice_id: string | null;
    readonly updated_at: Date;
    modules: Array<MeetingModule>;
    readonly daytime_min: string;
    readonly daytime_max: string;
    readonly ndays: number;
    source: SourceEnum;
    readonly code_analytic: string;
    readonly intranet_id: string;
    readonly supervisors: Array<NotNestedPublicMeetingParticipant>;
    readonly num_agreement_js: string;
    /**
     * Description du stage
     */
    readonly description: string;
    status: StatusEnum;
    readonly tracks: Array<Track>;
    readonly tagada_password: string | null;
    tagada_status: TagadaStatusEnum;
    readonly tagada_participants_last_sync: Date | null;
    readonly tagada_avis_last_sync: Date | null;
    readonly tagada_total_candidates: number;
    readonly tagada_synced_candidates: number;
    opinion_status: OpinionStatusEnum;
    readonly has_opinions: boolean;
    readonly intranet_last_sync: Date;
    /**
     * Si activé, une photo est demandée lors de l'émargement
     */
    readonly checkin_photo_enabled: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ReadonlyStructure = {
    readonly id: string;
    readonly label: string;
    readonly structure_code: string;
    readonly structure_type: string;
    readonly structure_echelon: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ResourceNode = {
    id?: string;
    children: Array<ResourceNode>;
};

export type ResourceTreeList = {
    readonly tree: Array<ResourceNode>;
    readonly list: Array<NotNestedResource>;
};

/**
 * * `content` - Contenu
 * * `link` - Lien
 * * `template_link` - Lien individualisé
 * * `media` - Média
 * * `category` - Catégorie
 */
export const ResourceTypeEnum = {
    CONTENT: 'content',
    LINK: 'link',
    TEMPLATE_LINK: 'template_link',
    MEDIA: 'media',
    CATEGORY: 'category'
} as const;

/**
 * * `content` - Contenu
 * * `link` - Lien
 * * `template_link` - Lien individualisé
 * * `media` - Média
 * * `category` - Catégorie
 */
export type ResourceTypeEnum = typeof ResourceTypeEnum[keyof typeof ResourceTypeEnum];

/**
 * * `ALL` - all
 * * `SUPERVISORS` - supervisors
 */
export const ResourceVisibilityEnum = { ALL: 'ALL', SUPERVISORS: 'SUPERVISORS' } as const;

/**
 * * `ALL` - all
 * * `SUPERVISORS` - supervisors
 */
export type ResourceVisibilityEnum = typeof ResourceVisibilityEnum[keyof typeof ResourceVisibilityEnum];

/**
 * * `team` - Par équipe
 * * `individual` - Individuelle
 */
export const ResponseTypeEnum = { TEAM: 'team', INDIVIDUAL: 'individual' } as const;

/**
 * * `team` - Par équipe
 * * `individual` - Individuelle
 */
export type ResponseTypeEnum = typeof ResponseTypeEnum[keyof typeof ResponseTypeEnum];

/**
 * This Serializer allow us to get access to the current user
 */
export type SgdfUserDetails = {
    readonly id: string;
    /**
     * Adresse électronique
     */
    readonly email: string;
    /**
     * Nom d’utilisateur
     *
     * Requis. 150 caractères maximum. Uniquement des lettres, nombres et les caractères « @ », « . », « + », « - » et « _ ».
     */
    readonly username: string;
    readonly adherent_id: string;
    readonly phone: string;
    /**
     * Prénom
     */
    readonly first_name: string;
    /**
     * Nom
     */
    readonly last_name: string;
    readonly usage_first_name: string | null;
    readonly usage_last_name: string | null;
    gender: GenderEnum;
    /**
     * Accord des intitulés (rôle, fonction) ; vide = déduit du genre
     *
     * * `m` - Masculin
     * * `f` - Féminin
     * * `n` - Les deux formes
     */
    grammatical_form: GrammaticalFormEnum;
    readonly birthdate: Date | null;
    /**
     * Statut super-utilisateur
     *
     * Précise que l’utilisateur possède toutes les permissions sans les assigner explicitement.
     */
    readonly is_superuser: boolean;
    structure: string | null;
    fonction: string | null;
    fonction_code: string | null;
    readonly participations: Array<OwnMeetingParticipant>;
    /**
     * Is true when Déontologie have been validated and accepted
     */
    readonly is_deontologie_validated: boolean;
    diplomas: Array<NotNestedDiploma>;
    readonly avatar_url: string;
    readonly avatar_available: boolean;
    readonly document_signature_url: string;
    readonly document_signature_available: boolean;
    readonly last_sync: Date | null;
};

export type SendEmailReset = {
    email: string;
};

export type SendEmailResetRequest = {
    email: string;
};

/**
 * * `1` - Non défini
 * * `2` - Favorable
 * * `3` - Défavorable
 */
export const SessionStatusEnum = {
    1: '1',
    2: '2',
    3: '3'
} as const;

/**
 * * `1` - Non défini
 * * `2` - Favorable
 * * `3` - Défavorable
 */
export type SessionStatusEnum = typeof SessionStatusEnum[keyof typeof SessionStatusEnum];

export type SetPassword = {
    new_password: string;
    current_password: string;
};

export type SetPasswordRequest = {
    new_password: string;
    current_password: string;
};

export type SetUsername = {
    current_password: string;
    /**
     * Adresse électronique
     */
    new_email?: string;
};

export type SetUsernameRequest = {
    current_password: string;
    /**
     * Adresse électronique
     */
    new_email?: string;
};

/**
 * * `intranet` - Intranet
 * * `tms` - TMS
 * * `manual` - Manuel
 */
export const SourceEnum = {
    INTRANET: 'intranet',
    TMS: 'tms',
    MANUAL: 'manual'
} as const;

/**
 * * `intranet` - Intranet
 * * `tms` - TMS
 * * `manual` - Manuel
 */
export type SourceEnum = typeof SourceEnum[keyof typeof SourceEnum];

/**
 * * `open` - Ouvert
 * * `close` - Fermé
 * * `committed` - Complété
 * * `cancelled` - Annulé
 * * `request_to_anonymize` - Prêt à anonymiser
 * * `anonymized` - Anonymisé
 */
export const StatusEnum = {
    OPEN: 'open',
    CLOSE: 'close',
    COMMITTED: 'committed',
    CANCELLED: 'cancelled',
    REQUEST_TO_ANONYMIZE: 'request_to_anonymize',
    ANONYMIZED: 'anonymized'
} as const;

/**
 * * `open` - Ouvert
 * * `close` - Fermé
 * * `committed` - Complété
 * * `cancelled` - Annulé
 * * `request_to_anonymize` - Prêt à anonymiser
 * * `anonymized` - Anonymisé
 */
export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];

/**
 * This Serializer allow us to get access to the current user
 */
export type StructureType = {
    readonly id: string;
    label: string;
    structure_code: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type StructureTypeRequest = {
    label: string;
    structure_code: string;
};

export type SyncFromIntranet = {
    message: string;
};

/**
 * * `not_sync` - Avis non synchronisé
 * * `candidate_error` - Le candidat associé à cet avis est en erreur
 * * `incoherent_avis` - L'avis digiform est différent de celui sur TAGADA
 * * `avis_too_long` - Erreur : l'avis de stage est trop long
 * * `avis_too_short` - Erreur : l'avis de stage est trop court
 * * `synchronized` - L'avis a été enregistré sur TAGADA
 * * `avis_session_not_set` - Le statut de session est indéfini
 * * `sync_outdated` - L'avis a été modifié depuis ledernier enregistrement sur TAGADA
 */
export const TagadaAvisStatusEnum = {
    NOT_SYNC: 'not_sync',
    CANDIDATE_ERROR: 'candidate_error',
    INCOHERENT_AVIS: 'incoherent_avis',
    AVIS_TOO_LONG: 'avis_too_long',
    AVIS_TOO_SHORT: 'avis_too_short',
    SYNCHRONIZED: 'synchronized',
    AVIS_SESSION_NOT_SET: 'avis_session_not_set',
    SYNC_OUTDATED: 'sync_outdated'
} as const;

/**
 * * `not_sync` - Avis non synchronisé
 * * `candidate_error` - Le candidat associé à cet avis est en erreur
 * * `incoherent_avis` - L'avis digiform est différent de celui sur TAGADA
 * * `avis_too_long` - Erreur : l'avis de stage est trop long
 * * `avis_too_short` - Erreur : l'avis de stage est trop court
 * * `synchronized` - L'avis a été enregistré sur TAGADA
 * * `avis_session_not_set` - Le statut de session est indéfini
 * * `sync_outdated` - L'avis a été modifié depuis ledernier enregistrement sur TAGADA
 */
export type TagadaAvisStatusEnum = typeof TagadaAvisStatusEnum[keyof typeof TagadaAvisStatusEnum];

export type TagadaCandidate = {
    numeroDossier?: string;
    nom?: string;
    prenom?: string;
    dateNaissance?: string;
    lieuNaissance?: string;
    adresse?: string;
    telephone?: string;
    mobile?: string;
    courriel?: string;
    codeDiplome?: string;
    libelleDiplome?: string;
    codeEtatDossier?: string;
    libelleEtatDossier?: string;
    codeErreur?: string;
    libelleErreur?: string;
};

/**
 * * `not_sync` - Non synchronisé
 * * `error_unknown` - Erreur : Raison inconnue
 * * `nbafa_not_found` - Erreur : Numéro de candidat BAFA/BAFD non trouvé
 * * `names_not_found` - Erreur : Dossier non trouvé par Prénom + Nom + Date de naissance
 * * `incorrect_inscription_state` - Erreur : Le candidat existe mais cursus ou état inscriptionnon correct (voir table des règles d’affectation
 * * `opinion_too_long` - Erreur : l'avis de stage est trop long
 * * `opinion_too_short` - Erreur : l'avis de stage est trop court
 * * `session_not_set` - Error: le statut de session est indéfini
 * * `found_not_added` - Candidat trouvé - Non synchronisé
 * * `incoherent_names` - Attention : des données du dossier (Nom, Prénom, ou date denaissance) sont incohérente entre elles
 * * `synchronized` - Candidat synchronisé
 * * `synchronized_verified` - Candidat synchronisé et informations vérifiées
 */
export const TagadaCandidateStatusEnum = {
    NOT_SYNC: 'not_sync',
    ERROR_UNKNOWN: 'error_unknown',
    NBAFA_NOT_FOUND: 'nbafa_not_found',
    NAMES_NOT_FOUND: 'names_not_found',
    INCORRECT_INSCRIPTION_STATE: 'incorrect_inscription_state',
    OPINION_TOO_LONG: 'opinion_too_long',
    OPINION_TOO_SHORT: 'opinion_too_short',
    SESSION_NOT_SET: 'session_not_set',
    FOUND_NOT_ADDED: 'found_not_added',
    INCOHERENT_NAMES: 'incoherent_names',
    SYNCHRONIZED: 'synchronized',
    SYNCHRONIZED_VERIFIED: 'synchronized_verified'
} as const;

/**
 * * `not_sync` - Non synchronisé
 * * `error_unknown` - Erreur : Raison inconnue
 * * `nbafa_not_found` - Erreur : Numéro de candidat BAFA/BAFD non trouvé
 * * `names_not_found` - Erreur : Dossier non trouvé par Prénom + Nom + Date de naissance
 * * `incorrect_inscription_state` - Erreur : Le candidat existe mais cursus ou état inscriptionnon correct (voir table des règles d’affectation
 * * `opinion_too_long` - Erreur : l'avis de stage est trop long
 * * `opinion_too_short` - Erreur : l'avis de stage est trop court
 * * `session_not_set` - Error: le statut de session est indéfini
 * * `found_not_added` - Candidat trouvé - Non synchronisé
 * * `incoherent_names` - Attention : des données du dossier (Nom, Prénom, ou date denaissance) sont incohérente entre elles
 * * `synchronized` - Candidat synchronisé
 * * `synchronized_verified` - Candidat synchronisé et informations vérifiées
 */
export type TagadaCandidateStatusEnum = typeof TagadaCandidateStatusEnum[keyof typeof TagadaCandidateStatusEnum];

/**
 * * `untested` - Synchronisation Tagada non-testé
 * * `missing_id` - Le numéro d'habilitation est manquant
 * * `incorrect_id` - Le numéro d'habilitation semble incorrect : stage non-trouvé sur l'extranet BAFA/BAFD
 * * `readonly_session` - La session ne peut pas être édité
 * * `candidates_in_error` - La synchronisation de certains participants a échoué
 * * `error_unknown` - Erreur inconnue
 * * `ok` - Connexion Tagada fonctionnelle
 */
export const TagadaStatusEnum = {
    UNTESTED: 'untested',
    MISSING_ID: 'missing_id',
    INCORRECT_ID: 'incorrect_id',
    READONLY_SESSION: 'readonly_session',
    CANDIDATES_IN_ERROR: 'candidates_in_error',
    ERROR_UNKNOWN: 'error_unknown',
    OK: 'ok'
} as const;

/**
 * * `untested` - Synchronisation Tagada non-testé
 * * `missing_id` - Le numéro d'habilitation est manquant
 * * `incorrect_id` - Le numéro d'habilitation semble incorrect : stage non-trouvé sur l'extranet BAFA/BAFD
 * * `readonly_session` - La session ne peut pas être édité
 * * `candidates_in_error` - La synchronisation de certains participants a échoué
 * * `error_unknown` - Erreur inconnue
 * * `ok` - Connexion Tagada fonctionnelle
 */
export type TagadaStatusEnum = typeof TagadaStatusEnum[keyof typeof TagadaStatusEnum];

/**
 * This Serializer allow us to get access to the current user
 */
export type Team = {
    readonly id: string;
    label: string;
    color?: string;
    /**
     * The meeting associated to the team
     */
    readonly meeting: string;
    category_id: string | null;
    participants: Array<NotNestedPublicMeetingParticipantWithAvatar>;
    category: NotNestedPublicTeamCategory;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type TeamDailyTask = {
    readonly id: string;
    daily_task: string;
    date: Date;
    team_in_charge: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type TeamDailyTaskRequest = {
    daily_task: string;
    date: Date;
    team_in_charge: string;
};

export type ToggleError = {
    status: string;
    message: string;
};

export type ToggleModuleResponse = {
    status: string;
    module_id: string;
    is_active: boolean;
};

export type Token = {
    access: string;
    refresh: string;
};

export type TokenObtainPairEmailRequest = {
    username_or_email: string;
    password: string;
};

export type TokenRefresh = {
    readonly access: string;
};

export type TokenRefreshRequest = {
    refresh: string;
};

export type TokenVerifyRequest = {
    token: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type Track = {
    readonly id: string;
    /**
     * Nom du Track (parcours)
     */
    label: string;
    /**
     * Must not be null, a Track must be linked to a meeting
     */
    readonly meeting: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type TrackRequest = {
    /**
     * Nom du Track (parcours)
     */
    label: string;
};

/**
 * * `avis` - Avis
 * * `commentaire_envoi` - Commentaire d'envoi
 * * `entretien` - Entretien
 * * `observation` - Observation
 * * `prep_entretien` - Préparation d'entretien
 */
export const TypeEnum = {
    AVIS: 'avis',
    COMMENTAIRE_ENVOI: 'commentaire_envoi',
    ENTRETIEN: 'entretien',
    OBSERVATION: 'observation',
    PREP_ENTRETIEN: 'prep_entretien'
} as const;

/**
 * * `avis` - Avis
 * * `commentaire_envoi` - Commentaire d'envoi
 * * `entretien` - Entretien
 * * `observation` - Observation
 * * `prep_entretien` - Préparation d'entretien
 */
export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];

export type User = {
    /**
     * Adresse électronique
     */
    readonly email: string;
    readonly id: string;
};

export type UserAccessRights = {
    user_id: string;
    meeting_id?: string;
    access_rights: Array<string>;
};

export type UserCreate = {
    /**
     * Adresse électronique
     */
    email?: string;
    readonly id: string;
};

export type UserCreateRequest = {
    /**
     * Adresse électronique
     */
    email?: string;
};

export type UsernameResetConfirm = {
    /**
     * Adresse électronique
     */
    new_email?: string;
};

export type UsernameResetConfirmRequest = {
    /**
     * Adresse électronique
     */
    new_email?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type CreateNotNestedResourceRequestWritable = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    unpublish?: boolean;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type CreatePublicNotNestedResourceRequestWritable = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    unpublish?: boolean;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DailyTaskWritable = {
    description?: string;
    /**
     * Nom du service
     */
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DailyTaskTeamWritable = {
    label: string;
    color?: string;
    participants: Array<NotNestedPublicMeetingParticipantWithAvatarWritable>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type DocTemplateWritable = {
    id?: string;
    label: string;
    description?: string | null;
    parent_template?: string | null;
    category?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type EventWritable = {
    start_date: Date;
    end_date: Date;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    visibility?: EventVisibilityEnum;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type EventWithActivityWritable = {
    start_date: Date;
    end_date: Date;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    visibility?: EventVisibilityEnum;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingWritable = {
    modules: Array<unknown>;
    code_analytic?: string;
    num_agreement_js?: string;
    /**
     * Description du stage
     */
    description?: string;
    tagada_password?: string | null;
    opinion_status?: OpinionStatusEnum;
    /**
     * Si activé, une photo est demandée lors de l'émargement
     */
    checkin_photo_enabled?: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingCommentWritable = {
    event?: string | null;
    text?: string | null;
    type?: TypeEnum;
    /**
     * Date must be filled for a comment
     */
    date: Date;
    /**
     * List of ids of the tags associated
     */
    tags_id?: Array<string>;
    /**
     * Assign the comment as a special comment. allowed_values : (start_interview, middle_interview, end_interview, sgdf_opinion, js_opinion)
     */
    assign_as?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingCommentTagWritable = {
    color?: string;
    label: string;
    favorite?: boolean;
    icon?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingFormWritable = {
    title: string;
    response_type: ResponseTypeEnum;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    author?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingFormFieldWritable = {
    title: string;
    name: string;
    type: string;
    choices?: string;
    help_info?: string;
    default_value?: string;
    is_required?: boolean;
    order: number;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingFormSubmissionWritable = {
    submission_data: unknown;
    participant: NotNestedPublicMeetingParticipantWithAvatarWritable;
    team?: NotNestedDailyTaskTeamWritable | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingGestionnaireWritable = {
    modules: Array<unknown>;
    daytime_min?: string;
    daytime_max?: string;
    code_analytic?: string;
    num_agreement_js?: string;
    /**
     * Description du stage
     */
    description?: string;
    tagada_password?: string | null;
    opinion_status?: OpinionStatusEnum;
    /**
     * Si activé, une photo est demandée lors de l'émargement
     */
    checkin_photo_enabled?: boolean;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type MeetingParticipantWritable = {
    first_name: string;
    last_name: string;
    usage_first_name: string;
    usage_last_name: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     *
     * * `0` - Non-défini
     * * `270` - Farfadets
     * * `210` - Louveteaux-Jeannettes
     * * `220` - Scouts-Guides
     * * `230` - Pionniers-Caravelles
     * * `240` - Compagnons
     * * `290` - Audace
     * * `180` - Impeesa
     * * `310` - Équipe de Groupe
     * * `300` - Responsable de Groupe
     * * `600` - Équipe Territoriale
     * * `505` - Responsable Territorial
     * * `500` - Délégué Territorial
     * * `900` - Équipe Nationale
     * * `980` - Salarié
     * * `1000` - Autre branche
     */
    branche?: BrancheEnum;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    food_regime?: string;
    session_status?: SessionStatusEnum;
    complement_information?: string;
    hidden?: boolean;
    birthdate?: Date | null;
    hebergement?: string;
    track_id: string | null;
    is_bafa_bafd_candidate?: boolean;
    tagada_candidate_status?: TagadaCandidateStatusEnum;
    tagada_avis_status?: TagadaAvisStatusEnum;
    tagada_avis_last_sync?: Date | null;
    age_at_meeting_start?: number;
    /**
     * Compte rendu de début de stage
     */
    start_interview?: string | null;
    /**
     * Compte rendu d'entretien de mi-stage
     */
    middle_interview?: string | null;
    /**
     * Compte rendu d'entretien de fin de stage
     */
    end_interview?: string | null;
    /**
     * Avis interne SGdF de fin de stage
     */
    sgdf_opinion?: string | null;
    /**
     * Avis JS de fin de stage
     */
    js_opinion?: string | null;
    user_last_sync: Date | null;
    rg_user: NotNestedUserWritable | null;
    dt_user: NotNestedUserWritable | null;
    gender: string;
    grammatical_form: string;
    birth_name: string;
    which_administrative_lastname: string;
    which_administrative_firstname: string;
    phone: string;
    email: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingPublicWritable = {
    modules: Array<unknown>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingPublicFormWritable = {
    title: string;
    response_type: ResponseTypeEnum;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    author?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type MeetingPublicFormWithFieldsWritable = {
    title: string;
    response_type: ResponseTypeEnum;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    author?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ModularEventWritable = {
    start_date: Date;
    end_date: Date;
    event_type?: EventTypeEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NestedByStructureParticipantWritable = {
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NestedMeetingCommentDetailWritable = {
    text?: string | null;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type NoCommentMeetingParticipantWritable = {
    /**
     * Is imported from intranet the 1st time but not synchronized after
     *
     * * `0` - Non-défini
     * * `270` - Farfadets
     * * `210` - Louveteaux-Jeannettes
     * * `220` - Scouts-Guides
     * * `230` - Pionniers-Caravelles
     * * `240` - Compagnons
     * * `290` - Audace
     * * `180` - Impeesa
     * * `310` - Équipe de Groupe
     * * `300` - Responsable de Groupe
     * * `600` - Équipe Territoriale
     * * `505` - Responsable Territorial
     * * `500` - Délégué Territorial
     * * `900` - Équipe Nationale
     * * `980` - Salarié
     * * `1000` - Autre branche
     */
    branche?: BrancheEnum;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    num_bafa_bafd?: string;
    /**
     * Is imported from intranet the 1st time but not synchronized after
     */
    food_regime?: string;
    session_status?: SessionStatusEnum;
    complement_information?: string;
    hidden?: boolean;
    hebergement?: string;
    track_id: string | null;
    is_bafa_bafd_candidate?: boolean;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedDailyTaskTeamWritable = {
    label: string;
    color?: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedDiplomaWritable = {
    /**
     * Type de diplôme
     *
     * * `619` - AFPS
     * * `73` - BAFA
     * * `140` - BAFD
     * * `618` - BP JEPS
     * * `615` - Diplome Marin
     * * `1000` - Équivalence BAFD
     * * `632` - DE Educateur Spécialisé
     * * `626` - DE JEPS
     * * `603` - PSC1 Prevention et Secours Civiques de niveau 1
     * * `608` - Surveillant de Baignade
     * * `1001` - Autre Diplome ou Brevet
     */
    diploma_type: DiplomaTypeEnum;
    /**
     * Date d'obtention du diplome
     */
    issue_date: Date;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedEventWritable = {
    activity: string;
    start_date: Date;
    end_date: Date;
    /**
     * Room where is located the event ; can be empty if no room has been defined yet during the meeting
     */
    room?: string | null;
    /**
     * Participant team in charge of this event, can be empty if no team in charge
     */
    team_in_charge?: string | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    /**
     * Supervisors in charge to prepare the Event, can be empty if no supervisor defined (all supervisors or no-one)
     */
    supervisors?: Array<string>;
    visibility?: EventVisibilityEnum;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedEventWithNestedActivityWritable = {
    activity: NotNestedPublicActivityWritable;
    start_date: Date;
    end_date: Date;
    /**
     * Room where is located the event ; can be empty if no room has been defined yet during the meeting
     */
    room?: string | null;
    /**
     * Participant team in charge of this event, can be empty if no team in charge
     */
    team_in_charge?: string | null;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
    /**
     * Commentaire interne en équipe de formation
     */
    comment?: string;
    /**
     * Supervisors in charge to prepare the Event, can be empty if no supervisor defined (all supervisors or no-one)
     */
    supervisors?: Array<string>;
    visibility?: EventVisibilityEnum;
    enrollment_publication_publication_date?: Date | null;
    enrollment_publication_opening_date?: Date | null;
    enrollment_publication_closing_date?: Date | null;
    review_form_id?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedMeetingFormWritable = {
    response_type: ResponseTypeEnum;
    /**
     * Date de publication du sondage
     */
    publication_date?: Date | null;
    /**
     * Date d'ouverture du sondage
     */
    opening_date?: Date | null;
    /**
     * Date de cloture du sondage
     */
    closing_date?: Date | null;
    author?: string | null;
    title: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedMeetingFormSubmissionWritable = {
    submission_data: unknown;
    participant?: string | null;
    team?: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicActivityWritable = {
    /**
     * Event Category, must be filled to create an event
     */
    category?: string | null;
    /**
     * Une Activity peut être associé à zéro, un ou plusieurs Track (parcours)
     */
    tracks?: Array<string>;
    label: string;
    description?: string | null;
    /**
     * Nombre maximum de participants autorisés lors de cette Activity
     */
    max_participants?: number;
    event_relation_type?: EventRelationTypeEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicActivityCategoryWritable = {
    color?: string;
    text_color?: string | null;
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicActivityTopicWritable = {
    color?: string;
    text_color?: string | null;
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicMeetingParticipantWithAvatarWritable = {
    teams: Array<string>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicRoomWritable = {
    /**
     * Nombre de personnes autorisées dans la salle
     */
    capacity: number;
    description?: string;
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedPublicTeamCategoryWritable = {
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedResourceWritable = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedResourceRequestWritable = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    unpublish?: boolean;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedRoomWithEventWritable = {
    /**
     * Nombre de personnes autorisées dans la salle
     */
    capacity: number;
    description?: string;
    label: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedTeamWritable = {
    label: string;
    color?: string;
    category_id: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type NotNestedUserWritable = {
    fonction: string | null;
    fonction_code: string | null;
    structure: string | null;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type OpinionParticipantWritable = {
    js_opinion?: NestedMeetingCommentDetailWritable | null;
    sgdf_opinion?: NestedMeetingCommentDetailWritable | null;
    session_status?: SessionStatusEnum;
};

/**
 * Lightweight — embedded in opinion participant list (count + status only).
 *
 * Read-only summary returned by the DRF v1 ``opinion_list``/``opinion``
 * endpoints. The full thread CRUD lives on the ninja v2 router
 * ``core.api.routers.opinion_review``.
 */
export type OpinionReviewThreadSummaryWritable = {
    is_resolved?: boolean;
};

/**
 * Libellé du rôle accordé selon la préférence de la personne.
 */
export type OwnMeetingParticipantWritable = {
    which_administrative_lastname: string;
    which_administrative_firstname: string;
    phone: string;
    birthdate?: Date;
    email: string;
    gender: string;
    grammatical_form: string;
};

export type PaginatedDailyTaskListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DailyTaskWritable>;
};

export type PaginatedDailyTaskTeamListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DailyTaskTeamWritable>;
};

export type PaginatedDocTemplateListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DocTemplateWritable>;
};

export type PaginatedEventListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<EventWritable>;
};

export type PaginatedMeetingCommentListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingCommentWritable>;
};

export type PaginatedMeetingListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingWritable>;
};

export type PaginatedMeetingModuleListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<unknown>;
};

export type PaginatedMeetingParticipantListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingParticipantWritable>;
};

export type PaginatedMeetingPublicListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingPublicWritable>;
};

export type PaginatedMeetingTypeListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<unknown>;
};

export type PaginatedModularEventListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ModularEventWritable>;
};

export type PaginatedNoCommentMeetingParticipantListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NoCommentMeetingParticipantWritable>;
};

export type PaginatedNotNestedMeetingRoleListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<unknown>;
};

export type PaginatedNotNestedPlaceListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<unknown>;
};

export type PaginatedNotNestedPublicActivityCategoryListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NotNestedPublicActivityCategoryWritable>;
};

export type PaginatedNotNestedPublicActivityTopicListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NotNestedPublicActivityTopicWritable>;
};

export type PaginatedNotNestedPublicEventParticipantEnrollmentListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<unknown>;
};

export type PaginatedNotNestedRoomWithEventListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<NotNestedRoomWithEventWritable>;
};

export type PaginatedOpinionParticipantListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<OpinionParticipantWritable>;
};

export type PaginatedParticipantStructureListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ParticipantStructureWritable>;
};

export type PaginatedPublicActivityListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<PublicActivityWritable>;
};

export type PaginatedPublicEventListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<PublicEventWritable>;
};

export type PaginatedPublicModularEventListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<PublicModularEventWritable>;
};

export type PaginatedReadonlyStructureListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<unknown>;
};

export type PaginatedTeamDailyTaskListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TeamDailyTaskWritable>;
};

export type PaginatedTeamListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TeamWritable>;
};

export type PaginatedTrackListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TrackWritable>;
};

export type PaginatedUserListWritable = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<unknown>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ParticipantStructureWritable = {
    label: string;
    structure_code: string;
    structure_type: string;
    structure_echelon: string;
    participants: Array<NestedByStructureParticipantWritable>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedNotNestedResourceRequestWritable = {
    id?: string;
    label?: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type?: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order?: number;
    parent?: string | null;
    unpublish?: boolean;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PatchedPublicNotNestedResourceRequestWritable = {
    id?: string;
    label?: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type?: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order?: number;
    parent?: string | null;
    unpublish?: boolean;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicActivityWritable = {
    label: string;
    description?: string | null;
    /**
     * Nombre maximum de participants autorisés lors de cette Activity
     */
    max_participants?: number;
    event_relation_type?: EventRelationTypeEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicEventWritable = {
    start_date: Date;
    end_date: Date;
    event_type?: EventTypeEnum;
    enrollment_modality?: EnrollmentModalityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicModularEventWritable = {
    start_date: Date;
    end_date: Date;
    event_type?: EventTypeEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicNotNestedResourceWritable = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    visibility?: ResourceVisibilityEnum;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type PublicNotNestedResourceRequestWritable = {
    id?: string;
    label: string;
    description?: string | null;
    /**
     * Type de resource
     *
     * * `content` - Contenu
     * * `link` - Lien
     * * `template_link` - Lien individualisé
     * * `media` - Média
     * * `category` - Catégorie
     */
    resource_type: ResourceTypeEnum;
    url?: string | null;
    url_template?: string | null;
    content?: string | null;
    /**
     * La ressource a-t-elle été créée par l'équipe de formation
     */
    trusted?: boolean;
    /**
     * Date de publication de la resource
     */
    publication_date?: Date | null;
    order: number;
    parent?: string | null;
    unpublish?: boolean;
    visibility?: ResourceVisibilityEnum;
};

export type PublicResourceTreeListWritable = {
    [key: string]: unknown;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ReadOnlyNotNestedUserWritable = {
    fonction: string | null;
    fonction_code: string | null;
    structure: string | null;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type ReadonlyMeetingWritable = {
    modules: Array<unknown>;
};

export type ResourceTreeListWritable = {
    [key: string]: unknown;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type SgdfUserDetailsWritable = {
    structure: string | null;
    fonction: string | null;
    fonction_code: string | null;
    diplomas: Array<NotNestedDiplomaWritable>;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type StructureTypeWritable = {
    label: string;
    structure_code: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type TeamWritable = {
    label: string;
    color?: string;
    category_id: string | null;
    participants: Array<NotNestedPublicMeetingParticipantWithAvatarWritable>;
    category: NotNestedPublicTeamCategoryWritable;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type TeamDailyTaskWritable = {
    daily_task: string;
    date: Date;
    team_in_charge: string;
};

/**
 * This Serializer allow us to get access to the current user
 */
export type TrackWritable = {
    /**
     * Nom du Track (parcours)
     */
    label: string;
};

export type UserCreateWritable = {
    /**
     * Adresse électronique
     */
    email?: string;
};

export type UserCreateRequestWritable = {
    /**
     * Adresse électronique
     */
    email?: string;
    password: string;
};

export type AuthJwtCreateCreateData = {
    body: TokenObtainPairEmailRequest;
    path?: never;
    query?: never;
    url: '/api/auth/jwt/create/';
};

export type AuthJwtCreateCreateResponses = {
    200: Token;
};

export type AuthJwtCreateCreateResponse = AuthJwtCreateCreateResponses[keyof AuthJwtCreateCreateResponses];

export type AuthJwtRefreshCreateData = {
    body: TokenRefreshRequest;
    path?: never;
    query?: never;
    url: '/api/auth/jwt/refresh/';
};

export type AuthJwtRefreshCreateResponses = {
    200: TokenRefresh;
};

export type AuthJwtRefreshCreateResponse = AuthJwtRefreshCreateResponses[keyof AuthJwtRefreshCreateResponses];

export type AuthJwtVerifyCreateData = {
    body: TokenVerifyRequest;
    path?: never;
    query?: never;
    url: '/api/auth/jwt/verify/';
};

export type AuthJwtVerifyCreateResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type AuthORetrieveData = {
    body?: never;
    path: {
        provider: string;
    };
    query?: never;
    url: '/api/auth/o/{provider}/';
};

export type AuthORetrieveResponses = {
    200: Djoser;
};

export type AuthORetrieveResponse = AuthORetrieveResponses[keyof AuthORetrieveResponses];

export type AuthOCreateData = {
    body?: never;
    path: {
        provider: string;
    };
    query: {
        code: string;
        session_state: string;
        state: string;
    };
    url: '/api/auth/o/{provider}/';
};

export type AuthOCreateResponses = {
    201: ProviderAuth;
};

export type AuthOCreateResponse = AuthOCreateResponses[keyof AuthOCreateResponses];

export type AuthUsersListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
    };
    url: '/api/auth/users/';
};

export type AuthUsersListResponses = {
    200: PaginatedUserList;
};

export type AuthUsersListResponse = AuthUsersListResponses[keyof AuthUsersListResponses];

export type AuthUsersCreateData = {
    body: UserCreateRequestWritable;
    path?: never;
    query?: never;
    url: '/api/auth/users/';
};

export type AuthUsersCreateResponses = {
    201: UserCreate;
};

export type AuthUsersCreateResponse = AuthUsersCreateResponses[keyof AuthUsersCreateResponses];

export type AuthUsersDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/auth/users/{id}/';
};

export type AuthUsersDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AuthUsersDestroyResponse = AuthUsersDestroyResponses[keyof AuthUsersDestroyResponses];

export type AuthUsersRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/auth/users/{id}/';
};

export type AuthUsersRetrieveResponses = {
    200: User;
};

export type AuthUsersRetrieveResponse = AuthUsersRetrieveResponses[keyof AuthUsersRetrieveResponses];

export type AuthUsersPartialUpdateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/auth/users/{id}/';
};

export type AuthUsersPartialUpdateResponses = {
    200: User;
};

export type AuthUsersPartialUpdateResponse = AuthUsersPartialUpdateResponses[keyof AuthUsersPartialUpdateResponses];

export type AuthUsersUpdateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/auth/users/{id}/';
};

export type AuthUsersUpdateResponses = {
    200: User;
};

export type AuthUsersUpdateResponse = AuthUsersUpdateResponses[keyof AuthUsersUpdateResponses];

export type AuthUsersActivationCreateData = {
    body: ActivationRequest;
    path?: never;
    query?: never;
    url: '/api/auth/users/activation/';
};

export type AuthUsersActivationCreateResponses = {
    200: Activation;
};

export type AuthUsersActivationCreateResponse = AuthUsersActivationCreateResponses[keyof AuthUsersActivationCreateResponses];

export type AuthUsersMeDestroyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/auth/users/me/';
};

export type AuthUsersMeDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AuthUsersMeDestroyResponse = AuthUsersMeDestroyResponses[keyof AuthUsersMeDestroyResponses];

export type AuthUsersMeRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/auth/users/me/';
};

export type AuthUsersMeRetrieveResponses = {
    200: User;
};

export type AuthUsersMeRetrieveResponse = AuthUsersMeRetrieveResponses[keyof AuthUsersMeRetrieveResponses];

export type AuthUsersMePartialUpdateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/auth/users/me/';
};

export type AuthUsersMePartialUpdateResponses = {
    200: User;
};

export type AuthUsersMePartialUpdateResponse = AuthUsersMePartialUpdateResponses[keyof AuthUsersMePartialUpdateResponses];

export type AuthUsersMeUpdateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/auth/users/me/';
};

export type AuthUsersMeUpdateResponses = {
    200: User;
};

export type AuthUsersMeUpdateResponse = AuthUsersMeUpdateResponses[keyof AuthUsersMeUpdateResponses];

export type AuthUsersResendActivationCreateData = {
    body: DigiformSendEmailResetRequest;
    path?: never;
    query?: never;
    url: '/api/auth/users/resend_activation/';
};

export type AuthUsersResendActivationCreateResponses = {
    200: DigiformSendEmailReset;
};

export type AuthUsersResendActivationCreateResponse = AuthUsersResendActivationCreateResponses[keyof AuthUsersResendActivationCreateResponses];

export type AuthUsersResetPasswordCreateData = {
    body: DigiformSendEmailResetRequest;
    path?: never;
    query?: never;
    url: '/api/auth/users/reset_password/';
};

export type AuthUsersResetPasswordCreateResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AuthUsersResetPasswordCreateResponse = AuthUsersResetPasswordCreateResponses[keyof AuthUsersResetPasswordCreateResponses];

export type AuthUsersResetPasswordConfirmCreateData = {
    body: PasswordResetConfirmRetypeRequest;
    path?: never;
    query?: never;
    url: '/api/auth/users/reset_password_confirm/';
};

export type AuthUsersResetPasswordConfirmCreateResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AuthUsersResetPasswordConfirmCreateResponse = AuthUsersResetPasswordConfirmCreateResponses[keyof AuthUsersResetPasswordConfirmCreateResponses];

export type AuthUsersResetUsernameCreateData = {
    body: SendEmailResetRequest;
    path?: never;
    query?: never;
    url: '/api/auth/users/reset_username/';
};

export type AuthUsersResetUsernameCreateResponses = {
    200: SendEmailReset;
};

export type AuthUsersResetUsernameCreateResponse = AuthUsersResetUsernameCreateResponses[keyof AuthUsersResetUsernameCreateResponses];

export type AuthUsersResetUsernameConfirmCreateData = {
    body?: UsernameResetConfirmRequest;
    path?: never;
    query?: never;
    url: '/api/auth/users/reset_username_confirm/';
};

export type AuthUsersResetUsernameConfirmCreateResponses = {
    200: UsernameResetConfirm;
};

export type AuthUsersResetUsernameConfirmCreateResponse = AuthUsersResetUsernameConfirmCreateResponses[keyof AuthUsersResetUsernameConfirmCreateResponses];

export type AuthUsersSetPasswordCreateData = {
    body: SetPasswordRequest;
    path?: never;
    query?: never;
    url: '/api/auth/users/set_password/';
};

export type AuthUsersSetPasswordCreateResponses = {
    200: SetPassword;
};

export type AuthUsersSetPasswordCreateResponse = AuthUsersSetPasswordCreateResponses[keyof AuthUsersSetPasswordCreateResponses];

export type AuthUsersSetUsernameCreateData = {
    body: SetUsernameRequest;
    path?: never;
    query?: never;
    url: '/api/auth/users/set_username/';
};

export type AuthUsersSetUsernameCreateResponses = {
    200: SetUsername;
};

export type AuthUsersSetUsernameCreateResponse = AuthUsersSetUsernameCreateResponses[keyof AuthUsersSetUsernameCreateResponses];

export type ExportsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        parent_template?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/exports/';
};

export type ExportsListResponses = {
    200: PaginatedDocTemplateList;
};

export type ExportsListResponse = ExportsListResponses[keyof ExportsListResponses];

export type ExportsCreateData = {
    body: DocTemplateRequest;
    path?: never;
    query?: never;
    url: '/api/exports/';
};

export type ExportsCreateResponses = {
    201: DocTemplate;
};

export type ExportsCreateResponse = ExportsCreateResponses[keyof ExportsCreateResponses];

export type ExportsParticipantsExportRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the doctemplate
         */
        doctemplate_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting participant.
         */
        participant_id: string;
    };
    query?: never;
    url: '/api/exports/{doctemplate_id}/participants/{participant_id}/export/';
};

export type ExportsParticipantsExportRetrieveResponses = {
    200: MeetingParticipant;
};

export type ExportsParticipantsExportRetrieveResponse = ExportsParticipantsExportRetrieveResponses[keyof ExportsParticipantsExportRetrieveResponses];

export type ExportsParticipantsExportMultipleRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the doctemplate
         */
        doctemplate_id: string;
        /**
         * UUID of the participant
         */
        participant_id: string;
    };
    query?: never;
    url: '/api/exports/{doctemplate_id}/participants/export-multiple/';
};

export type ExportsParticipantsExportMultipleRetrieveResponses = {
    200: MeetingParticipant;
};

export type ExportsParticipantsExportMultipleRetrieveResponse = ExportsParticipantsExportMultipleRetrieveResponses[keyof ExportsParticipantsExportMultipleRetrieveResponses];

export type ExportsDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) doc template.
         */
        id: string;
    };
    query?: never;
    url: '/api/exports/{id}/';
};

export type ExportsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ExportsDestroyResponse = ExportsDestroyResponses[keyof ExportsDestroyResponses];

export type ExportsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) doc template.
         */
        id: string;
    };
    query?: never;
    url: '/api/exports/{id}/';
};

export type ExportsRetrieveResponses = {
    200: DocTemplate;
};

export type ExportsRetrieveResponse = ExportsRetrieveResponses[keyof ExportsRetrieveResponses];

export type ExportsPartialUpdateData = {
    body?: PatchedDocTemplateRequest;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) doc template.
         */
        id: string;
    };
    query?: never;
    url: '/api/exports/{id}/';
};

export type ExportsPartialUpdateResponses = {
    200: DocTemplate;
};

export type ExportsPartialUpdateResponse = ExportsPartialUpdateResponses[keyof ExportsPartialUpdateResponses];

export type ExportsUpdateData = {
    body: DocTemplateRequest;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) doc template.
         */
        id: string;
    };
    query?: never;
    url: '/api/exports/{id}/';
};

export type ExportsUpdateResponses = {
    200: DocTemplate;
};

export type ExportsUpdateResponse = ExportsUpdateResponses[keyof ExportsUpdateResponses];

export type GestionnaireMeetingsListData = {
    body?: never;
    path?: never;
    query?: {
        centre_ressource?: string;
        end_date?: Date;
        include_past_years?: boolean;
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        meeting_type__id__in?: Array<string>;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * * `manually_submitted` - Finalisé - soumis manuellement
         * * `not_started` - Non démarré
         * * `` -
         * * `validated_director` - Validé par la direction
         * * `in_progress` - Rédaction En cours
         * * `validated_orga` - Validé national
         * * `submitted` - Finalisé - Soumis J&S
         */
        opinion_status?: Array<'' | 'in_progress' | 'manually_submitted' | 'not_started' | 'submitted' | 'validated_director' | 'validated_orga'>;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        /**
         * * `intranet` - Intranet
         * * `tms` - TMS
         * * `manual` - Manuel
         */
        source?: 'intranet' | 'manual' | 'tms';
        start_date?: Date;
        /**
         * * `close` - Fermé
         * * `committed` - Complété
         * * `` -
         * * `open` - Ouvert
         * * `anonymized` - Anonymisé
         * * `cancelled` - Annulé
         * * `request_to_anonymize` - Prêt à anonymiser
         */
        status?: Array<'' | 'anonymized' | 'cancelled' | 'close' | 'committed' | 'open' | 'request_to_anonymize'>;
        with_has_opinions?: boolean;
    };
    url: '/api/gestionnaire-meetings/';
};

export type GestionnaireMeetingsListResponses = {
    200: PaginatedMeetingList;
};

export type GestionnaireMeetingsListResponse = GestionnaireMeetingsListResponses[keyof GestionnaireMeetingsListResponses];

export type GestionnaireMeetingsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/';
};

export type GestionnaireMeetingsRetrieveResponses = {
    200: MeetingGestionnaire;
};

export type GestionnaireMeetingsRetrieveResponse = GestionnaireMeetingsRetrieveResponses[keyof GestionnaireMeetingsRetrieveResponses];

export type GestionnaireMeetingsPartialUpdateData = {
    body?: PatchedMeetingGestionnaireRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/';
};

export type GestionnaireMeetingsPartialUpdateResponses = {
    200: MeetingGestionnaire;
};

export type GestionnaireMeetingsPartialUpdateResponse = GestionnaireMeetingsPartialUpdateResponses[keyof GestionnaireMeetingsPartialUpdateResponses];

export type GestionnaireMeetingsUpdateData = {
    body?: MeetingGestionnaireRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/';
};

export type GestionnaireMeetingsUpdateResponses = {
    200: MeetingGestionnaire;
};

export type GestionnaireMeetingsUpdateResponse = GestionnaireMeetingsUpdateResponses[keyof GestionnaireMeetingsUpdateResponses];

export type GestionnaireMeetingsMyParticipationRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/my-participation/';
};

export type GestionnaireMeetingsMyParticipationRetrieveResponses = {
    200: OwnMeetingParticipant;
};

export type GestionnaireMeetingsMyParticipationRetrieveResponse = GestionnaireMeetingsMyParticipationRetrieveResponses[keyof GestionnaireMeetingsMyParticipationRetrieveResponses];

export type GestionnaireMeetingsMyParticipationPartialUpdateData = {
    body?: PatchedMeetingRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/my-participation/';
};

export type GestionnaireMeetingsMyParticipationPartialUpdateResponses = {
    200: OwnMeetingUpdateParticipant;
};

export type GestionnaireMeetingsMyParticipationPartialUpdateResponse = GestionnaireMeetingsMyParticipationPartialUpdateResponses[keyof GestionnaireMeetingsMyParticipationPartialUpdateResponses];

export type GestionnaireMeetingsMyParticipationUpdateData = {
    body?: MeetingRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/my-participation/';
};

export type GestionnaireMeetingsMyParticipationUpdateResponses = {
    200: OwnMeetingUpdateParticipant;
};

export type GestionnaireMeetingsMyParticipationUpdateResponse = GestionnaireMeetingsMyParticipationUpdateResponses[keyof GestionnaireMeetingsMyParticipationUpdateResponses];

export type GestionnaireMeetingsRequestAnonymizationPartialUpdateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: {
        'cancel-anonymization'?: boolean;
    };
    url: '/api/gestionnaire-meetings/{id}/request-anonymization/';
};

export type GestionnaireMeetingsRequestAnonymizationPartialUpdateResponses = {
    200: AnonymizeMeeting;
};

export type GestionnaireMeetingsRequestAnonymizationPartialUpdateResponse = GestionnaireMeetingsRequestAnonymizationPartialUpdateResponses[keyof GestionnaireMeetingsRequestAnonymizationPartialUpdateResponses];

export type GestionnaireMeetingsResetParticipantsAvatarDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/reset-participants-avatar/';
};

export type GestionnaireMeetingsResetParticipantsAvatarDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type GestionnaireMeetingsResetParticipantsAvatarDestroyResponse = GestionnaireMeetingsResetParticipantsAvatarDestroyResponses[keyof GestionnaireMeetingsResetParticipantsAvatarDestroyResponses];

export type GestionnaireMeetingsResetParticipantsSignatureDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/reset-participants-signature/';
};

export type GestionnaireMeetingsResetParticipantsSignatureDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type GestionnaireMeetingsResetParticipantsSignatureDestroyResponse = GestionnaireMeetingsResetParticipantsSignatureDestroyResponses[keyof GestionnaireMeetingsResetParticipantsSignatureDestroyResponses];

export type GestionnaireMeetingsRetrieveTagadaCandidateRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: {
        /**
         * Numéro de dossier du candidat
         */
        candidate?: string;
    };
    url: '/api/gestionnaire-meetings/{id}/retrieve-tagada-candidate/';
};

export type GestionnaireMeetingsRetrieveTagadaCandidateRetrieveResponses = {
    200: TagadaCandidate;
};

export type GestionnaireMeetingsRetrieveTagadaCandidateRetrieveResponse = GestionnaireMeetingsRetrieveTagadaCandidateRetrieveResponses[keyof GestionnaireMeetingsRetrieveTagadaCandidateRetrieveResponses];

export type GestionnaireMeetingsSyncAvisTagadaCreateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/sync-avis-tagada/';
};

export type GestionnaireMeetingsSyncAvisTagadaCreateResponses = {
    200: Meeting;
};

export type GestionnaireMeetingsSyncAvisTagadaCreateResponse = GestionnaireMeetingsSyncAvisTagadaCreateResponses[keyof GestionnaireMeetingsSyncAvisTagadaCreateResponses];

export type GestionnaireMeetingsSyncFromIntranetCreateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/sync-from-intranet/';
};

export type GestionnaireMeetingsSyncFromIntranetCreateResponses = {
    200: SyncFromIntranet;
};

export type GestionnaireMeetingsSyncFromIntranetCreateResponse = GestionnaireMeetingsSyncFromIntranetCreateResponses[keyof GestionnaireMeetingsSyncFromIntranetCreateResponses];

export type GestionnaireMeetingsSyncParticipantsTagadaCreateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-meetings/{id}/sync-participants-tagada/';
};

export type GestionnaireMeetingsSyncParticipantsTagadaCreateResponses = {
    200: Meeting;
};

export type GestionnaireMeetingsSyncParticipantsTagadaCreateResponse = GestionnaireMeetingsSyncParticipantsTagadaCreateResponses[keyof GestionnaireMeetingsSyncParticipantsTagadaCreateResponses];

export type GestionnaireMeetingsMyScopeListListData = {
    body?: never;
    path?: never;
    query?: {
        centre_ressource?: string;
        end_date?: Date;
        include_past_years?: boolean;
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        meeting_type__id__in?: Array<string>;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * Filter by opinion status
         */
        opinion_status?: string;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        /**
         * * `intranet` - Intranet
         * * `tms` - TMS
         * * `manual` - Manuel
         */
        source?: 'intranet' | 'manual' | 'tms';
        start_date?: Date;
        /**
         * * `close` - Fermé
         * * `committed` - Complété
         * * `` -
         * * `open` - Ouvert
         * * `anonymized` - Anonymisé
         * * `cancelled` - Annulé
         * * `request_to_anonymize` - Prêt à anonymiser
         */
        status?: Array<'' | 'anonymized' | 'cancelled' | 'close' | 'committed' | 'open' | 'request_to_anonymize'>;
        with_has_opinions?: boolean;
    };
    url: '/api/gestionnaire-meetings/my-scope-list/';
};

export type GestionnaireMeetingsMyScopeListListResponses = {
    200: PaginatedMeetingList;
};

export type GestionnaireMeetingsMyScopeListListResponse = GestionnaireMeetingsMyScopeListListResponses[keyof GestionnaireMeetingsMyScopeListListResponses];

export type GestionnaireParticipantsListData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
    };
    query?: {
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        meeting__end_date?: Date;
        meeting__label?: string;
        meeting__start_date?: Date;
        meeting__structure_organisatrice?: string;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        user__first_name?: string;
        user__last_name?: string;
        user__username?: string;
    };
    url: '/api/gestionnaire-participants/';
};

export type GestionnaireParticipantsListResponses = {
    200: PaginatedMeetingParticipantList;
};

export type GestionnaireParticipantsListResponse = GestionnaireParticipantsListResponses[keyof GestionnaireParticipantsListResponses];

export type GestionnaireParticipantsRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-participants/{id}/';
};

export type GestionnaireParticipantsRetrieveResponses = {
    200: MeetingParticipant;
};

export type GestionnaireParticipantsRetrieveResponse = GestionnaireParticipantsRetrieveResponses[keyof GestionnaireParticipantsRetrieveResponses];

export type GestionnaireParticipantsPartialUpdateData = {
    body?: PatchedMeetingParticipantRequest;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-participants/{id}/';
};

export type GestionnaireParticipantsPartialUpdateResponses = {
    200: MeetingParticipant;
};

export type GestionnaireParticipantsPartialUpdateResponse = GestionnaireParticipantsPartialUpdateResponses[keyof GestionnaireParticipantsPartialUpdateResponses];

export type GestionnaireParticipantsUpdateData = {
    body: MeetingParticipantRequest;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
    };
    query?: never;
    url: '/api/gestionnaire-participants/{id}/';
};

export type GestionnaireParticipantsUpdateResponses = {
    200: MeetingParticipant;
};

export type GestionnaireParticipantsUpdateResponse = GestionnaireParticipantsUpdateResponses[keyof GestionnaireParticipantsUpdateResponses];

export type MediaRetrieveData = {
    body?: never;
    path: {
        /**
         * Temporary media url hash
         */
        url_hash: string;
    };
    query?: never;
    url: '/api/media/{url_hash}/';
};

export type MediaRetrieveResponses = {
    200: Media;
};

export type MediaRetrieveResponse = MediaRetrieveResponses[keyof MediaRetrieveResponses];

export type MediaFileRetrieveData = {
    body?: never;
    path: {
        /**
         * Temporary media url hash
         */
        url_hash: string;
    };
    query?: never;
    url: '/api/media/{url_hash}/file/';
};

export type MediaFileRetrieveResponses = {
    200: Blob | File;
};

export type MediaFileRetrieveResponse = MediaFileRetrieveResponses[keyof MediaFileRetrieveResponses];

export type MediaFileUpdateData = {
    body?: never;
    path: {
        /**
         * Temporary media url hash
         */
        url_hash: string;
    };
    query?: never;
    url: '/api/media/{url_hash}/file/';
};

export type MediaFileUpdateResponses = {
    201: unknown;
};

export type MeetingModulesListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meeting-modules/';
};

export type MeetingModulesListResponses = {
    200: PaginatedMeetingModuleList;
};

export type MeetingModulesListResponse = MeetingModulesListResponses[keyof MeetingModulesListResponses];

export type MeetingModulesRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting module.
         */
        id: string;
    };
    query?: never;
    url: '/api/meeting-modules/{id}/';
};

export type MeetingModulesRetrieveResponses = {
    200: MeetingModule;
};

export type MeetingModulesRetrieveResponse = MeetingModulesRetrieveResponses[keyof MeetingModulesRetrieveResponses];

export type MeetingRolesListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meeting-roles/';
};

export type MeetingRolesListResponses = {
    200: PaginatedNotNestedMeetingRoleList;
};

export type MeetingRolesListResponse = MeetingRolesListResponses[keyof MeetingRolesListResponses];

export type MeetingRolesRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting role.
         */
        id: string;
    };
    query?: never;
    url: '/api/meeting-roles/{id}/';
};

export type MeetingRolesRetrieveResponses = {
    200: NotNestedMeetingRole;
};

export type MeetingRolesRetrieveResponse = MeetingRolesRetrieveResponses[keyof MeetingRolesRetrieveResponses];

export type MeetingTypesListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meeting-types/';
};

export type MeetingTypesListResponses = {
    200: PaginatedMeetingTypeList;
};

export type MeetingTypesListResponse = MeetingTypesListResponses[keyof MeetingTypesListResponses];

export type MeetingTypesRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting type.
         */
        id: string;
    };
    query?: never;
    url: '/api/meeting-types/{id}/';
};

export type MeetingTypesRetrieveResponses = {
    200: MeetingType;
};

export type MeetingTypesRetrieveResponse = MeetingTypesRetrieveResponses[keyof MeetingTypesRetrieveResponses];

export type MeetingsListData = {
    body?: never;
    path?: never;
    query?: {
        centre_ressource?: string;
        end_date?: Date;
        include_past_years?: boolean;
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        meeting_type__id__in?: Array<string>;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * * `manually_submitted` - Finalisé - soumis manuellement
         * * `not_started` - Non démarré
         * * `` -
         * * `validated_director` - Validé par la direction
         * * `in_progress` - Rédaction En cours
         * * `validated_orga` - Validé national
         * * `submitted` - Finalisé - Soumis J&S
         */
        opinion_status?: Array<'' | 'in_progress' | 'manually_submitted' | 'not_started' | 'submitted' | 'validated_director' | 'validated_orga'>;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        /**
         * * `intranet` - Intranet
         * * `tms` - TMS
         * * `manual` - Manuel
         */
        source?: 'intranet' | 'manual' | 'tms';
        start_date?: Date;
        /**
         * * `close` - Fermé
         * * `committed` - Complété
         * * `` -
         * * `open` - Ouvert
         * * `anonymized` - Anonymisé
         * * `cancelled` - Annulé
         * * `request_to_anonymize` - Prêt à anonymiser
         */
        status?: Array<'' | 'anonymized' | 'cancelled' | 'close' | 'committed' | 'open' | 'request_to_anonymize'>;
        with_has_opinions?: boolean;
    };
    url: '/api/meetings/';
};

export type MeetingsListResponses = {
    200: PaginatedMeetingList;
};

export type MeetingsListResponse = MeetingsListResponses[keyof MeetingsListResponses];

export type MeetingsPublicListData = {
    body?: never;
    path?: never;
    query?: {
        centre_ressource?: string;
        end_date?: Date;
        include_past_years?: boolean;
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        meeting_type__id__in?: Array<string>;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * * `manually_submitted` - Finalisé - soumis manuellement
         * * `not_started` - Non démarré
         * * `` -
         * * `validated_director` - Validé par la direction
         * * `in_progress` - Rédaction En cours
         * * `validated_orga` - Validé national
         * * `submitted` - Finalisé - Soumis J&S
         */
        opinion_status?: Array<'' | 'in_progress' | 'manually_submitted' | 'not_started' | 'submitted' | 'validated_director' | 'validated_orga'>;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        /**
         * * `intranet` - Intranet
         * * `tms` - TMS
         * * `manual` - Manuel
         */
        source?: 'intranet' | 'manual' | 'tms';
        start_date?: Date;
        /**
         * * `close` - Fermé
         * * `committed` - Complété
         * * `` -
         * * `open` - Ouvert
         * * `anonymized` - Anonymisé
         * * `cancelled` - Annulé
         * * `request_to_anonymize` - Prêt à anonymiser
         */
        status?: Array<'' | 'anonymized' | 'cancelled' | 'close' | 'committed' | 'open' | 'request_to_anonymize'>;
        with_has_opinions?: boolean;
    };
    url: '/api/meetings-public/';
};

export type MeetingsPublicListResponses = {
    200: PaginatedMeetingPublicList;
};

export type MeetingsPublicListResponse = MeetingsPublicListResponses[keyof MeetingsPublicListResponses];

export type MeetingsPublicRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings-public/{id}/';
};

export type MeetingsPublicRetrieveResponses = {
    200: MeetingPublic;
};

export type MeetingsPublicRetrieveResponse = MeetingsPublicRetrieveResponses[keyof MeetingsPublicRetrieveResponses];

export type MeetingsPublicAccessRightsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings-public/{id}/access-rights/';
};

export type MeetingsPublicAccessRightsRetrieveResponses = {
    200: UserAccessRights;
};

export type MeetingsPublicAccessRightsRetrieveResponse = MeetingsPublicAccessRightsRetrieveResponses[keyof MeetingsPublicAccessRightsRetrieveResponses];

export type MeetingsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings/{id}/';
};

export type MeetingsRetrieveResponses = {
    200: Meeting;
};

export type MeetingsRetrieveResponse = MeetingsRetrieveResponses[keyof MeetingsRetrieveResponses];

export type MeetingsMyParticipationRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings/{id}/my-participation/';
};

export type MeetingsMyParticipationRetrieveResponses = {
    200: OwnMeetingParticipant;
};

export type MeetingsMyParticipationRetrieveResponse = MeetingsMyParticipationRetrieveResponses[keyof MeetingsMyParticipationRetrieveResponses];

export type MeetingsMyParticipationPartialUpdateData = {
    body?: PatchedOwnMeetingUpdateParticipantRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings/{id}/my-participation/';
};

export type MeetingsMyParticipationPartialUpdateResponses = {
    200: OwnMeetingUpdateParticipant;
};

export type MeetingsMyParticipationPartialUpdateResponse = MeetingsMyParticipationPartialUpdateResponses[keyof MeetingsMyParticipationPartialUpdateResponses];

export type MeetingsMyParticipationUpdateData = {
    body?: OwnMeetingUpdateParticipantRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings/{id}/my-participation/';
};

export type MeetingsMyParticipationUpdateResponses = {
    200: OwnMeetingUpdateParticipant;
};

export type MeetingsMyParticipationUpdateResponse = MeetingsMyParticipationUpdateResponses[keyof MeetingsMyParticipationUpdateResponses];

export type MeetingsRequestAnonymizationPartialUpdateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: {
        'cancel-anonymization'?: boolean;
    };
    url: '/api/meetings/{id}/request-anonymization/';
};

export type MeetingsRequestAnonymizationPartialUpdateResponses = {
    200: AnonymizeMeeting;
};

export type MeetingsRequestAnonymizationPartialUpdateResponse = MeetingsRequestAnonymizationPartialUpdateResponses[keyof MeetingsRequestAnonymizationPartialUpdateResponses];

export type MeetingsResetParticipantsAvatarDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings/{id}/reset-participants-avatar/';
};

export type MeetingsResetParticipantsAvatarDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsResetParticipantsAvatarDestroyResponse = MeetingsResetParticipantsAvatarDestroyResponses[keyof MeetingsResetParticipantsAvatarDestroyResponses];

export type MeetingsResetParticipantsSignatureDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings/{id}/reset-participants-signature/';
};

export type MeetingsResetParticipantsSignatureDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsResetParticipantsSignatureDestroyResponse = MeetingsResetParticipantsSignatureDestroyResponses[keyof MeetingsResetParticipantsSignatureDestroyResponses];

export type MeetingsRetrieveTagadaCandidateRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: {
        /**
         * Numéro de dossier du candidat
         */
        candidate?: string;
    };
    url: '/api/meetings/{id}/retrieve-tagada-candidate/';
};

export type MeetingsRetrieveTagadaCandidateRetrieveResponses = {
    200: TagadaCandidate;
};

export type MeetingsRetrieveTagadaCandidateRetrieveResponse = MeetingsRetrieveTagadaCandidateRetrieveResponses[keyof MeetingsRetrieveTagadaCandidateRetrieveResponses];

export type MeetingsSyncAvisTagadaCreateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings/{id}/sync-avis-tagada/';
};

export type MeetingsSyncAvisTagadaCreateResponses = {
    200: Meeting;
};

export type MeetingsSyncAvisTagadaCreateResponse = MeetingsSyncAvisTagadaCreateResponses[keyof MeetingsSyncAvisTagadaCreateResponses];

export type MeetingsSyncFromIntranetCreateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings/{id}/sync-from-intranet/';
};

export type MeetingsSyncFromIntranetCreateResponses = {
    200: SyncFromIntranet;
};

export type MeetingsSyncFromIntranetCreateResponse = MeetingsSyncFromIntranetCreateResponses[keyof MeetingsSyncFromIntranetCreateResponses];

export type MeetingsSyncParticipantsTagadaCreateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting.
         */
        id: string;
    };
    query?: never;
    url: '/api/meetings/{id}/sync-participants-tagada/';
};

export type MeetingsSyncParticipantsTagadaCreateResponses = {
    200: Meeting;
};

export type MeetingsSyncParticipantsTagadaCreateResponse = MeetingsSyncParticipantsTagadaCreateResponses[keyof MeetingsSyncParticipantsTagadaCreateResponses];

export type MeetingsActivitiesListData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: {
        category?: string;
        /**
         * Catégorie
         */
        category_label?: string;
        /**
         * * `MANY` - many
         * * `ONE` - one
         */
        event_relation_type?: 'MANY' | 'ONE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_relation_type__in?: Array<string>;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
        topic?: string;
        /**
         * Thématique
         */
        topic_label?: string;
        /**
         * Parcours
         */
        track_label?: string;
        tracks?: Array<string>;
    };
    url: '/api/meetings/{meeting_id}/activities/';
};

export type MeetingsActivitiesListResponses = {
    200: PaginatedPublicActivityList;
};

export type MeetingsActivitiesListResponse = MeetingsActivitiesListResponses[keyof MeetingsActivitiesListResponses];

export type MeetingsActivitiesCreateData = {
    body: NotNestedPublicActivityRequest;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activities/';
};

export type MeetingsActivitiesCreateResponses = {
    201: NotNestedPublicActivity;
};

export type MeetingsActivitiesCreateResponse = MeetingsActivitiesCreateResponses[keyof MeetingsActivitiesCreateResponses];

export type MeetingsActivitiesDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activities/{id}/';
};

export type MeetingsActivitiesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsActivitiesDestroyResponse = MeetingsActivitiesDestroyResponses[keyof MeetingsActivitiesDestroyResponses];

export type MeetingsActivitiesRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activities/{id}/';
};

export type MeetingsActivitiesRetrieveResponses = {
    200: PublicActivity;
};

export type MeetingsActivitiesRetrieveResponse = MeetingsActivitiesRetrieveResponses[keyof MeetingsActivitiesRetrieveResponses];

export type MeetingsActivitiesPartialUpdateData = {
    body?: PatchedNotNestedPublicActivityRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activities/{id}/';
};

export type MeetingsActivitiesPartialUpdateResponses = {
    200: NotNestedPublicActivity;
};

export type MeetingsActivitiesPartialUpdateResponse = MeetingsActivitiesPartialUpdateResponses[keyof MeetingsActivitiesPartialUpdateResponses];

export type MeetingsActivitiesUpdateData = {
    body: NotNestedPublicActivityRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activities/{id}/';
};

export type MeetingsActivitiesUpdateResponses = {
    200: NotNestedPublicActivity;
};

export type MeetingsActivitiesUpdateResponse = MeetingsActivitiesUpdateResponses[keyof MeetingsActivitiesUpdateResponses];

export type MeetingsActivityCategoriesListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/activity-categories/';
};

export type MeetingsActivityCategoriesListResponses = {
    200: PaginatedNotNestedPublicActivityCategoryList;
};

export type MeetingsActivityCategoriesListResponse = MeetingsActivityCategoriesListResponses[keyof MeetingsActivityCategoriesListResponses];

export type MeetingsActivityCategoriesCreateData = {
    body: NotNestedPublicActivityCategoryRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-categories/';
};

export type MeetingsActivityCategoriesCreateResponses = {
    201: NotNestedPublicActivityCategory;
};

export type MeetingsActivityCategoriesCreateResponse = MeetingsActivityCategoriesCreateResponses[keyof MeetingsActivityCategoriesCreateResponses];

export type MeetingsActivityCategoriesDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity category.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-categories/{id}/';
};

export type MeetingsActivityCategoriesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsActivityCategoriesDestroyResponse = MeetingsActivityCategoriesDestroyResponses[keyof MeetingsActivityCategoriesDestroyResponses];

export type MeetingsActivityCategoriesRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity category.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-categories/{id}/';
};

export type MeetingsActivityCategoriesRetrieveResponses = {
    200: NotNestedPublicActivityCategory;
};

export type MeetingsActivityCategoriesRetrieveResponse = MeetingsActivityCategoriesRetrieveResponses[keyof MeetingsActivityCategoriesRetrieveResponses];

export type MeetingsActivityCategoriesPartialUpdateData = {
    body?: PatchedNotNestedPublicActivityCategoryRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity category.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-categories/{id}/';
};

export type MeetingsActivityCategoriesPartialUpdateResponses = {
    200: NotNestedPublicActivityCategory;
};

export type MeetingsActivityCategoriesPartialUpdateResponse = MeetingsActivityCategoriesPartialUpdateResponses[keyof MeetingsActivityCategoriesPartialUpdateResponses];

export type MeetingsActivityCategoriesUpdateData = {
    body: NotNestedPublicActivityCategoryRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity category.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-categories/{id}/';
};

export type MeetingsActivityCategoriesUpdateResponses = {
    200: NotNestedPublicActivityCategory;
};

export type MeetingsActivityCategoriesUpdateResponse = MeetingsActivityCategoriesUpdateResponses[keyof MeetingsActivityCategoriesUpdateResponses];

export type MeetingsActivityTopicsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/activity-topics/';
};

export type MeetingsActivityTopicsListResponses = {
    200: PaginatedNotNestedPublicActivityTopicList;
};

export type MeetingsActivityTopicsListResponse = MeetingsActivityTopicsListResponses[keyof MeetingsActivityTopicsListResponses];

export type MeetingsActivityTopicsCreateData = {
    body: NotNestedPublicActivityTopicRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-topics/';
};

export type MeetingsActivityTopicsCreateResponses = {
    201: NotNestedPublicActivityTopic;
};

export type MeetingsActivityTopicsCreateResponse = MeetingsActivityTopicsCreateResponses[keyof MeetingsActivityTopicsCreateResponses];

export type MeetingsActivityTopicsDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity topic.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-topics/{id}/';
};

export type MeetingsActivityTopicsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsActivityTopicsDestroyResponse = MeetingsActivityTopicsDestroyResponses[keyof MeetingsActivityTopicsDestroyResponses];

export type MeetingsActivityTopicsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity topic.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-topics/{id}/';
};

export type MeetingsActivityTopicsRetrieveResponses = {
    200: NotNestedPublicActivityTopic;
};

export type MeetingsActivityTopicsRetrieveResponse = MeetingsActivityTopicsRetrieveResponses[keyof MeetingsActivityTopicsRetrieveResponses];

export type MeetingsActivityTopicsPartialUpdateData = {
    body?: PatchedNotNestedPublicActivityTopicRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity topic.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-topics/{id}/';
};

export type MeetingsActivityTopicsPartialUpdateResponses = {
    200: NotNestedPublicActivityTopic;
};

export type MeetingsActivityTopicsPartialUpdateResponse = MeetingsActivityTopicsPartialUpdateResponses[keyof MeetingsActivityTopicsPartialUpdateResponses];

export type MeetingsActivityTopicsUpdateData = {
    body: NotNestedPublicActivityTopicRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) activity topic.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/activity-topics/{id}/';
};

export type MeetingsActivityTopicsUpdateResponses = {
    200: NotNestedPublicActivityTopic;
};

export type MeetingsActivityTopicsUpdateResponse = MeetingsActivityTopicsUpdateResponses[keyof MeetingsActivityTopicsUpdateResponses];

export type MeetingsCommentTagsListData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/comment-tags/';
};

export type MeetingsCommentTagsListResponses = {
    200: Array<MeetingCommentTag>;
};

export type MeetingsCommentTagsListResponse = MeetingsCommentTagsListResponses[keyof MeetingsCommentTagsListResponses];

export type MeetingsCommentTagsCreateData = {
    body: MeetingCommentTagRequest;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/comment-tags/';
};

export type MeetingsCommentTagsCreateResponses = {
    201: MeetingCommentTag;
};

export type MeetingsCommentTagsCreateResponse = MeetingsCommentTagsCreateResponses[keyof MeetingsCommentTagsCreateResponses];

export type MeetingsCommentTagsDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting comment tag.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/comment-tags/{id}/';
};

export type MeetingsCommentTagsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsCommentTagsDestroyResponse = MeetingsCommentTagsDestroyResponses[keyof MeetingsCommentTagsDestroyResponses];

export type MeetingsCommentTagsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting comment tag.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/comment-tags/{id}/';
};

export type MeetingsCommentTagsRetrieveResponses = {
    200: MeetingCommentTag;
};

export type MeetingsCommentTagsRetrieveResponse = MeetingsCommentTagsRetrieveResponses[keyof MeetingsCommentTagsRetrieveResponses];

export type MeetingsCommentTagsPartialUpdateData = {
    body?: PatchedMeetingCommentTagRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting comment tag.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/comment-tags/{id}/';
};

export type MeetingsCommentTagsPartialUpdateResponses = {
    200: MeetingCommentTag;
};

export type MeetingsCommentTagsPartialUpdateResponse = MeetingsCommentTagsPartialUpdateResponses[keyof MeetingsCommentTagsPartialUpdateResponses];

export type MeetingsCommentTagsUpdateData = {
    body: MeetingCommentTagRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting comment tag.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/comment-tags/{id}/';
};

export type MeetingsCommentTagsUpdateResponses = {
    200: MeetingCommentTag;
};

export type MeetingsCommentTagsUpdateResponse = MeetingsCommentTagsUpdateResponses[keyof MeetingsCommentTagsUpdateResponses];

export type MeetingsDailyTaskTeamsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/daily-task-teams/';
};

export type MeetingsDailyTaskTeamsListResponses = {
    200: PaginatedDailyTaskTeamList;
};

export type MeetingsDailyTaskTeamsListResponse = MeetingsDailyTaskTeamsListResponses[keyof MeetingsDailyTaskTeamsListResponses];

export type MeetingsDailyTaskTeamsCreateData = {
    body: NotNestedDailyTaskTeamRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-task-teams/';
};

export type MeetingsDailyTaskTeamsCreateResponses = {
    201: NotNestedDailyTaskTeam;
};

export type MeetingsDailyTaskTeamsCreateResponse = MeetingsDailyTaskTeamsCreateResponses[keyof MeetingsDailyTaskTeamsCreateResponses];

export type MeetingsDailyTaskTeamsDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/';
};

export type MeetingsDailyTaskTeamsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsDailyTaskTeamsDestroyResponse = MeetingsDailyTaskTeamsDestroyResponses[keyof MeetingsDailyTaskTeamsDestroyResponses];

export type MeetingsDailyTaskTeamsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/';
};

export type MeetingsDailyTaskTeamsRetrieveResponses = {
    200: DailyTaskTeam;
};

export type MeetingsDailyTaskTeamsRetrieveResponse = MeetingsDailyTaskTeamsRetrieveResponses[keyof MeetingsDailyTaskTeamsRetrieveResponses];

export type MeetingsDailyTaskTeamsPartialUpdateData = {
    body?: PatchedDailyTaskTeamRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/';
};

export type MeetingsDailyTaskTeamsPartialUpdateResponses = {
    200: DailyTaskTeam;
};

export type MeetingsDailyTaskTeamsPartialUpdateResponse = MeetingsDailyTaskTeamsPartialUpdateResponses[keyof MeetingsDailyTaskTeamsPartialUpdateResponses];

export type MeetingsDailyTaskTeamsUpdateData = {
    body: NotNestedDailyTaskTeamRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/';
};

export type MeetingsDailyTaskTeamsUpdateResponses = {
    200: NotNestedDailyTaskTeam;
};

export type MeetingsDailyTaskTeamsUpdateResponse = MeetingsDailyTaskTeamsUpdateResponses[keyof MeetingsDailyTaskTeamsUpdateResponses];

export type MeetingsDailyTaskTeamsParticipantsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/participants/';
};

export type MeetingsDailyTaskTeamsParticipantsRetrieveResponses = {
    200: ParticipantsDailyTaskTeam;
};

export type MeetingsDailyTaskTeamsParticipantsRetrieveResponse = MeetingsDailyTaskTeamsParticipantsRetrieveResponses[keyof MeetingsDailyTaskTeamsParticipantsRetrieveResponses];

export type MeetingsDailyTaskTeamsParticipantsUpdateData = {
    body: ParticipantsDailyTaskTeamRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-task-teams/{id}/participants/';
};

export type MeetingsDailyTaskTeamsParticipantsUpdateResponses = {
    200: ParticipantsDailyTaskTeam;
};

export type MeetingsDailyTaskTeamsParticipantsUpdateResponse = MeetingsDailyTaskTeamsParticipantsUpdateResponses[keyof MeetingsDailyTaskTeamsParticipantsUpdateResponses];

export type MeetingsDailyTaskTeamsTeamDailyTasksListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
        /**
         * UUID of the team
         */
        team_id: string;
    };
    query?: {
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/daily-task-teams/{team_id}/team-daily-tasks/';
};

export type MeetingsDailyTaskTeamsTeamDailyTasksListResponses = {
    200: PaginatedTeamDailyTaskList;
};

export type MeetingsDailyTaskTeamsTeamDailyTasksListResponse = MeetingsDailyTaskTeamsTeamDailyTasksListResponses[keyof MeetingsDailyTaskTeamsTeamDailyTasksListResponses];

export type MeetingsDailyTaskTeamsTeamDailyTasksRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team daily task.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
        /**
         * UUID of the team
         */
        team_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-task-teams/{team_id}/team-daily-tasks/{id}/';
};

export type MeetingsDailyTaskTeamsTeamDailyTasksRetrieveResponses = {
    200: TeamDailyTask;
};

export type MeetingsDailyTaskTeamsTeamDailyTasksRetrieveResponse = MeetingsDailyTaskTeamsTeamDailyTasksRetrieveResponses[keyof MeetingsDailyTaskTeamsTeamDailyTasksRetrieveResponses];

export type MeetingsDailyTasksListData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/daily-tasks/';
};

export type MeetingsDailyTasksListResponses = {
    200: PaginatedDailyTaskList;
};

export type MeetingsDailyTasksListResponse = MeetingsDailyTasksListResponses[keyof MeetingsDailyTasksListResponses];

export type MeetingsDailyTasksCreateData = {
    body: DailyTaskRequest;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-tasks/';
};

export type MeetingsDailyTasksCreateResponses = {
    201: DailyTask;
};

export type MeetingsDailyTasksCreateResponse = MeetingsDailyTasksCreateResponses[keyof MeetingsDailyTasksCreateResponses];

export type MeetingsDailyTasksDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-tasks/{id}/';
};

export type MeetingsDailyTasksDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsDailyTasksDestroyResponse = MeetingsDailyTasksDestroyResponses[keyof MeetingsDailyTasksDestroyResponses];

export type MeetingsDailyTasksRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-tasks/{id}/';
};

export type MeetingsDailyTasksRetrieveResponses = {
    200: DailyTask;
};

export type MeetingsDailyTasksRetrieveResponse = MeetingsDailyTasksRetrieveResponses[keyof MeetingsDailyTasksRetrieveResponses];

export type MeetingsDailyTasksPartialUpdateData = {
    body?: PatchedDailyTaskRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-tasks/{id}/';
};

export type MeetingsDailyTasksPartialUpdateResponses = {
    200: DailyTask;
};

export type MeetingsDailyTasksPartialUpdateResponse = MeetingsDailyTasksPartialUpdateResponses[keyof MeetingsDailyTasksPartialUpdateResponses];

export type MeetingsDailyTasksUpdateData = {
    body: DailyTaskRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) daily task.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/daily-tasks/{id}/';
};

export type MeetingsDailyTasksUpdateResponses = {
    200: DailyTask;
};

export type MeetingsDailyTasksUpdateResponse = MeetingsDailyTasksUpdateResponses[keyof MeetingsDailyTasksUpdateResponses];

export type MeetingsDailyTasksMyDailyTasksListData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/daily-tasks/my-daily-tasks/';
};

export type MeetingsDailyTasksMyDailyTasksListResponses = {
    200: PaginatedDailyTaskList;
};

export type MeetingsDailyTasksMyDailyTasksListResponse = MeetingsDailyTasksMyDailyTasksListResponses[keyof MeetingsDailyTasksMyDailyTasksListResponses];

export type MeetingsEventsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        /**
         * La requête ne renverra que les évenements futurs
         */
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * La requête filtrera les evenement spécifique à ce participant
         */
        participant_id?: string;
        /**
         * La requête filtrera les evenement dont le participant est superviseur
         */
        planning_type?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        /**
         * La requête filtrera les evenement spécifique à cette équipe
         */
        team_id?: string;
    };
    url: '/api/meetings/{meeting_id}/events/';
};

export type MeetingsEventsListResponses = {
    200: PaginatedEventList;
};

export type MeetingsEventsListResponse = MeetingsEventsListResponses[keyof MeetingsEventsListResponses];

export type MeetingsEventsCreateData = {
    body: NotNestedEventRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/';
};

export type MeetingsEventsCreateResponses = {
    201: NotNestedEvent;
};

export type MeetingsEventsCreateResponse = MeetingsEventsCreateResponses[keyof MeetingsEventsCreateResponses];

export type MeetingsEventsWithActivityListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        /**
         * La requête ne renverra que les évenements futurs
         */
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * La requête filtrera les evenement spécifique à ce participant
         */
        participant_id?: string;
        /**
         * La requête filtrera les evenement dont le participant est superviseur
         */
        planning_type?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        /**
         * La requête filtrera les evenement spécifique à cette équipe
         */
        team_id?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/';
};

export type MeetingsEventsWithActivityListResponses = {
    200: PaginatedEventList;
};

export type MeetingsEventsWithActivityListResponse = MeetingsEventsWithActivityListResponses[keyof MeetingsEventsWithActivityListResponses];

export type MeetingsEventsWithActivityCreateData = {
    body: NotNestedEventWithNestedActivityRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/';
};

export type MeetingsEventsWithActivityCreateResponses = {
    201: EventWithActivity;
};

export type MeetingsEventsWithActivityCreateResponse = MeetingsEventsWithActivityCreateResponses[keyof MeetingsEventsWithActivityCreateResponses];

export type MeetingsEventsWithActivityDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/';
};

export type MeetingsEventsWithActivityDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsEventsWithActivityDestroyResponse = MeetingsEventsWithActivityDestroyResponses[keyof MeetingsEventsWithActivityDestroyResponses];

export type MeetingsEventsWithActivityRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/';
};

export type MeetingsEventsWithActivityRetrieveResponses = {
    200: NotNestedEventWithNestedActivity;
};

export type MeetingsEventsWithActivityRetrieveResponse = MeetingsEventsWithActivityRetrieveResponses[keyof MeetingsEventsWithActivityRetrieveResponses];

export type MeetingsEventsWithActivityPartialUpdateData = {
    body?: PatchedNotNestedEventWithNestedActivityRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/';
};

export type MeetingsEventsWithActivityPartialUpdateResponses = {
    200: NotNestedEventWithNestedActivity;
};

export type MeetingsEventsWithActivityPartialUpdateResponse = MeetingsEventsWithActivityPartialUpdateResponses[keyof MeetingsEventsWithActivityPartialUpdateResponses];

export type MeetingsEventsWithActivityUpdateData = {
    body: NotNestedEventWithNestedActivityRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Déplacer les événements voisins. Valeurs : Déplacer les élements en intersection dû au déplacement `intersect_[next|previous]` ,Déplacer tous les événements de la journée `day_[next|previous]`. next / previous indique si ce sont les événements suivants ou précédents l'événement updatés qui doivent être déplacés
         */
        move_neighbours?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/';
};

export type MeetingsEventsWithActivityUpdateResponses = {
    200: EventWithActivity;
};

export type MeetingsEventsWithActivityUpdateResponse = MeetingsEventsWithActivityUpdateResponses[keyof MeetingsEventsWithActivityUpdateResponses];

export type MeetingsEventsWithActivityChildrenRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/children/';
};

export type MeetingsEventsWithActivityChildrenRetrieveResponses = {
    200: NotNestedEventWithNestedActivity;
};

export type MeetingsEventsWithActivityChildrenRetrieveResponse = MeetingsEventsWithActivityChildrenRetrieveResponses[keyof MeetingsEventsWithActivityChildrenRetrieveResponses];

export type MeetingsEventsWithActivityChildrenCreateData = {
    body: NotNestedEventWithNestedActivityRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/children/';
};

export type MeetingsEventsWithActivityChildrenCreateResponses = {
    201: Event;
};

export type MeetingsEventsWithActivityChildrenCreateResponse = MeetingsEventsWithActivityChildrenCreateResponses[keyof MeetingsEventsWithActivityChildrenCreateResponses];

export type MeetingsEventsWithActivityCopyToDaysCreateData = {
    body: ApplyTypicalDayRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/copy-to-days/';
};

export type MeetingsEventsWithActivityCopyToDaysCreateResponses = {
    200: ApplyTypicalDay;
};

export type MeetingsEventsWithActivityCopyToDaysCreateResponse = MeetingsEventsWithActivityCopyToDaysCreateResponses[keyof MeetingsEventsWithActivityCopyToDaysCreateResponses];

export type MeetingsEventsWithActivityEnrollmentDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query: {
        /**
         * UUID du participant à désinscrire
         */
        participant_id: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/enrollment/';
};

export type MeetingsEventsWithActivityEnrollmentDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsEventsWithActivityEnrollmentDestroyResponse = MeetingsEventsWithActivityEnrollmentDestroyResponses[keyof MeetingsEventsWithActivityEnrollmentDestroyResponses];

export type MeetingsEventsWithActivityEnrollmentListData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * La requête filtrera les evenement spécifique à ce participant
         */
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/enrollment/';
};

export type MeetingsEventsWithActivityEnrollmentListResponses = {
    200: PaginatedNotNestedPublicEventParticipantEnrollmentList;
};

export type MeetingsEventsWithActivityEnrollmentListResponse = MeetingsEventsWithActivityEnrollmentListResponses[keyof MeetingsEventsWithActivityEnrollmentListResponses];

export type MeetingsEventsWithActivityEnrollmentCreateData = {
    body: ParticipantEnrollmentRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/enrollment/';
};

export type MeetingsEventsWithActivityEnrollmentCreateResponses = {
    201: NotNestedPublicEventParticipantEnrollment;
};

export type MeetingsEventsWithActivityEnrollmentCreateResponse = MeetingsEventsWithActivityEnrollmentCreateResponses[keyof MeetingsEventsWithActivityEnrollmentCreateResponses];

export type MeetingsEventsWithActivityMyEnrollmentDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/my-enrollment/';
};

export type MeetingsEventsWithActivityMyEnrollmentDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsEventsWithActivityMyEnrollmentDestroyResponse = MeetingsEventsWithActivityMyEnrollmentDestroyResponses[keyof MeetingsEventsWithActivityMyEnrollmentDestroyResponses];

export type MeetingsEventsWithActivityMyEnrollmentRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/my-enrollment/';
};

export type MeetingsEventsWithActivityMyEnrollmentRetrieveResponses = {
    200: NotNestedPublicEventParticipantEnrollment;
};

export type MeetingsEventsWithActivityMyEnrollmentRetrieveResponse = MeetingsEventsWithActivityMyEnrollmentRetrieveResponses[keyof MeetingsEventsWithActivityMyEnrollmentRetrieveResponses];

export type MeetingsEventsWithActivityMyEnrollmentCreateData = {
    body: NotNestedEventWithNestedActivityRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/{id}/my-enrollment/';
};

export type MeetingsEventsWithActivityMyEnrollmentCreateResponses = {
    201: NotNestedPublicEventParticipantEnrollment;
};

export type MeetingsEventsWithActivityMyEnrollmentCreateResponse = MeetingsEventsWithActivityMyEnrollmentCreateResponses[keyof MeetingsEventsWithActivityMyEnrollmentCreateResponses];

export type MeetingsEventsWithActivityApplyTypicalDayCreateData = {
    body: ApplyTypicalDayRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/apply-typical-day/';
};

export type MeetingsEventsWithActivityApplyTypicalDayCreateResponses = {
    200: PaginatedEventList;
};

export type MeetingsEventsWithActivityApplyTypicalDayCreateResponse = MeetingsEventsWithActivityApplyTypicalDayCreateResponses[keyof MeetingsEventsWithActivityApplyTypicalDayCreateResponses];

export type MeetingsEventsWithActivityEnrollmentsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * La requête filtrera les evenement spécifique à ce participant
         */
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/enrollments/';
};

export type MeetingsEventsWithActivityEnrollmentsListResponses = {
    200: PaginatedNotNestedPublicEventParticipantEnrollmentList;
};

export type MeetingsEventsWithActivityEnrollmentsListResponse = MeetingsEventsWithActivityEnrollmentsListResponses[keyof MeetingsEventsWithActivityEnrollmentsListResponses];

export type MeetingsEventsWithActivityInChargeListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/in-charge/';
};

export type MeetingsEventsWithActivityInChargeListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsWithActivityInChargeListResponse = MeetingsEventsWithActivityInChargeListResponses[keyof MeetingsEventsWithActivityInChargeListResponses];

export type MeetingsEventsWithActivityMyDailyEventsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/my-daily-events/';
};

export type MeetingsEventsWithActivityMyDailyEventsListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsWithActivityMyDailyEventsListResponse = MeetingsEventsWithActivityMyDailyEventsListResponses[keyof MeetingsEventsWithActivityMyDailyEventsListResponses];

export type MeetingsEventsWithActivityMyEnrollmentsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/my-enrollments/';
};

export type MeetingsEventsWithActivityMyEnrollmentsListResponses = {
    200: PaginatedNotNestedPublicEventParticipantEnrollmentList;
};

export type MeetingsEventsWithActivityMyEnrollmentsListResponse = MeetingsEventsWithActivityMyEnrollmentsListResponses[keyof MeetingsEventsWithActivityMyEnrollmentsListResponses];

export type MeetingsEventsWithActivityOwnPlanningListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/own-planning/';
};

export type MeetingsEventsWithActivityOwnPlanningListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsWithActivityOwnPlanningListResponse = MeetingsEventsWithActivityOwnPlanningListResponses[keyof MeetingsEventsWithActivityOwnPlanningListResponses];

export type MeetingsEventsWithActivityPlanningRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events-with-activity/planning/';
};

export type MeetingsEventsWithActivityPlanningRetrieveResponses = {
    200: NotNestedEventWithNestedActivity;
};

export type MeetingsEventsWithActivityPlanningRetrieveResponse = MeetingsEventsWithActivityPlanningRetrieveResponses[keyof MeetingsEventsWithActivityPlanningRetrieveResponses];

export type MeetingsEventsWithActivityPublicListListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/public-list/';
};

export type MeetingsEventsWithActivityPublicListListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsWithActivityPublicListListResponse = MeetingsEventsWithActivityPublicListListResponses[keyof MeetingsEventsWithActivityPublicListListResponses];

export type MeetingsEventsWithActivitySupervisorListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/supervisor/';
};

export type MeetingsEventsWithActivitySupervisorListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsWithActivitySupervisorListResponse = MeetingsEventsWithActivitySupervisorListResponses[keyof MeetingsEventsWithActivitySupervisorListResponses];

export type MeetingsEventsWithActivityTypicalDayListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events-with-activity/typical-day/';
};

export type MeetingsEventsWithActivityTypicalDayListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsWithActivityTypicalDayListResponse = MeetingsEventsWithActivityTypicalDayListResponses[keyof MeetingsEventsWithActivityTypicalDayListResponses];

export type MeetingsEventsDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/';
};

export type MeetingsEventsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsEventsDestroyResponse = MeetingsEventsDestroyResponses[keyof MeetingsEventsDestroyResponses];

export type MeetingsEventsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/';
};

export type MeetingsEventsRetrieveResponses = {
    200: NotNestedEvent;
};

export type MeetingsEventsRetrieveResponse = MeetingsEventsRetrieveResponses[keyof MeetingsEventsRetrieveResponses];

export type MeetingsEventsPartialUpdateData = {
    body?: PatchedNotNestedEventRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/';
};

export type MeetingsEventsPartialUpdateResponses = {
    200: NotNestedEvent;
};

export type MeetingsEventsPartialUpdateResponse = MeetingsEventsPartialUpdateResponses[keyof MeetingsEventsPartialUpdateResponses];

export type MeetingsEventsUpdateData = {
    body: NotNestedEventRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Deplacer les evenements voisin. Valeurs : Deplacer les élements en intersection dù au déplacement `intersect_[next|previous]` ,Deplacer tous les evenement de la journée `day_[next|previous]`. next / previous indique si ce sont le evenements suivant ou précédent l'evenemement updaté qui doivent être déplacés
         */
        move_neighbours?: string;
    };
    url: '/api/meetings/{meeting_id}/events/{id}/';
};

export type MeetingsEventsUpdateResponses = {
    200: NotNestedEvent;
};

export type MeetingsEventsUpdateResponse = MeetingsEventsUpdateResponses[keyof MeetingsEventsUpdateResponses];

export type MeetingsEventsChildrenRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/children/';
};

export type MeetingsEventsChildrenRetrieveResponses = {
    200: NotNestedEvent;
};

export type MeetingsEventsChildrenRetrieveResponse = MeetingsEventsChildrenRetrieveResponses[keyof MeetingsEventsChildrenRetrieveResponses];

export type MeetingsEventsChildrenCreateData = {
    body: ActivityUuidRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/children/';
};

export type MeetingsEventsChildrenCreateResponses = {
    201: Event;
};

export type MeetingsEventsChildrenCreateResponse = MeetingsEventsChildrenCreateResponses[keyof MeetingsEventsChildrenCreateResponses];

export type MeetingsEventsCopyToDaysCreateData = {
    body: ApplyTypicalDayRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/copy-to-days/';
};

export type MeetingsEventsCopyToDaysCreateResponses = {
    200: ApplyTypicalDay;
};

export type MeetingsEventsCopyToDaysCreateResponse = MeetingsEventsCopyToDaysCreateResponses[keyof MeetingsEventsCopyToDaysCreateResponses];

export type MeetingsEventsEnrollmentDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query: {
        /**
         * UUID du participant à désinscrire
         */
        participant_id: string;
    };
    url: '/api/meetings/{meeting_id}/events/{id}/enrollment/';
};

export type MeetingsEventsEnrollmentDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsEventsEnrollmentDestroyResponse = MeetingsEventsEnrollmentDestroyResponses[keyof MeetingsEventsEnrollmentDestroyResponses];

export type MeetingsEventsEnrollmentListData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * La requête filtrera les evenement spécifique à ce participant
         */
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/{id}/enrollment/';
};

export type MeetingsEventsEnrollmentListResponses = {
    200: PaginatedNotNestedPublicEventParticipantEnrollmentList;
};

export type MeetingsEventsEnrollmentListResponse = MeetingsEventsEnrollmentListResponses[keyof MeetingsEventsEnrollmentListResponses];

export type MeetingsEventsEnrollmentCreateData = {
    body: ParticipantEnrollmentRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/enrollment/';
};

export type MeetingsEventsEnrollmentCreateResponses = {
    201: NotNestedPublicEventParticipantEnrollment;
};

export type MeetingsEventsEnrollmentCreateResponse = MeetingsEventsEnrollmentCreateResponses[keyof MeetingsEventsEnrollmentCreateResponses];

export type MeetingsEventsExportIcsRetrieve2Data = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/export-ics/';
};

export type MeetingsEventsExportIcsRetrieve2Responses = {
    200: Blob | File;
};

export type MeetingsEventsExportIcsRetrieve2Response = MeetingsEventsExportIcsRetrieve2Responses[keyof MeetingsEventsExportIcsRetrieve2Responses];

export type MeetingsEventsMyEnrollmentDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/my-enrollment/';
};

export type MeetingsEventsMyEnrollmentDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsEventsMyEnrollmentDestroyResponse = MeetingsEventsMyEnrollmentDestroyResponses[keyof MeetingsEventsMyEnrollmentDestroyResponses];

export type MeetingsEventsMyEnrollmentRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/my-enrollment/';
};

export type MeetingsEventsMyEnrollmentRetrieveResponses = {
    200: NotNestedPublicEventParticipantEnrollment;
};

export type MeetingsEventsMyEnrollmentRetrieveResponse = MeetingsEventsMyEnrollmentRetrieveResponses[keyof MeetingsEventsMyEnrollmentRetrieveResponses];

export type MeetingsEventsMyEnrollmentCreateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) event.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/{id}/my-enrollment/';
};

export type MeetingsEventsMyEnrollmentCreateResponses = {
    201: NotNestedPublicEventParticipantEnrollment;
};

export type MeetingsEventsMyEnrollmentCreateResponse = MeetingsEventsMyEnrollmentCreateResponses[keyof MeetingsEventsMyEnrollmentCreateResponses];

export type MeetingsEventsApplyTypicalDayCreateData = {
    body: ApplyTypicalDayRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/apply-typical-day/';
};

export type MeetingsEventsApplyTypicalDayCreateResponses = {
    200: PaginatedEventList;
};

export type MeetingsEventsApplyTypicalDayCreateResponse = MeetingsEventsApplyTypicalDayCreateResponses[keyof MeetingsEventsApplyTypicalDayCreateResponses];

export type MeetingsEventsEnrollmentsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * La requête filtrera les evenement spécifique à ce participant
         */
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/enrollments/';
};

export type MeetingsEventsEnrollmentsListResponses = {
    200: PaginatedNotNestedPublicEventParticipantEnrollmentList;
};

export type MeetingsEventsEnrollmentsListResponse = MeetingsEventsEnrollmentsListResponses[keyof MeetingsEventsEnrollmentsListResponses];

export type MeetingsEventsExportIcsRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * `mine` (défaut) : planning personnel du participant courant (créneaux communs + ceux où il est inscrit / superviseur). `all` : tout le planning visible.
         */
        scope?: 'all' | 'mine';
    };
    url: '/api/meetings/{meeting_id}/events/export-ics/';
};

export type MeetingsEventsExportIcsRetrieveResponses = {
    200: Blob | File;
};

export type MeetingsEventsExportIcsRetrieveResponse = MeetingsEventsExportIcsRetrieveResponses[keyof MeetingsEventsExportIcsRetrieveResponses];

export type MeetingsEventsInChargeListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/in-charge/';
};

export type MeetingsEventsInChargeListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsInChargeListResponse = MeetingsEventsInChargeListResponses[keyof MeetingsEventsInChargeListResponses];

export type MeetingsEventsModularListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/modular/';
};

export type MeetingsEventsModularListResponses = {
    200: PaginatedModularEventList;
};

export type MeetingsEventsModularListResponse = MeetingsEventsModularListResponses[keyof MeetingsEventsModularListResponses];

export type MeetingsEventsMyDailyEventsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/my-daily-events/';
};

export type MeetingsEventsMyDailyEventsListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsMyDailyEventsListResponse = MeetingsEventsMyDailyEventsListResponses[keyof MeetingsEventsMyDailyEventsListResponses];

export type MeetingsEventsMyEnrollmentsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/my-enrollments/';
};

export type MeetingsEventsMyEnrollmentsListResponses = {
    200: PaginatedNotNestedPublicEventParticipantEnrollmentList;
};

export type MeetingsEventsMyEnrollmentsListResponse = MeetingsEventsMyEnrollmentsListResponses[keyof MeetingsEventsMyEnrollmentsListResponses];

export type MeetingsEventsOwnPlanningListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/own-planning/';
};

export type MeetingsEventsOwnPlanningListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsOwnPlanningListResponse = MeetingsEventsOwnPlanningListResponses[keyof MeetingsEventsOwnPlanningListResponses];

export type MeetingsEventsPlanningRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/events/planning/';
};

export type MeetingsEventsPlanningRetrieveResponses = {
    200: NotNestedEvent;
};

export type MeetingsEventsPlanningRetrieveResponse = MeetingsEventsPlanningRetrieveResponses[keyof MeetingsEventsPlanningRetrieveResponses];

export type MeetingsEventsPublicListListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/public-list/';
};

export type MeetingsEventsPublicListListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsPublicListListResponse = MeetingsEventsPublicListListResponses[keyof MeetingsEventsPublicListListResponses];

export type MeetingsEventsPublicModularListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/public-modular/';
};

export type MeetingsEventsPublicModularListResponses = {
    200: PaginatedPublicModularEventList;
};

export type MeetingsEventsPublicModularListResponse = MeetingsEventsPublicModularListResponses[keyof MeetingsEventsPublicModularListResponses];

export type MeetingsEventsSupervisorListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/supervisor/';
};

export type MeetingsEventsSupervisorListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsSupervisorListResponse = MeetingsEventsSupervisorListResponses[keyof MeetingsEventsSupervisorListResponses];

export type MeetingsEventsTypicalDayListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * * `JOURNEE_TYPE` - abstract
         * * `CONCRET` - concret
         * * `MODULAIRE` - modulaire
         */
        event_type?: 'CONCRET' | 'JOURNEE_TYPE' | 'MODULAIRE';
        /**
         * Les valeurs multiples doivent être séparées par des virgules.
         */
        event_type__in?: Array<string>;
        only_future?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        participant_id?: string;
        /**
         * * `participant` - Planning du participant
         * * `participant_responsible` - Evenement dont le participant est responsable / équipe en charge
         * * `participant_in_charge` - Evenement dont une équipe du participant est responsable
         * * `generic` - Planning Generique
         * * `participant_generic` - Tout les evenement possible pour un participant
         * * `typical_day` - Journée type
         */
        planning_type?: 'generic' | 'participant' | 'participant_generic' | 'participant_in_charge' | 'participant_responsible' | 'typical_day';
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/events/typical-day/';
};

export type MeetingsEventsTypicalDayListResponses = {
    200: PaginatedPublicEventList;
};

export type MeetingsEventsTypicalDayListResponse = MeetingsEventsTypicalDayListResponses[keyof MeetingsEventsTypicalDayListResponses];

export type MeetingsExportsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/exports/';
};

export type MeetingsExportsListResponses = {
    200: PaginatedDocTemplateList;
};

export type MeetingsExportsListResponse = MeetingsExportsListResponses[keyof MeetingsExportsListResponses];

export type MeetingsExportsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) doc template.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/exports/{id}/';
};

export type MeetingsExportsRetrieveResponses = {
    200: DocTemplate;
};

export type MeetingsExportsRetrieveResponse = MeetingsExportsRetrieveResponses[keyof MeetingsExportsRetrieveResponses];

export type MeetingsExportsExportRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) doc template.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/exports/{id}/export/';
};

export type MeetingsExportsExportRetrieveResponses = {
    200: DocTemplate;
};

export type MeetingsExportsExportRetrieveResponse = MeetingsExportsExportRetrieveResponses[keyof MeetingsExportsExportRetrieveResponses];

export type MeetingsFormsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/forms/';
};

export type MeetingsFormsListResponses = {
    200: Array<MeetingForm>;
};

export type MeetingsFormsListResponse = MeetingsFormsListResponses[keyof MeetingsFormsListResponses];

export type MeetingsFormsCreateData = {
    body: NotNestedMeetingFormRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/';
};

export type MeetingsFormsCreateResponses = {
    201: NotNestedMeetingForm;
};

export type MeetingsFormsCreateResponse = MeetingsFormsCreateResponses[keyof MeetingsFormsCreateResponses];

export type MeetingsFormsPublicListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/forms-public/';
};

export type MeetingsFormsPublicListResponses = {
    200: Array<MeetingPublicForm>;
};

export type MeetingsFormsPublicListResponse = MeetingsFormsPublicListResponses[keyof MeetingsFormsPublicListResponses];

export type MeetingsFormsPublicRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms-public/{id}/';
};

export type MeetingsFormsPublicRetrieveResponses = {
    200: MeetingPublicFormWithFields;
};

export type MeetingsFormsPublicRetrieveResponse = MeetingsFormsPublicRetrieveResponses[keyof MeetingsFormsPublicRetrieveResponses];

export type MeetingsFormsFieldsListData = {
    body?: never;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/';
};

export type MeetingsFormsFieldsListResponses = {
    200: Array<MeetingFormField>;
};

export type MeetingsFormsFieldsListResponse = MeetingsFormsFieldsListResponses[keyof MeetingsFormsFieldsListResponses];

export type MeetingsFormsFieldsCreateData = {
    body: MeetingFormFieldRequest;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/';
};

export type MeetingsFormsFieldsCreateResponses = {
    201: MeetingFormField;
};

export type MeetingsFormsFieldsCreateResponse = MeetingsFormsFieldsCreateResponses[keyof MeetingsFormsFieldsCreateResponses];

export type MeetingsFormsFieldsDestroyData = {
    body?: never;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form field.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/{id}/';
};

export type MeetingsFormsFieldsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsFormsFieldsDestroyResponse = MeetingsFormsFieldsDestroyResponses[keyof MeetingsFormsFieldsDestroyResponses];

export type MeetingsFormsFieldsRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form field.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/{id}/';
};

export type MeetingsFormsFieldsRetrieveResponses = {
    200: MeetingFormField;
};

export type MeetingsFormsFieldsRetrieveResponse = MeetingsFormsFieldsRetrieveResponses[keyof MeetingsFormsFieldsRetrieveResponses];

export type MeetingsFormsFieldsPartialUpdateData = {
    body?: PatchedMeetingFormFieldRequest;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form field.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/{id}/';
};

export type MeetingsFormsFieldsPartialUpdateResponses = {
    200: MeetingFormField;
};

export type MeetingsFormsFieldsPartialUpdateResponse = MeetingsFormsFieldsPartialUpdateResponses[keyof MeetingsFormsFieldsPartialUpdateResponses];

export type MeetingsFormsFieldsUpdateData = {
    body: MeetingFormFieldRequest;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form field.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/fields/{id}/';
};

export type MeetingsFormsFieldsUpdateResponses = {
    200: MeetingFormField;
};

export type MeetingsFormsFieldsUpdateResponse = MeetingsFormsFieldsUpdateResponses[keyof MeetingsFormsFieldsUpdateResponses];

export type MeetingsFormsSubmissionsListData = {
    body?: never;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/';
};

export type MeetingsFormsSubmissionsListResponses = {
    200: Array<MeetingFormSubmission>;
};

export type MeetingsFormsSubmissionsListResponse = MeetingsFormsSubmissionsListResponses[keyof MeetingsFormsSubmissionsListResponses];

export type MeetingsFormsSubmissionsCreateData = {
    body: NotNestedMeetingFormSubmissionRequest;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/';
};

export type MeetingsFormsSubmissionsCreateResponses = {
    201: NotNestedMeetingFormSubmission;
};

export type MeetingsFormsSubmissionsCreateResponse = MeetingsFormsSubmissionsCreateResponses[keyof MeetingsFormsSubmissionsCreateResponses];

export type MeetingsFormsSubmissionsDestroyData = {
    body?: never;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form submission.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/{id}/';
};

export type MeetingsFormsSubmissionsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsFormsSubmissionsDestroyResponse = MeetingsFormsSubmissionsDestroyResponses[keyof MeetingsFormsSubmissionsDestroyResponses];

export type MeetingsFormsSubmissionsRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form submission.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/{id}/';
};

export type MeetingsFormsSubmissionsRetrieveResponses = {
    200: MeetingFormSubmission;
};

export type MeetingsFormsSubmissionsRetrieveResponse = MeetingsFormsSubmissionsRetrieveResponses[keyof MeetingsFormsSubmissionsRetrieveResponses];

export type MeetingsFormsSubmissionsPartialUpdateData = {
    body?: PatchedMeetingFormSubmissionRequest;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form submission.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/{id}/';
};

export type MeetingsFormsSubmissionsPartialUpdateResponses = {
    200: MeetingFormSubmission;
};

export type MeetingsFormsSubmissionsPartialUpdateResponse = MeetingsFormsSubmissionsPartialUpdateResponses[keyof MeetingsFormsSubmissionsPartialUpdateResponses];

export type MeetingsFormsSubmissionsUpdateData = {
    body: MeetingFormSubmissionRequest;
    path: {
        /**
         * UUID of the form
         */
        form_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form submission.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{form_id}/submissions/{id}/';
};

export type MeetingsFormsSubmissionsUpdateResponses = {
    200: MeetingFormSubmission;
};

export type MeetingsFormsSubmissionsUpdateResponse = MeetingsFormsSubmissionsUpdateResponses[keyof MeetingsFormsSubmissionsUpdateResponses];

export type MeetingsFormsDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{id}/';
};

export type MeetingsFormsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsFormsDestroyResponse = MeetingsFormsDestroyResponses[keyof MeetingsFormsDestroyResponses];

export type MeetingsFormsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{id}/';
};

export type MeetingsFormsRetrieveResponses = {
    200: MeetingForm;
};

export type MeetingsFormsRetrieveResponse = MeetingsFormsRetrieveResponses[keyof MeetingsFormsRetrieveResponses];

export type MeetingsFormsPartialUpdateData = {
    body?: PatchedMeetingFormRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{id}/';
};

export type MeetingsFormsPartialUpdateResponses = {
    200: MeetingForm;
};

export type MeetingsFormsPartialUpdateResponse = MeetingsFormsPartialUpdateResponses[keyof MeetingsFormsPartialUpdateResponses];

export type MeetingsFormsUpdateData = {
    body: NotNestedMeetingFormRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{id}/';
};

export type MeetingsFormsUpdateResponses = {
    200: NotNestedMeetingForm;
};

export type MeetingsFormsUpdateResponse = MeetingsFormsUpdateResponses[keyof MeetingsFormsUpdateResponses];

export type MeetingsFormsDuplicateCreateData = {
    body?: DuplicationMeetingFormRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{id}/duplicate/';
};

export type MeetingsFormsDuplicateCreateResponses = {
    200: DuplicationMeetingForm;
};

export type MeetingsFormsDuplicateCreateResponse = MeetingsFormsDuplicateCreateResponses[keyof MeetingsFormsDuplicateCreateResponses];

export type MeetingsFormsExportSubmissionsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        format?: 'csv' | 'json' | 'png' | 'svg' | 'txt' | 'xls' | 'xlsx';
    };
    url: '/api/meetings/{meeting_id}/forms/{id}/export-submissions/';
};

export type MeetingsFormsExportSubmissionsRetrieveResponses = {
    200: MeetingFormSubmissionExport;
};

export type MeetingsFormsExportSubmissionsRetrieveResponse = MeetingsFormsExportSubmissionsRetrieveResponses[keyof MeetingsFormsExportSubmissionsRetrieveResponses];

export type MeetingsFormsPublishCreateData = {
    body?: PublishMeetingFormRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{id}/publish/';
};

export type MeetingsFormsPublishCreateResponses = {
    200: PublishMeetingForm;
};

export type MeetingsFormsPublishCreateResponse = MeetingsFormsPublishCreateResponses[keyof MeetingsFormsPublishCreateResponses];

export type MeetingsFormsUnpublishCreateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting form.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/forms/{id}/unpublish/';
};

export type MeetingsFormsUnpublishCreateResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type MeetingsInfoCampaignListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/info-campaign/';
};

export type MeetingsInfoCampaignListResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type MeetingsInfoCampaignCreateData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/info-campaign/';
};

export type MeetingsInfoCampaignCreateResponses = {
    /**
     * No response body
     */
    201: unknown;
};

export type MeetingsInfoCampaignPartialUpdateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) info campaign.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/info-campaign/{id}/';
};

export type MeetingsInfoCampaignPartialUpdateResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type MeetingsInfoCampaignUpdateData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) info campaign.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/info-campaign/{id}/';
};

export type MeetingsInfoCampaignUpdateResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type MeetingsModulesToggleCreateData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting module.
         */
        module_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/modules/{module_id}/toggle/';
};

export type MeetingsModulesToggleCreateErrors = {
    400: ToggleError;
    404: ModuleNotFoundError;
};

export type MeetingsModulesToggleCreateError = MeetingsModulesToggleCreateErrors[keyof MeetingsModulesToggleCreateErrors];

export type MeetingsModulesToggleCreateResponses = {
    200: ToggleModuleResponse;
};

export type MeetingsModulesToggleCreateResponse = MeetingsModulesToggleCreateResponses[keyof MeetingsModulesToggleCreateResponses];

export type MeetingsParticipantsListData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/participants/';
};

export type MeetingsParticipantsListResponses = {
    200: PaginatedNoCommentMeetingParticipantList;
};

export type MeetingsParticipantsListResponse = MeetingsParticipantsListResponses[keyof MeetingsParticipantsListResponses];

export type MeetingsParticipantsRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/';
};

export type MeetingsParticipantsRetrieveResponses = {
    200: MeetingParticipant;
};

export type MeetingsParticipantsRetrieveResponse = MeetingsParticipantsRetrieveResponses[keyof MeetingsParticipantsRetrieveResponses];

export type MeetingsParticipantsPartialUpdateData = {
    body?: PatchedMeetingParticipantRequest;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/';
};

export type MeetingsParticipantsPartialUpdateResponses = {
    200: MeetingParticipant;
};

export type MeetingsParticipantsPartialUpdateResponse = MeetingsParticipantsPartialUpdateResponses[keyof MeetingsParticipantsPartialUpdateResponses];

export type MeetingsParticipantsUpdateData = {
    body: MeetingParticipantRequest;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/';
};

export type MeetingsParticipantsUpdateResponses = {
    200: MeetingParticipant;
};

export type MeetingsParticipantsUpdateResponse = MeetingsParticipantsUpdateResponses[keyof MeetingsParticipantsUpdateResponses];

export type MeetingsParticipantsAvatarMediaRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/avatar-media/';
};

export type MeetingsParticipantsAvatarMediaRetrieveResponses = {
    200: MeetingParticipant;
};

export type MeetingsParticipantsAvatarMediaRetrieveResponse = MeetingsParticipantsAvatarMediaRetrieveResponses[keyof MeetingsParticipantsAvatarMediaRetrieveResponses];

export type MeetingsParticipantsAvatarMediaUpdateData = {
    body: MeetingParticipantRequest;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/avatar-media/';
};

export type MeetingsParticipantsAvatarMediaUpdateResponses = {
    200: MeetingParticipant;
};

export type MeetingsParticipantsAvatarMediaUpdateResponse = MeetingsParticipantsAvatarMediaUpdateResponses[keyof MeetingsParticipantsAvatarMediaUpdateResponses];

export type MeetingsParticipantsOpinionRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/opinion/';
};

export type MeetingsParticipantsOpinionRetrieveResponses = {
    200: OpinionParticipant;
};

export type MeetingsParticipantsOpinionRetrieveResponse = MeetingsParticipantsOpinionRetrieveResponses[keyof MeetingsParticipantsOpinionRetrieveResponses];

export type MeetingsParticipantsOpinionPartialUpdateData = {
    body?: PatchedOpinionParticipantRequest;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/opinion/';
};

export type MeetingsParticipantsOpinionPartialUpdateResponses = {
    200: OpinionParticipant;
};

export type MeetingsParticipantsOpinionPartialUpdateResponse = MeetingsParticipantsOpinionPartialUpdateResponses[keyof MeetingsParticipantsOpinionPartialUpdateResponses];

export type MeetingsParticipantsOpinionUpdateData = {
    body?: OpinionParticipantRequest;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/opinion/';
};

export type MeetingsParticipantsOpinionUpdateResponses = {
    200: OpinionParticipant;
};

export type MeetingsParticipantsOpinionUpdateResponse = MeetingsParticipantsOpinionUpdateResponses[keyof MeetingsParticipantsOpinionUpdateResponses];

export type MeetingsParticipantsResetAvatarDestroyData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/reset-avatar/';
};

export type MeetingsParticipantsResetAvatarDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsParticipantsResetAvatarDestroyResponse = MeetingsParticipantsResetAvatarDestroyResponses[keyof MeetingsParticipantsResetAvatarDestroyResponses];

export type MeetingsParticipantsResetSignatureDestroyData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/reset-signature/';
};

export type MeetingsParticipantsResetSignatureDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsParticipantsResetSignatureDestroyResponse = MeetingsParticipantsResetSignatureDestroyResponses[keyof MeetingsParticipantsResetSignatureDestroyResponses];

export type MeetingsParticipantsSignatureMediaRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/signature-media/';
};

export type MeetingsParticipantsSignatureMediaRetrieveResponses = {
    200: MeetingParticipant;
};

export type MeetingsParticipantsSignatureMediaRetrieveResponse = MeetingsParticipantsSignatureMediaRetrieveResponses[keyof MeetingsParticipantsSignatureMediaRetrieveResponses];

export type MeetingsParticipantsSignatureMediaUpdateData = {
    body: MeetingParticipantRequest;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{id}/signature-media/';
};

export type MeetingsParticipantsSignatureMediaUpdateResponses = {
    200: MeetingParticipant;
};

export type MeetingsParticipantsSignatureMediaUpdateResponse = MeetingsParticipantsSignatureMediaUpdateResponses[keyof MeetingsParticipantsSignatureMediaUpdateResponses];

export type MeetingsParticipantsCommentsListData = {
    body?: never;
    path: {
        meeting_id: string;
        participant_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/';
};

export type MeetingsParticipantsCommentsListResponses = {
    200: PaginatedMeetingCommentList;
};

export type MeetingsParticipantsCommentsListResponse = MeetingsParticipantsCommentsListResponses[keyof MeetingsParticipantsCommentsListResponses];

export type MeetingsParticipantsCommentsCreateData = {
    body: MeetingCommentRequest;
    path: {
        meeting_id: string;
        participant_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/';
};

export type MeetingsParticipantsCommentsCreateResponses = {
    201: MeetingComment;
};

export type MeetingsParticipantsCommentsCreateResponse = MeetingsParticipantsCommentsCreateResponses[keyof MeetingsParticipantsCommentsCreateResponses];

export type MeetingsParticipantsCommentsDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting comment.
         */
        id: string;
        meeting_id: string;
        participant_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/{id}/';
};

export type MeetingsParticipantsCommentsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsParticipantsCommentsDestroyResponse = MeetingsParticipantsCommentsDestroyResponses[keyof MeetingsParticipantsCommentsDestroyResponses];

export type MeetingsParticipantsCommentsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting comment.
         */
        id: string;
        meeting_id: string;
        participant_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/{id}/';
};

export type MeetingsParticipantsCommentsRetrieveResponses = {
    200: MeetingComment;
};

export type MeetingsParticipantsCommentsRetrieveResponse = MeetingsParticipantsCommentsRetrieveResponses[keyof MeetingsParticipantsCommentsRetrieveResponses];

export type MeetingsParticipantsCommentsPartialUpdateData = {
    body?: PatchedMeetingCommentRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting comment.
         */
        id: string;
        meeting_id: string;
        participant_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/{id}/';
};

export type MeetingsParticipantsCommentsPartialUpdateResponses = {
    200: MeetingComment;
};

export type MeetingsParticipantsCommentsPartialUpdateResponse = MeetingsParticipantsCommentsPartialUpdateResponses[keyof MeetingsParticipantsCommentsPartialUpdateResponses];

export type MeetingsParticipantsCommentsUpdateData = {
    body: MeetingCommentRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) meeting comment.
         */
        id: string;
        meeting_id: string;
        participant_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/participants/{participant_id}/comments/{id}/';
};

export type MeetingsParticipantsCommentsUpdateResponses = {
    200: MeetingComment;
};

export type MeetingsParticipantsCommentsUpdateResponse = MeetingsParticipantsCommentsUpdateResponses[keyof MeetingsParticipantsCommentsUpdateResponses];

export type MeetingsParticipantsOpinionListListData = {
    body?: never;
    path: {
        /**
         * UUID of the participant
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/participants/opinion-list/';
};

export type MeetingsParticipantsOpinionListListResponses = {
    200: PaginatedOpinionParticipantList;
};

export type MeetingsParticipantsOpinionListListResponse = MeetingsParticipantsOpinionListListResponses[keyof MeetingsParticipantsOpinionListListResponses];

export type MeetingsResourcesCreateData = {
    body: CreateNotNestedResourceRequestWritable;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources/';
};

export type MeetingsResourcesCreateResponses = {
    201: PublicNotNestedResource;
};

export type MeetingsResourcesCreateResponse = MeetingsResourcesCreateResponses[keyof MeetingsResourcesCreateResponses];

export type MeetingsResourcesPublicCreateData = {
    body: CreatePublicNotNestedResourceRequestWritable;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources-public/';
};

export type MeetingsResourcesPublicCreateResponses = {
    201: PublicNotNestedResource;
};

export type MeetingsResourcesPublicCreateResponse = MeetingsResourcesPublicCreateResponses[keyof MeetingsResourcesPublicCreateResponses];

export type MeetingsResourcesPublicRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources-public/{id}/';
};

export type MeetingsResourcesPublicRetrieveResponses = {
    200: PublicNotNestedResource;
};

export type MeetingsResourcesPublicRetrieveResponse = MeetingsResourcesPublicRetrieveResponses[keyof MeetingsResourcesPublicRetrieveResponses];

export type MeetingsResourcesPublicPartialUpdateData = {
    body?: PatchedPublicNotNestedResourceRequestWritable;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources-public/{id}/';
};

export type MeetingsResourcesPublicPartialUpdateResponses = {
    200: PublicNotNestedResource;
};

export type MeetingsResourcesPublicPartialUpdateResponse = MeetingsResourcesPublicPartialUpdateResponses[keyof MeetingsResourcesPublicPartialUpdateResponses];

export type MeetingsResourcesPublicUpdateData = {
    body: CreatePublicNotNestedResourceRequestWritable;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources-public/{id}/';
};

export type MeetingsResourcesPublicUpdateResponses = {
    200: CreatePublicNotNestedResource;
};

export type MeetingsResourcesPublicUpdateResponse = MeetingsResourcesPublicUpdateResponses[keyof MeetingsResourcesPublicUpdateResponses];

export type MeetingsResourcesPublicResourceMediaRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources-public/{id}/resource-media/';
};

export type MeetingsResourcesPublicResourceMediaRetrieveResponses = {
    200: PublicNotNestedResource;
};

export type MeetingsResourcesPublicResourceMediaRetrieveResponse = MeetingsResourcesPublicResourceMediaRetrieveResponses[keyof MeetingsResourcesPublicResourceMediaRetrieveResponses];

export type MeetingsResourcesPublicResourceMediaUpdateData = {
    body: PublicNotNestedResourceRequestWritable;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources-public/{id}/resource-media/';
};

export type MeetingsResourcesPublicResourceMediaUpdateResponses = {
    200: PublicNotNestedResource;
};

export type MeetingsResourcesPublicResourceMediaUpdateResponse = MeetingsResourcesPublicResourceMediaUpdateResponses[keyof MeetingsResourcesPublicResourceMediaUpdateResponses];

export type MeetingsResourcesPublicTreeRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources-public/tree/';
};

export type MeetingsResourcesPublicTreeRetrieveResponses = {
    200: PublicResourceTreeList;
};

export type MeetingsResourcesPublicTreeRetrieveResponse = MeetingsResourcesPublicTreeRetrieveResponses[keyof MeetingsResourcesPublicTreeRetrieveResponses];

export type MeetingsResourcesDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources/{id}/';
};

export type MeetingsResourcesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsResourcesDestroyResponse = MeetingsResourcesDestroyResponses[keyof MeetingsResourcesDestroyResponses];

export type MeetingsResourcesRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources/{id}/';
};

export type MeetingsResourcesRetrieveResponses = {
    200: NotNestedResource;
};

export type MeetingsResourcesRetrieveResponse = MeetingsResourcesRetrieveResponses[keyof MeetingsResourcesRetrieveResponses];

export type MeetingsResourcesPartialUpdateData = {
    body?: PatchedNotNestedResourceRequestWritable;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources/{id}/';
};

export type MeetingsResourcesPartialUpdateResponses = {
    200: NotNestedResource;
};

export type MeetingsResourcesPartialUpdateResponse = MeetingsResourcesPartialUpdateResponses[keyof MeetingsResourcesPartialUpdateResponses];

export type MeetingsResourcesUpdateData = {
    body: CreateNotNestedResourceRequestWritable;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources/{id}/';
};

export type MeetingsResourcesUpdateResponses = {
    200: CreateNotNestedResource;
};

export type MeetingsResourcesUpdateResponse = MeetingsResourcesUpdateResponses[keyof MeetingsResourcesUpdateResponses];

export type MeetingsResourcesResourceMediaRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources/{id}/resource-media/';
};

export type MeetingsResourcesResourceMediaRetrieveResponses = {
    200: NotNestedResource;
};

export type MeetingsResourcesResourceMediaRetrieveResponse = MeetingsResourcesResourceMediaRetrieveResponses[keyof MeetingsResourcesResourceMediaRetrieveResponses];

export type MeetingsResourcesResourceMediaUpdateData = {
    body: NotNestedResourceRequestWritable;
    path: {
        /**
         * Un(une) valeur unique identifiant ce(cette) resource.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources/{id}/resource-media/';
};

export type MeetingsResourcesResourceMediaUpdateResponses = {
    200: NotNestedResource;
};

export type MeetingsResourcesResourceMediaUpdateResponse = MeetingsResourcesResourceMediaUpdateResponses[keyof MeetingsResourcesResourceMediaUpdateResponses];

export type MeetingsResourcesTreeRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources/tree/';
};

export type MeetingsResourcesTreeRetrieveResponses = {
    200: ResourceTreeList;
};

export type MeetingsResourcesTreeRetrieveResponse = MeetingsResourcesTreeRetrieveResponses[keyof MeetingsResourcesTreeRetrieveResponses];

export type MeetingsResourcesUrlTemplatePlaceholdersRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/resources/url-template-placeholders/';
};

export type MeetingsResourcesUrlTemplatePlaceholdersRetrieveResponses = {
    200: {
        [key: string]: unknown;
    };
};

export type MeetingsResourcesUrlTemplatePlaceholdersRetrieveResponse = MeetingsResourcesUrlTemplatePlaceholdersRetrieveResponses[keyof MeetingsResourcesUrlTemplatePlaceholdersRetrieveResponses];

export type MeetingsRoomsListData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: {
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/rooms/';
};

export type MeetingsRoomsListResponses = {
    200: PaginatedNotNestedRoomWithEventList;
};

export type MeetingsRoomsListResponse = MeetingsRoomsListResponses[keyof MeetingsRoomsListResponses];

export type MeetingsRoomsCreateData = {
    body: NotNestedRoomWithEventRequest;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/rooms/';
};

export type MeetingsRoomsCreateResponses = {
    201: NotNestedRoomWithEvent;
};

export type MeetingsRoomsCreateResponse = MeetingsRoomsCreateResponses[keyof MeetingsRoomsCreateResponses];

export type MeetingsRoomsDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) room.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/rooms/{id}/';
};

export type MeetingsRoomsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsRoomsDestroyResponse = MeetingsRoomsDestroyResponses[keyof MeetingsRoomsDestroyResponses];

export type MeetingsRoomsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) room.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/rooms/{id}/';
};

export type MeetingsRoomsRetrieveResponses = {
    200: NotNestedRoomWithEvent;
};

export type MeetingsRoomsRetrieveResponse = MeetingsRoomsRetrieveResponses[keyof MeetingsRoomsRetrieveResponses];

export type MeetingsRoomsPartialUpdateData = {
    body?: PatchedNotNestedRoomWithEventRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) room.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/rooms/{id}/';
};

export type MeetingsRoomsPartialUpdateResponses = {
    200: NotNestedRoomWithEvent;
};

export type MeetingsRoomsPartialUpdateResponse = MeetingsRoomsPartialUpdateResponses[keyof MeetingsRoomsPartialUpdateResponses];

export type MeetingsRoomsUpdateData = {
    body: NotNestedRoomWithEventRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) room.
         */
        id: string;
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/rooms/{id}/';
};

export type MeetingsRoomsUpdateResponses = {
    200: NotNestedRoomWithEvent;
};

export type MeetingsRoomsUpdateResponse = MeetingsRoomsUpdateResponses[keyof MeetingsRoomsUpdateResponses];

export type MeetingsTableExportsParticipantEnrollementsRetrieveData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/table-exports/participant-enrollements/';
};

export type MeetingsTableExportsParticipantEnrollementsRetrieveResponses = {
    200: ParticipantEnrollementList;
};

export type MeetingsTableExportsParticipantEnrollementsRetrieveResponse = MeetingsTableExportsParticipantEnrollementsRetrieveResponses[keyof MeetingsTableExportsParticipantEnrollementsRetrieveResponses];

export type MeetingsTableExportsParticipantListRetrieveData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/table-exports/participant-list/';
};

export type MeetingsTableExportsParticipantListRetrieveResponses = {
    200: ParticipantList;
};

export type MeetingsTableExportsParticipantListRetrieveResponse = MeetingsTableExportsParticipantListRetrieveResponses[keyof MeetingsTableExportsParticipantListRetrieveResponses];

export type MeetingsTableExportsParticipantListDirectionRetrieveData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/table-exports/participant-list-direction/';
};

export type MeetingsTableExportsParticipantListDirectionRetrieveResponses = {
    200: ParticipantListDirection;
};

export type MeetingsTableExportsParticipantListDirectionRetrieveResponse = MeetingsTableExportsParticipantListDirectionRetrieveResponses[keyof MeetingsTableExportsParticipantListDirectionRetrieveResponses];

export type MeetingsTableExportsProcesVerbalRetrieveData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/table-exports/proces-verbal/';
};

export type MeetingsTableExportsProcesVerbalRetrieveResponses = {
    200: Pv;
};

export type MeetingsTableExportsProcesVerbalRetrieveResponse = MeetingsTableExportsProcesVerbalRetrieveResponses[keyof MeetingsTableExportsProcesVerbalRetrieveResponses];

export type MeetingsTableExportsTeamsdailytasksbytaskRetrieveData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/table-exports/teamsdailytasksbytask/';
};

export type MeetingsTableExportsTeamsdailytasksbytaskRetrieveResponses = {
    200: PandasTeamDailyTaskByTask;
};

export type MeetingsTableExportsTeamsdailytasksbytaskRetrieveResponse = MeetingsTableExportsTeamsdailytasksbytaskRetrieveResponses[keyof MeetingsTableExportsTeamsdailytasksbytaskRetrieveResponses];

export type MeetingsTableExportsTeamsdailytasksbyteamRetrieveData = {
    body?: never;
    path: {
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/table-exports/teamsdailytasksbyteam/';
};

export type MeetingsTableExportsTeamsdailytasksbyteamRetrieveResponses = {
    200: PandasTeamDailyTaskByTeam;
};

export type MeetingsTableExportsTeamsdailytasksbyteamRetrieveResponse = MeetingsTableExportsTeamsdailytasksbyteamRetrieveResponses[keyof MeetingsTableExportsTeamsdailytasksbyteamRetrieveResponses];

export type MeetingsTeamDailyTasksListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/team-daily-tasks/';
};

export type MeetingsTeamDailyTasksListResponses = {
    200: Array<TeamDailyTask>;
};

export type MeetingsTeamDailyTasksListResponse = MeetingsTeamDailyTasksListResponses[keyof MeetingsTeamDailyTasksListResponses];

export type MeetingsTeamDailyTasksCreateData = {
    body: TeamDailyTaskRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/team-daily-tasks/';
};

export type MeetingsTeamDailyTasksCreateResponses = {
    201: TeamDailyTask;
};

export type MeetingsTeamDailyTasksCreateResponse = MeetingsTeamDailyTasksCreateResponses[keyof MeetingsTeamDailyTasksCreateResponses];

export type MeetingsTeamDailyTasksDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team daily task.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/team-daily-tasks/{id}/';
};

export type MeetingsTeamDailyTasksDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsTeamDailyTasksDestroyResponse = MeetingsTeamDailyTasksDestroyResponses[keyof MeetingsTeamDailyTasksDestroyResponses];

export type MeetingsTeamDailyTasksRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team daily task.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/team-daily-tasks/{id}/';
};

export type MeetingsTeamDailyTasksRetrieveResponses = {
    200: TeamDailyTask;
};

export type MeetingsTeamDailyTasksRetrieveResponse = MeetingsTeamDailyTasksRetrieveResponses[keyof MeetingsTeamDailyTasksRetrieveResponses];

export type MeetingsTeamDailyTasksPartialUpdateData = {
    body?: PatchedTeamDailyTaskRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team daily task.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/team-daily-tasks/{id}/';
};

export type MeetingsTeamDailyTasksPartialUpdateResponses = {
    200: TeamDailyTask;
};

export type MeetingsTeamDailyTasksPartialUpdateResponse = MeetingsTeamDailyTasksPartialUpdateResponses[keyof MeetingsTeamDailyTasksPartialUpdateResponses];

export type MeetingsTeamDailyTasksUpdateData = {
    body: TeamDailyTaskRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team daily task.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/team-daily-tasks/{id}/';
};

export type MeetingsTeamDailyTasksUpdateResponses = {
    200: TeamDailyTask;
};

export type MeetingsTeamDailyTasksUpdateResponse = MeetingsTeamDailyTasksUpdateResponses[keyof MeetingsTeamDailyTasksUpdateResponses];

export type MeetingsTeamsListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/teams/';
};

export type MeetingsTeamsListResponses = {
    200: PaginatedTeamList;
};

export type MeetingsTeamsListResponse = MeetingsTeamsListResponses[keyof MeetingsTeamsListResponses];

export type MeetingsTeamsCreateData = {
    body: NotNestedTeamRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams/';
};

export type MeetingsTeamsCreateResponses = {
    201: NotNestedTeam;
};

export type MeetingsTeamsCreateResponse = MeetingsTeamsCreateResponses[keyof MeetingsTeamsCreateResponses];

export type MeetingsTeamsCategoriesListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/teams-categories/';
};

export type MeetingsTeamsCategoriesListResponses = {
    200: Array<NotNestedPublicTeamCategory>;
};

export type MeetingsTeamsCategoriesListResponse = MeetingsTeamsCategoriesListResponses[keyof MeetingsTeamsCategoriesListResponses];

export type MeetingsTeamsCategoriesCreateData = {
    body: NotNestedPublicTeamCategoryRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams-categories/';
};

export type MeetingsTeamsCategoriesCreateResponses = {
    201: NotNestedPublicTeamCategory;
};

export type MeetingsTeamsCategoriesCreateResponse = MeetingsTeamsCategoriesCreateResponses[keyof MeetingsTeamsCategoriesCreateResponses];

export type MeetingsTeamsCategoriesDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team category.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams-categories/{id}/';
};

export type MeetingsTeamsCategoriesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsTeamsCategoriesDestroyResponse = MeetingsTeamsCategoriesDestroyResponses[keyof MeetingsTeamsCategoriesDestroyResponses];

export type MeetingsTeamsCategoriesRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team category.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams-categories/{id}/';
};

export type MeetingsTeamsCategoriesRetrieveResponses = {
    200: NotNestedPublicTeamCategory;
};

export type MeetingsTeamsCategoriesRetrieveResponse = MeetingsTeamsCategoriesRetrieveResponses[keyof MeetingsTeamsCategoriesRetrieveResponses];

export type MeetingsTeamsCategoriesPartialUpdateData = {
    body?: PatchedNotNestedPublicTeamCategoryRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team category.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams-categories/{id}/';
};

export type MeetingsTeamsCategoriesPartialUpdateResponses = {
    200: NotNestedPublicTeamCategory;
};

export type MeetingsTeamsCategoriesPartialUpdateResponse = MeetingsTeamsCategoriesPartialUpdateResponses[keyof MeetingsTeamsCategoriesPartialUpdateResponses];

export type MeetingsTeamsCategoriesUpdateData = {
    body: NotNestedPublicTeamCategoryRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team category.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams-categories/{id}/';
};

export type MeetingsTeamsCategoriesUpdateResponses = {
    200: NotNestedPublicTeamCategory;
};

export type MeetingsTeamsCategoriesUpdateResponse = MeetingsTeamsCategoriesUpdateResponses[keyof MeetingsTeamsCategoriesUpdateResponses];

export type MeetingsTeamsDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams/{id}/';
};

export type MeetingsTeamsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsTeamsDestroyResponse = MeetingsTeamsDestroyResponses[keyof MeetingsTeamsDestroyResponses];

export type MeetingsTeamsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams/{id}/';
};

export type MeetingsTeamsRetrieveResponses = {
    200: Team;
};

export type MeetingsTeamsRetrieveResponse = MeetingsTeamsRetrieveResponses[keyof MeetingsTeamsRetrieveResponses];

export type MeetingsTeamsPartialUpdateData = {
    body?: PatchedTeamRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams/{id}/';
};

export type MeetingsTeamsPartialUpdateResponses = {
    200: Team;
};

export type MeetingsTeamsPartialUpdateResponse = MeetingsTeamsPartialUpdateResponses[keyof MeetingsTeamsPartialUpdateResponses];

export type MeetingsTeamsUpdateData = {
    body: NotNestedTeamRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams/{id}/';
};

export type MeetingsTeamsUpdateResponses = {
    200: NotNestedTeam;
};

export type MeetingsTeamsUpdateResponse = MeetingsTeamsUpdateResponses[keyof MeetingsTeamsUpdateResponses];

export type MeetingsTeamsParticipantsRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams/{id}/participants/';
};

export type MeetingsTeamsParticipantsRetrieveResponses = {
    200: ParticipantsTeam;
};

export type MeetingsTeamsParticipantsRetrieveResponse = MeetingsTeamsParticipantsRetrieveResponses[keyof MeetingsTeamsParticipantsRetrieveResponses];

export type MeetingsTeamsParticipantsUpdateData = {
    body: ParticipantsTeamRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) team.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/teams/{id}/participants/';
};

export type MeetingsTeamsParticipantsUpdateResponses = {
    200: ParticipantsTeam;
};

export type MeetingsTeamsParticipantsUpdateResponse = MeetingsTeamsParticipantsUpdateResponses[keyof MeetingsTeamsParticipantsUpdateResponses];

export type MeetingsTracksListData = {
    body?: never;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: {
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/meetings/{meeting_id}/tracks/';
};

export type MeetingsTracksListResponses = {
    200: PaginatedTrackList;
};

export type MeetingsTracksListResponse = MeetingsTracksListResponses[keyof MeetingsTracksListResponses];

export type MeetingsTracksCreateData = {
    body: TrackRequest;
    path: {
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/tracks/';
};

export type MeetingsTracksCreateResponses = {
    201: Track;
};

export type MeetingsTracksCreateResponse = MeetingsTracksCreateResponses[keyof MeetingsTracksCreateResponses];

export type MeetingsTracksDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) track.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/tracks/{id}/';
};

export type MeetingsTracksDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type MeetingsTracksDestroyResponse = MeetingsTracksDestroyResponses[keyof MeetingsTracksDestroyResponses];

export type MeetingsTracksRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) track.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/tracks/{id}/';
};

export type MeetingsTracksRetrieveResponses = {
    200: Track;
};

export type MeetingsTracksRetrieveResponse = MeetingsTracksRetrieveResponses[keyof MeetingsTracksRetrieveResponses];

export type MeetingsTracksPartialUpdateData = {
    body?: PatchedTrackRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) track.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/tracks/{id}/';
};

export type MeetingsTracksPartialUpdateResponses = {
    200: Track;
};

export type MeetingsTracksPartialUpdateResponse = MeetingsTracksPartialUpdateResponses[keyof MeetingsTracksPartialUpdateResponses];

export type MeetingsTracksUpdateData = {
    body: TrackRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) track.
         */
        id: string;
        /**
         * UUID of the meeting
         */
        meeting_id: string;
    };
    query?: never;
    url: '/api/meetings/{meeting_id}/tracks/{id}/';
};

export type MeetingsTracksUpdateResponses = {
    200: Track;
};

export type MeetingsTracksUpdateResponse = MeetingsTracksUpdateResponses[keyof MeetingsTracksUpdateResponses];

export type ParticipantsExportsProcesVerbalRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * UUID of the centre de ressource
         */
        centre_ressource?: string;
        /**
         * Filter participation by date
         */
        end_date?: Date;
        /**
         * List of meeting_types
         */
        meeting_type?: Array<string>;
        /**
         * Filter participation by date
         */
        start_date?: Date;
        /**
         * only includes meeting with opinions
         */
        with_has_opinions?: boolean;
    };
    url: '/api/participants-exports/proces-verbal/';
};

export type ParticipantsExportsProcesVerbalRetrieveResponses = {
    200: Pv;
};

export type ParticipantsExportsProcesVerbalRetrieveResponse = ParticipantsExportsProcesVerbalRetrieveResponses[keyof ParticipantsExportsProcesVerbalRetrieveResponses];

export type PlacesListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/places/';
};

export type PlacesListResponses = {
    200: PaginatedNotNestedPlaceList;
};

export type PlacesListResponse = PlacesListResponses[keyof PlacesListResponses];

export type PlacesRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) place.
         */
        id: string;
    };
    query?: never;
    url: '/api/places/{id}/';
};

export type PlacesRetrieveResponses = {
    200: NotNestedPlace;
};

export type PlacesRetrieveResponse = PlacesRetrieveResponses[keyof PlacesRetrieveResponses];

export type SchemaRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        format?: 'json' | 'yaml';
        lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'ckb' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant';
    };
    url: '/api/schema/';
};

export type SchemaRetrieveResponses = {
    200: {
        [key: string]: unknown;
    };
};

export type SchemaRetrieveResponse = SchemaRetrieveResponses[keyof SchemaRetrieveResponses];

export type StructureExportsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * UUID of the centre de ressource
         */
        centre_ressource?: string;
        /**
         * Filter participation by date
         */
        end_date?: Date;
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * List of meeting_types
         */
        meeting_type?: Array<string>;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        /**
         * Filter participation by date
         */
        start_date?: Date;
    };
    url: '/api/structure-exports/';
};

export type StructureExportsListResponses = {
    200: PaginatedParticipantStructureList;
};

export type StructureExportsListResponse = StructureExportsListResponses[keyof StructureExportsListResponses];

export type StructureExportsExportRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) structure.
         */
        structure_id: string;
    };
    query?: {
        /**
         * UUID of the centre de ressource
         */
        centre_ressource?: string;
        /**
         * UUID of the doctemplate used for this export
         */
        doc_template?: string;
        /**
         * Filter participation by date
         */
        end_date?: Date;
        /**
         * List of meeting_types
         */
        meeting_type?: Array<string>;
        /**
         * Filter participation by date
         */
        start_date?: Date;
    };
    url: '/api/structure-exports/{structure_id}/export/';
};

export type StructureExportsExportRetrieveResponses = {
    200: ParticipantStructure;
};

export type StructureExportsExportRetrieveResponse = StructureExportsExportRetrieveResponses[keyof StructureExportsExportRetrieveResponses];

export type StructureExportsListByGroupeListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * UUID of the centre de ressource
         */
        centre_ressource?: string;
        /**
         * Filter participation by date
         */
        end_date?: Date;
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * List of meeting_types
         */
        meeting_type?: Array<string>;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        /**
         * Filter participation by date
         */
        start_date?: Date;
    };
    url: '/api/structure-exports/list-by-groupe/';
};

export type StructureExportsListByGroupeListResponses = {
    200: PaginatedParticipantStructureList;
};

export type StructureExportsListByGroupeListResponse = StructureExportsListByGroupeListResponses[keyof StructureExportsListByGroupeListResponses];

export type StructureExportsListByTerritoireListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * UUID of the centre de ressource
         */
        centre_ressource?: string;
        /**
         * Filter participation by date
         */
        end_date?: Date;
        /**
         * Nombre de résultats à retourner par page.
         */
        limit?: number;
        /**
         * List of meeting_types
         */
        meeting_type?: Array<string>;
        /**
         * L'index initial depuis lequel retourner les résultats.
         */
        offset?: number;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
        /**
         * Filter participation by date
         */
        start_date?: Date;
    };
    url: '/api/structure-exports/list-by-territoire/';
};

export type StructureExportsListByTerritoireListResponses = {
    200: PaginatedParticipantStructureList;
};

export type StructureExportsListByTerritoireListResponse = StructureExportsListByTerritoireListResponses[keyof StructureExportsListByTerritoireListResponses];

export type StructuresCentresRessourceListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/structures/centres-ressource/';
};

export type StructuresCentresRessourceListResponses = {
    200: PaginatedReadonlyStructureList;
};

export type StructuresCentresRessourceListResponse = StructuresCentresRessourceListResponses[keyof StructuresCentresRessourceListResponses];

export type StructuresOrganisatriceListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Limiter la liste des structures organisatrices aux structures dont l'utilisateur courant est membre
         */
        only_mine?: boolean;
        /**
         * Limiter la liste des structures organisatrices aux structures nationales
         */
        only_national?: boolean;
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un numéro de page de l'ensemble des résultats.
         */
        page?: number;
        /**
         * Nombre de résultats à retourner par page.
         */
        page_size?: number;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/structures/organisatrice/';
};

export type StructuresOrganisatriceListResponses = {
    200: PaginatedReadonlyStructureList;
};

export type StructuresOrganisatriceListResponse = StructuresOrganisatriceListResponses[keyof StructuresOrganisatriceListResponses];

export type UsersDeontologieEnableCreateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/users-deontologie/enable/';
};

export type UsersDeontologieEnableCreateResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type UsersRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/users/{id}/';
};

export type UsersRetrieveResponses = {
    200: ReadOnlyNotNestedUser;
};

export type UsersRetrieveResponse = UsersRetrieveResponses[keyof UsersRetrieveResponses];

export type UsersAvatarMediaRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/users/{id}/avatar-media/';
};

export type UsersAvatarMediaRetrieveResponses = {
    200: ReadOnlyNotNestedUser;
};

export type UsersAvatarMediaRetrieveResponse = UsersAvatarMediaRetrieveResponses[keyof UsersAvatarMediaRetrieveResponses];

export type UsersAvatarMediaUpdateData = {
    body: ReadOnlyNotNestedUserRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/users/{id}/avatar-media/';
};

export type UsersAvatarMediaUpdateResponses = {
    200: ReadOnlyNotNestedUser;
};

export type UsersAvatarMediaUpdateResponse = UsersAvatarMediaUpdateResponses[keyof UsersAvatarMediaUpdateResponses];

export type UsersResetAvatarDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/users/{id}/reset-avatar/';
};

export type UsersResetAvatarDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type UsersResetAvatarDestroyResponse = UsersResetAvatarDestroyResponses[keyof UsersResetAvatarDestroyResponses];

export type UsersResetSignatureDestroyData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/users/{id}/reset-signature/';
};

export type UsersResetSignatureDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type UsersResetSignatureDestroyResponse = UsersResetSignatureDestroyResponses[keyof UsersResetSignatureDestroyResponses];

export type UsersSignatureMediaRetrieveData = {
    body?: never;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/users/{id}/signature-media/';
};

export type UsersSignatureMediaRetrieveResponses = {
    200: ReadOnlyNotNestedUser;
};

export type UsersSignatureMediaRetrieveResponse = UsersSignatureMediaRetrieveResponses[keyof UsersSignatureMediaRetrieveResponses];

export type UsersSignatureMediaUpdateData = {
    body: ReadOnlyNotNestedUserRequest;
    path: {
        /**
         * Un(une) Chaîne UUID identifiant ce(cette) user.
         */
        id: string;
    };
    query?: never;
    url: '/api/users/{id}/signature-media/';
};

export type UsersSignatureMediaUpdateResponses = {
    200: ReadOnlyNotNestedUser;
};

export type UsersSignatureMediaUpdateResponse = UsersSignatureMediaUpdateResponses[keyof UsersSignatureMediaUpdateResponses];

export type UsersDiplomasListData = {
    body?: never;
    path: {
        /**
         * UUID of the diploma
         */
        id: string;
        /**
         * UUID of the user
         */
        user_id: string;
    };
    query?: {
        /**
         * Quel champ utiliser pour classer les résultats.
         */
        ordering?: string;
        /**
         * Un terme de recherche.
         */
        search?: string;
    };
    url: '/api/users/{user_id}/diplomas/';
};

export type UsersDiplomasListResponses = {
    200: Array<NotNestedDiploma>;
};

export type UsersDiplomasListResponse = UsersDiplomasListResponses[keyof UsersDiplomasListResponses];

export type UsersDiplomasCreateData = {
    body: NotNestedDiplomaRequest;
    path: {
        /**
         * UUID of the diploma
         */
        id: string;
        /**
         * UUID of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/api/users/{user_id}/diplomas/';
};

export type UsersDiplomasCreateResponses = {
    201: NotNestedDiploma;
};

export type UsersDiplomasCreateResponse = UsersDiplomasCreateResponses[keyof UsersDiplomasCreateResponses];

export type UsersDiplomasDestroyData = {
    body?: never;
    path: {
        /**
         * UUID of the diploma
         */
        id: string;
        /**
         * UUID of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/api/users/{user_id}/diplomas/{id}/';
};

export type UsersDiplomasDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type UsersDiplomasDestroyResponse = UsersDiplomasDestroyResponses[keyof UsersDiplomasDestroyResponses];

export type UsersDiplomasRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the diploma
         */
        id: string;
        /**
         * UUID of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/api/users/{user_id}/diplomas/{id}/';
};

export type UsersDiplomasRetrieveResponses = {
    200: NotNestedDiploma;
};

export type UsersDiplomasRetrieveResponse = UsersDiplomasRetrieveResponses[keyof UsersDiplomasRetrieveResponses];

export type UsersDiplomasPartialUpdateData = {
    body?: PatchedNotNestedDiplomaRequest;
    path: {
        /**
         * UUID of the diploma
         */
        id: string;
        /**
         * UUID of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/api/users/{user_id}/diplomas/{id}/';
};

export type UsersDiplomasPartialUpdateResponses = {
    200: NotNestedDiploma;
};

export type UsersDiplomasPartialUpdateResponse = UsersDiplomasPartialUpdateResponses[keyof UsersDiplomasPartialUpdateResponses];

export type UsersDiplomasUpdateData = {
    body: NotNestedDiplomaRequest;
    path: {
        /**
         * UUID of the diploma
         */
        id: string;
        /**
         * UUID of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/api/users/{user_id}/diplomas/{id}/';
};

export type UsersDiplomasUpdateResponses = {
    200: NotNestedDiploma;
};

export type UsersDiplomasUpdateResponse = UsersDiplomasUpdateResponses[keyof UsersDiplomasUpdateResponses];

export type UsersDiplomasDiplomaMediaRetrieveData = {
    body?: never;
    path: {
        /**
         * UUID of the diploma
         */
        id: string;
        /**
         * UUID of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/api/users/{user_id}/diplomas/{id}/diploma-media/';
};

export type UsersDiplomasDiplomaMediaRetrieveResponses = {
    200: NotNestedDiploma;
};

export type UsersDiplomasDiplomaMediaRetrieveResponse = UsersDiplomasDiplomaMediaRetrieveResponses[keyof UsersDiplomasDiplomaMediaRetrieveResponses];

export type UsersDiplomasDiplomaMediaUpdateData = {
    body: NotNestedDiplomaRequest;
    path: {
        /**
         * UUID of the diploma
         */
        id: string;
        /**
         * UUID of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/api/users/{user_id}/diplomas/{id}/diploma-media/';
};

export type UsersDiplomasDiplomaMediaUpdateResponses = {
    200: NotNestedDiploma;
};

export type UsersDiplomasDiplomaMediaUpdateResponse = UsersDiplomasDiplomaMediaUpdateResponses[keyof UsersDiplomasDiplomaMediaUpdateResponses];

export type UsersAccessRightsRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/users/access-rights/';
};

export type UsersAccessRightsRetrieveResponses = {
    200: UserAccessRights;
};

export type UsersAccessRightsRetrieveResponse = UsersAccessRightsRetrieveResponses[keyof UsersAccessRightsRetrieveResponses];

export type UsersMeRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/users/me/';
};

export type UsersMeRetrieveResponses = {
    200: SgdfUserDetails;
};

export type UsersMeRetrieveResponse = UsersMeRetrieveResponses[keyof UsersMeRetrieveResponses];

export type WebhooksCronMeetingCreateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/webhooks/cron/meeting/';
};

export type WebhooksCronMeetingCreateResponses = {
    200: ReadonlyMeeting;
};

export type WebhooksCronMeetingCreateResponse = WebhooksCronMeetingCreateResponses[keyof WebhooksCronMeetingCreateResponses];

export type WebhooksCronMeetingParticipantCreateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/webhooks/cron/meeting-participant/';
};

export type WebhooksCronMeetingParticipantCreateResponses = {
    200: ReadonlyMeeting;
};

export type WebhooksCronMeetingParticipantCreateResponse = WebhooksCronMeetingParticipantCreateResponses[keyof WebhooksCronMeetingParticipantCreateResponses];

export type WebhooksCronMeetingTypeCreateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/webhooks/cron/meeting-type/';
};

export type WebhooksCronMeetingTypeCreateResponses = {
    200: MeetingType;
};

export type WebhooksCronMeetingTypeCreateResponse = WebhooksCronMeetingTypeCreateResponses[keyof WebhooksCronMeetingTypeCreateResponses];

export type WebhooksCronPlaceCreateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/webhooks/cron/place/';
};

export type WebhooksCronPlaceCreateResponses = {
    200: NotNestedPlace;
};

export type WebhooksCronPlaceCreateResponse = WebhooksCronPlaceCreateResponses[keyof WebhooksCronPlaceCreateResponses];

export type WebhooksCronStructureCreateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/webhooks/cron/structure/';
};

export type WebhooksCronStructureCreateResponses = {
    200: ReadonlyStructure;
};

export type WebhooksCronStructureCreateResponse = WebhooksCronStructureCreateResponses[keyof WebhooksCronStructureCreateResponses];
